var pakke_shop_json_array ={
  "shop": [
    {
      "Number": "96101",
      "CompanyName": "Dagli´Brugsen Brydes Allé",
      "Streetname": "Brydes Alle 34",
      "Streetname2": "Pakkeshop: 96101",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5968",
      "Latitude": "55.659"
    },
    {
      "Number": "97633",
      "CompanyName": "Grøndals Boghandel",
      "Streetname": "Godthåbsvej 250",
      "Streetname2": "Pakkeshop: 97633",
      "ZipCode": "2720",
      "CityName": "Vanløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.511",
      "Latitude": "55.6944"
    },
    {
      "Number": "97639",
      "CompanyName": "Min Købmand",
      "Streetname": "Øsby Kirkevej 14",
      "Streetname2": "Pakkeshop: 97639",
      "ZipCode": "6100",
      "CityName": "Haderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.64331",
      "Latitude": "55.2512"
    },
    {
      "Number": "96597",
      "CompanyName": "Vedbæk Kiosk",
      "Streetname": "Vedbæk Stationsvej 14",
      "Streetname2": "Pakkeshop: 96597",
      "ZipCode": "2950",
      "CityName": "Vedbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5646",
      "Latitude": "55.8534"
    },
    {
      "Number": "96535",
      "CompanyName": "Go´on Frederikssund",
      "Streetname": "Heimdalsvej 7",
      "Streetname2": "Pakkeshop: 96535",
      "ZipCode": "3600",
      "CityName": "Frederikssund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0596",
      "Latitude": "55.8472"
    },
    {
      "Number": "96783",
      "CompanyName": "OK Plus hvidovre",
      "Streetname": "Rebæk Søpark 4",
      "Streetname2": "Pakkeshop: 96783",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4565",
      "Latitude": "55.6632"
    },
    {
      "Number": "96028",
      "CompanyName": "City Kiosken",
      "Streetname": "Stationsvej 36",
      "Streetname2": "Pakkeshop: 96028",
      "ZipCode": "5500",
      "CityName": "Middelfart",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.73344",
      "Latitude": "55.5021"
    },
    {
      "Number": "96104",
      "CompanyName": "Dagli´Brugsen Tranegården",
      "Streetname": "Brøndbyvestervej 18",
      "Streetname2": "Pakkeshop: 96104",
      "ZipCode": "2600",
      "CityName": "Glostrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4065",
      "Latitude": "55.6595"
    },
    {
      "Number": "96534",
      "CompanyName": "OK Plus Linde Allé",
      "Streetname": "Linde Allé 11",
      "Streetname2": "Pakkeshop: 96534",
      "ZipCode": "2720",
      "CityName": "Vanløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4916",
      "Latitude": "55.6827"
    },
    {
      "Number": "96899",
      "CompanyName": "Min Købmand Skarrild",
      "Streetname": "Hovedgaden 47",
      "Streetname2": "Pakkeshop: 96899",
      "ZipCode": "6933",
      "CityName": "Kibæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.89791",
      "Latitude": "55.9779"
    },
    {
      "Number": "96699",
      "CompanyName": "Rødekro Boghandel",
      "Streetname": "Østergade 3",
      "Streetname2": "Pakkeshop: 96699",
      "ZipCode": "6230",
      "CityName": "Rødekro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.33724",
      "Latitude": "55.0701"
    },
    {
      "Number": "96223",
      "CompanyName": "Dagli´Brugsen Horslunde",
      "Streetname": "Nylandsvej 12",
      "Streetname2": "Pakkeshop: 96223",
      "ZipCode": "4913",
      "CityName": "Horslunde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2219",
      "Latitude": "54.9145"
    },
    {
      "Number": "96314",
      "CompanyName": "Grønlunds Kiosk",
      "Streetname": "Nr Alslev Langgade 41",
      "Streetname2": "Pakkeshop: 96314",
      "ZipCode": "4840",
      "CityName": "Nørre Alslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8808",
      "Latitude": "54.8977"
    },
    {
      "Number": "96320",
      "CompanyName": "Eurospar Store Heddinge",
      "Streetname": "Østergade 7",
      "Streetname2": "Pakkeshop: 96320",
      "ZipCode": "4660",
      "CityName": "Store Heddinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.39",
      "Latitude": "55.3096"
    },
    {
      "Number": "96326",
      "CompanyName": "Bladkiosken",
      "Streetname": "Gaabensevej 72",
      "Streetname2": "Pakkeshop: 96326",
      "ZipCode": "4800",
      "CityName": "Nykøbing F",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8671",
      "Latitude": "54.7781"
    },
    {
      "Number": "96237",
      "CompanyName": "Dagli´Brugsen Skærbæk",
      "Streetname": "Overmarken 2",
      "Streetname2": "Pakkeshop: 96237",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.63215",
      "Latitude": "55.5201"
    },
    {
      "Number": "96542",
      "CompanyName": "Min Købmand",
      "Streetname": "Marstrup Bygade 125",
      "Streetname2": "Pakkeshop: 96542",
      "ZipCode": "6100",
      "CityName": "Haderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.44182",
      "Latitude": "55.2081"
    },
    {
      "Number": "97515",
      "CompanyName": "Dagli´Brugsen Hviding",
      "Streetname": "Ribevej 64",
      "Streetname2": "Pakkeshop: 97515",
      "ZipCode": "6760",
      "CityName": "Ribe",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.72928",
      "Latitude": "55.2765"
    },
    {
      "Number": "97667",
      "CompanyName": "Elite Købmand",
      "Streetname": "Slagelsegade 14, st",
      "Streetname2": "Pakkeshop: 97667",
      "ZipCode": "2100",
      "CityName": "København ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5801",
      "Latitude": "55.6983"
    },
    {
      "Number": "96186",
      "CompanyName": "Dagli´Brugsen Sønderho",
      "Streetname": "Landevejen 42",
      "Streetname2": "Pakkeshop: 96186",
      "ZipCode": "6720",
      "CityName": "Fanø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.47017",
      "Latitude": "55.3485"
    },
    {
      "Number": "96188",
      "CompanyName": "Holbøl Og Omegns Brugsforening",
      "Streetname": "Kelstrupgårdvej 1",
      "Streetname2": "Pakkeshop: 96188",
      "ZipCode": "6340",
      "CityName": "Kruså",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.44033",
      "Latitude": "54.893"
    },
    {
      "Number": "96189",
      "CompanyName": "LokalBrugsen Ravsted",
      "Streetname": "Ravsted Hovedgade 77",
      "Streetname2": "Pakkeshop: 96189",
      "ZipCode": "6372",
      "CityName": "Bylderup-Bov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.12524",
      "Latitude": "55.0087"
    },
    {
      "Number": "96193",
      "CompanyName": "SuperBrugsen Egtved",
      "Streetname": "Kirkevej 20",
      "Streetname2": "Pakkeshop: 96193",
      "ZipCode": "6040",
      "CityName": "Egtved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.30305",
      "Latitude": "55.6187"
    },
    {
      "Number": "96229",
      "CompanyName": "Dagli´Brugsen Uvelse",
      "Streetname": "Uvelse Byvej 1",
      "Streetname2": "Pakkeshop: 96229",
      "ZipCode": "3550",
      "CityName": "Slangerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2375",
      "Latitude": "55.8668"
    },
    {
      "Number": "96200",
      "CompanyName": "SuperBrugsen Lunderskov",
      "Streetname": "Iver Dahlsvej 6",
      "Streetname2": "Pakkeshop: 96200",
      "ZipCode": "6640",
      "CityName": "Lunderskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.29835",
      "Latitude": "55.4802"
    },
    {
      "Number": "96206",
      "CompanyName": "SuperBrugsen Augustenborg",
      "Streetname": "Stadionvej 1",
      "Streetname2": "Pakkeshop: 96206",
      "ZipCode": "6440",
      "CityName": "Augustenborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.87609",
      "Latitude": "54.9502"
    },
    {
      "Number": "96207",
      "CompanyName": "Dagli´Brugsen Nybøl",
      "Streetname": "Amtsvejen 46",
      "Streetname2": "Pakkeshop: 96207",
      "ZipCode": "6400",
      "CityName": "Sønderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.68192",
      "Latitude": "54.9199"
    },
    {
      "Number": "96215",
      "CompanyName": "Dagli´Brugsen Horne",
      "Streetname": "Hornelund 17",
      "Streetname2": "Pakkeshop: 96215",
      "ZipCode": "6800",
      "CityName": "Varde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.53218",
      "Latitude": "55.7246"
    },
    {
      "Number": "96698",
      "CompanyName": "Uno-X Extra Vildbjerg",
      "Streetname": "Vestergade 35",
      "Streetname2": "Pakkeshop: 96698",
      "ZipCode": "7480",
      "CityName": "Vildbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.76363",
      "Latitude": "56.2021"
    },
    {
      "Number": "96977",
      "CompanyName": "Juelsminde Trælast",
      "Streetname": "Tofteskovvej 1",
      "Streetname2": "Pakkeshop: 96977",
      "ZipCode": "7130",
      "CityName": "Juelsminde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.98042",
      "Latitude": "55.7112"
    },
    {
      "Number": "96982",
      "CompanyName": "Tybjergs IT",
      "Streetname": "Storegade 36",
      "Streetname2": "Pakkeshop: 96982",
      "ZipCode": "6870",
      "CityName": "Ølgod",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.6214",
      "Latitude": "55.8078"
    },
    {
      "Number": "96632",
      "CompanyName": "Slagteren i Strib",
      "Streetname": "Vestergade 60",
      "Streetname2": "Pakkeshop: 96632",
      "ZipCode": "5500",
      "CityName": "Middelfart",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.76923",
      "Latitude": "55.539"
    },
    {
      "Number": "96996",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Søndergade 5",
      "Streetname2": "Pakkeshop: 96996",
      "ZipCode": "6520",
      "CityName": "Toftlund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.06412",
      "Latitude": "55.1922"
    },
    {
      "Number": "96137",
      "CompanyName": "Dagli´Brugsen Ølstrup",
      "Streetname": "Byvejen 36 B",
      "Streetname2": "Pakkeshop: 96137",
      "ZipCode": "6950",
      "CityName": "Ringkøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.4229",
      "Latitude": "56.1123"
    },
    {
      "Number": "96138",
      "CompanyName": "Dagli´Brugsen Harboøre",
      "Streetname": "Lemvigvej 5",
      "Streetname2": "Pakkeshop: 96138",
      "ZipCode": "7673",
      "CityName": "Harboøre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.17668",
      "Latitude": "56.6169"
    },
    {
      "Number": "96139",
      "CompanyName": "Dagli´Brugsen Thisted",
      "Streetname": "Refsvej 28",
      "Streetname2": "Pakkeshop: 96139",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.69637",
      "Latitude": "56.9605"
    },
    {
      "Number": "96141",
      "CompanyName": "Dagli´Brugsen Resen",
      "Streetname": "Frugtparken 1",
      "Streetname2": "Pakkeshop: 96141",
      "ZipCode": "7800",
      "CityName": "Skive",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.02784",
      "Latitude": "56.5851"
    },
    {
      "Number": "96142",
      "CompanyName": "Dagli’Brugsen Lihme",
      "Streetname": "Ålbækvej 1",
      "Streetname2": "Pakkeshop: 96142",
      "ZipCode": "7860",
      "CityName": "Spøttrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.73134",
      "Latitude": "56.6007"
    },
    {
      "Number": "96143",
      "CompanyName": "Dagli´Brugsen Nykøbing Mors",
      "Streetname": "Faaruphusevej 1",
      "Streetname2": "Pakkeshop: 96143",
      "ZipCode": "7900",
      "CityName": "Nykøbing Mors",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.83907",
      "Latitude": "56.7754"
    },
    {
      "Number": "96179",
      "CompanyName": "Dagli´Brugsen Holmsland",
      "Streetname": "Klostervej 70",
      "Streetname2": "Pakkeshop: 96179",
      "ZipCode": "6950",
      "CityName": "Ringkøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.17784",
      "Latitude": "56.1266"
    },
    {
      "Number": "97125",
      "CompanyName": "Min Købmand Vrøgum",
      "Streetname": "Fiilsøvej 2",
      "Streetname2": "Pakkeshop: 97125",
      "ZipCode": "6840",
      "CityName": "Oksbøl",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.2907",
      "Latitude": "55.6555"
    },
    {
      "Number": "96763",
      "CompanyName": "Dagli´Brugsen Mejlby",
      "Streetname": "Mejlbyvej 685",
      "Streetname2": "Pakkeshop: 96763",
      "ZipCode": "8530",
      "CityName": "Hjortshøj",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2123",
      "Latitude": "56.3014"
    },
    {
      "Number": "96688",
      "CompanyName": "Mercur Kiosken",
      "Streetname": "Viby Centret 22",
      "Streetname2": "Pakkeshop: 96688",
      "ZipCode": "8260",
      "CityName": "Viby J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1607",
      "Latitude": "56.1301"
    },
    {
      "Number": "96097",
      "CompanyName": "Sadolin Farveland",
      "Streetname": "Lystrupvej 238",
      "Streetname2": "Pakkeshop: 96097",
      "ZipCode": "8520",
      "CityName": "Lystrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2319",
      "Latitude": "56.2316"
    },
    {
      "Number": "96159",
      "CompanyName": "Dagli´Brugsen Fuglebakken",
      "Streetname": "Spættevej 16",
      "Streetname2": "Pakkeshop: 96159",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.56672",
      "Latitude": "56.1687"
    },
    {
      "Number": "96160",
      "CompanyName": "Dagli´Brugsen Kragelund",
      "Streetname": "Engesvangvej 9",
      "Streetname2": "Pakkeshop: 96160",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.40918",
      "Latitude": "56.1947"
    },
    {
      "Number": "96161",
      "CompanyName": "Dagli´Brugsen Voel",
      "Streetname": "Hjaltesvej 2",
      "Streetname2": "Pakkeshop: 96161",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.69226",
      "Latitude": "56.1903"
    },
    {
      "Number": "96162",
      "CompanyName": "Dagli´Brugsen Viborg",
      "Streetname": "Gammel Ålborgvej 72",
      "Streetname2": "Pakkeshop: 96162",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.41626",
      "Latitude": "56.4648"
    },
    {
      "Number": "96163",
      "CompanyName": "Dagli´Brugsen Stevnstrup",
      "Streetname": "Grenstenvej 1",
      "Streetname2": "Pakkeshop: 96163",
      "ZipCode": "8870",
      "CityName": "Langå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94536",
      "Latitude": "56.4329"
    },
    {
      "Number": "96185",
      "CompanyName": "Dagli´Brugsen Råby",
      "Streetname": "Ved Dammen 31",
      "Streetname2": "Pakkeshop: 96185",
      "ZipCode": "8970",
      "CityName": "Havndal",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2293",
      "Latitude": "56.6085"
    },
    {
      "Number": "96232",
      "CompanyName": "Dagli´Brugsen Guldborg",
      "Streetname": "Guldborgvej 189G",
      "Streetname2": "Pakkeshop: 96232",
      "ZipCode": "4862",
      "CityName": "Guldborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7415",
      "Latitude": "54.869"
    },
    {
      "Number": "96591",
      "CompanyName": "Nexø Boghandel",
      "Streetname": "Torvet 1",
      "Streetname2": "Pakkeshop: 96591",
      "ZipCode": "3730",
      "CityName": "Nexø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "15.1325",
      "Latitude": "55.0627"
    },
    {
      "Number": "96228",
      "CompanyName": "SuperBrugsen Beder",
      "Streetname": "Kirkebakken 4",
      "Streetname2": "Pakkeshop: 96228",
      "ZipCode": "8330",
      "CityName": "Beder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2053",
      "Latitude": "56.0588"
    },
    {
      "Number": "96341",
      "CompanyName": "Kristrup Døgner",
      "Streetname": "Valdemarsvej 2, st.",
      "Streetname2": "Pakkeshop: 96341",
      "ZipCode": "8960",
      "CityName": "Randers SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0549",
      "Latitude": "56.4473"
    },
    {
      "Number": "97518",
      "CompanyName": "Dagli´Brugsen Brenderup",
      "Streetname": "Stationsvej 22",
      "Streetname2": "Pakkeshop: 97518",
      "ZipCode": "5464",
      "CityName": "Brenderup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.96931",
      "Latitude": "55.4904"
    },
    {
      "Number": "96892",
      "CompanyName": "Shell Gråsten",
      "Streetname": "Kongevej 86",
      "Streetname2": "Pakkeshop: 96892",
      "ZipCode": "6300",
      "CityName": "Gråsten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.59308",
      "Latitude": "54.919"
    },
    {
      "Number": "96355",
      "CompanyName": "Carlsro Super",
      "Streetname": "Tårnvej 209",
      "Streetname2": "Pakkeshop: 96355",
      "ZipCode": "2610",
      "CityName": "Rødovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4518",
      "Latitude": "55.6814"
    },
    {
      "Number": "96366",
      "CompanyName": "Statoil Nørre Snede",
      "Streetname": "Horsensvej 1",
      "Streetname2": "Pakkeshop: 96366",
      "ZipCode": "8766",
      "CityName": "Nørre Snede",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.39457",
      "Latitude": "55.9645"
    },
    {
      "Number": "96065",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Langeskov-Centret 3",
      "Streetname2": "Pakkeshop: 96065",
      "ZipCode": "5550",
      "CityName": "Langeskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.59",
      "Latitude": "55.3604"
    },
    {
      "Number": "96378",
      "CompanyName": "Netkiosken.dk",
      "Streetname": "Kayerødsgade 6",
      "Streetname2": "Pakkeshop: 96378",
      "ZipCode": "9000",
      "CityName": "Ålborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92422",
      "Latitude": "57.0448"
    },
    {
      "Number": "96667",
      "CompanyName": "Skjold Burne",
      "Streetname": "Hjallesevej 6",
      "Streetname2": "Pakkeshop: 96667",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.397",
      "Latitude": "55.3914"
    },
    {
      "Number": "96887",
      "CompanyName": "Click Grønlund Foto",
      "Streetname": "Østerbrogade 134",
      "Streetname2": "Pakkeshop: 96887",
      "ZipCode": "2100",
      "CityName": "København Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5777",
      "Latitude": "55.7065"
    },
    {
      "Number": "96850",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Søndergade 1",
      "Streetname2": "Pakkeshop: 96850",
      "ZipCode": "4990",
      "CityName": "Sakskøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6361",
      "Latitude": "54.7993"
    },
    {
      "Number": "96851",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Vestergade 2B",
      "Streetname2": "Pakkeshop: 96851",
      "ZipCode": "4690",
      "CityName": "Haslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.963",
      "Latitude": "55.3271"
    },
    {
      "Number": "96852",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Storegade 12",
      "Streetname2": "Pakkeshop: 96852",
      "ZipCode": "4780",
      "CityName": "Stege",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.284",
      "Latitude": "54.9832"
    },
    {
      "Number": "96311",
      "CompanyName": "Kwik Spar",
      "Streetname": "Krügersvej 38",
      "Streetname2": "Pakkeshop: 96311",
      "ZipCode": "6541",
      "CityName": "Bevtoft",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.20634",
      "Latitude": "55.1997"
    },
    {
      "Number": "96183",
      "CompanyName": "Dagli´Brugsen Rødding",
      "Streetname": "Borgergade 19",
      "Streetname2": "Pakkeshop: 96183",
      "ZipCode": "7860",
      "CityName": "Spøttrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.809",
      "Latitude": "56.6454"
    },
    {
      "Number": "96187",
      "CompanyName": "SuperBrugsen Ans",
      "Streetname": "Søndermarksgade 16",
      "Streetname2": "Pakkeshop: 96187",
      "ZipCode": "8643",
      "CityName": "Ans By",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.59412",
      "Latitude": "56.3055"
    },
    {
      "Number": "96309",
      "CompanyName": "Min købmand",
      "Streetname": "Borgergade 1",
      "Streetname2": "Pakkeshop: 96309",
      "ZipCode": "9740",
      "CityName": "Jerslev J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0919",
      "Latitude": "57.2849"
    },
    {
      "Number": "96342",
      "CompanyName": "Svends Kiosk",
      "Streetname": "Nørregade 62",
      "Streetname2": "Pakkeshop: 96342",
      "ZipCode": "6600",
      "CityName": "Vejen",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.13952",
      "Latitude": "55.4794"
    },
    {
      "Number": "97029",
      "CompanyName": "Arriva",
      "Streetname": "Banegårdspladsen 2",
      "Streetname2": "Pakkeshop: 97029",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.39839",
      "Latitude": "56.4474"
    },
    {
      "Number": "96657",
      "CompanyName": "Vesterbro Kiosk",
      "Streetname": "Vesterbro Torv 8",
      "Streetname2": "Pakkeshop: 96657",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1989",
      "Latitude": "56.1583"
    },
    {
      "Number": "97640",
      "CompanyName": "Min Købmand Vejrup",
      "Streetname": "Vejrup Storegade 34",
      "Streetname2": "Pakkeshop: 97640",
      "ZipCode": "6740",
      "CityName": "Bramming",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.78359",
      "Latitude": "55.5211"
    },
    {
      "Number": "96281",
      "CompanyName": "LokalBrugsen Veflinge",
      "Streetname": "Bystævnet 12",
      "Streetname2": "Pakkeshop: 96281",
      "ZipCode": "5474",
      "CityName": "Veflinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1584",
      "Latitude": "55.4757"
    },
    {
      "Number": "96738",
      "CompanyName": "OK Plus Sløsse",
      "Streetname": "Holebyvej 56",
      "Streetname2": "Pakkeshop: 96738",
      "ZipCode": "4894",
      "CityName": "Øster Ulslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.598",
      "Latitude": "54.6985"
    },
    {
      "Number": "97219",
      "CompanyName": "OK Plus Tølløse",
      "Streetname": "Kvarmløsevej 56",
      "Streetname2": "Pakkeshop: 97219",
      "ZipCode": "4340",
      "CityName": "Tølløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7842",
      "Latitude": "55.6134"
    },
    {
      "Number": "97397",
      "CompanyName": "Super spar Humlum",
      "Streetname": "Vesterbrogade 2",
      "Streetname2": "Pakkeshop: 97397",
      "ZipCode": "7600",
      "CityName": "Struer",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.55155",
      "Latitude": "56.5396"
    },
    {
      "Number": "96758",
      "CompanyName": "Min Købmand",
      "Streetname": "Priorgade 17",
      "Streetname2": "Pakkeshop: 96758",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3558",
      "Latitude": "55.3981"
    },
    {
      "Number": "96765",
      "CompanyName": "Shell 7-Eleven Næstved",
      "Streetname": "Odensevej 102",
      "Streetname2": "Pakkeshop: 96765",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7603",
      "Latitude": "55.2134"
    },
    {
      "Number": "96877",
      "CompanyName": "Click",
      "Streetname": "Algade 27",
      "Streetname2": "Pakkeshop: 96877",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0855",
      "Latitude": "55.6412"
    },
    {
      "Number": "96768",
      "CompanyName": "SuperBrugsen Skælskør",
      "Streetname": "Carl Medingsvej 22",
      "Streetname2": "Pakkeshop: 96768",
      "ZipCode": "4230",
      "CityName": "Skælskør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.297",
      "Latitude": "55.2531"
    },
    {
      "Number": "96771",
      "CompanyName": "Min Købmand Helsinge",
      "Streetname": "Søndergade 10",
      "Streetname2": "Pakkeshop: 96771",
      "ZipCode": "4281",
      "CityName": "Gørlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2067",
      "Latitude": "55.5155"
    },
    {
      "Number": "96772",
      "CompanyName": "Min Købmand",
      "Streetname": "Drøsselbjergvej 106",
      "Streetname2": "Pakkeshop: 96772",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2095",
      "Latitude": "55.4429"
    },
    {
      "Number": "96236",
      "CompanyName": "Dagli´Brugsen Vester Hæsinger",
      "Streetname": "Birkevej 57",
      "Streetname2": "Pakkeshop: 96236",
      "ZipCode": "5672",
      "CityName": "Broby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2484",
      "Latitude": "55.1965"
    },
    {
      "Number": "96629",
      "CompanyName": "Pak & Send",
      "Streetname": "Ulrikkenborg Plads 1",
      "Streetname2": "Pakkeshop: 96629",
      "ZipCode": "2800",
      "CityName": "Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5022",
      "Latitude": "55.7677"
    },
    {
      "Number": "96332",
      "CompanyName": "OK Plus Lyne",
      "Streetname": "Vardevej 117",
      "Streetname2": "Pakkeshop: 96332",
      "ZipCode": "6880",
      "CityName": "Tarm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.49222",
      "Latitude": "55.7994"
    },
    {
      "Number": "96376",
      "CompanyName": "Netkiosken.dk",
      "Streetname": "Kastetvej 55",
      "Streetname2": "Pakkeshop: 96376",
      "ZipCode": "9000",
      "CityName": "Ålborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.90255",
      "Latitude": "57.0538"
    },
    {
      "Number": "96871",
      "CompanyName": "Spillecafé Vinderhjørnet",
      "Streetname": "Dybbølsgade 41",
      "Streetname2": "Pakkeshop: 96871",
      "ZipCode": "1721",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5513",
      "Latitude": "55.6665"
    },
    {
      "Number": "97650",
      "CompanyName": "Statoil Københavnsvej",
      "Streetname": "Københavnsvej 13",
      "Streetname2": "Pakkeshop: 97650",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0968",
      "Latitude": "55.641"
    },
    {
      "Number": "97651",
      "CompanyName": "Elextra - Brinck Elektronik",
      "Streetname": "Frederiksborggade 42",
      "Streetname2": "Pakkeshop: 97651",
      "ZipCode": "1360",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5677",
      "Latitude": "55.6854"
    },
    {
      "Number": "97654",
      "CompanyName": "Statoil Rundkørslen",
      "Streetname": "Frederiksborgvej 45",
      "Streetname2": "Pakkeshop: 97654",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0846",
      "Latitude": "55.6504"
    },
    {
      "Number": "96042",
      "CompanyName": "Ejby Boghandel",
      "Streetname": "Algade 10",
      "Streetname2": "Pakkeshop: 96042",
      "ZipCode": "5592",
      "CityName": "Ejby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92808",
      "Latitude": "55.429"
    },
    {
      "Number": "96635",
      "CompanyName": "Kiosk, Vin & Gaveshop",
      "Streetname": "Torvegade 13",
      "Streetname2": "Pakkeshop: 96635",
      "ZipCode": "6510",
      "CityName": "Gram",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.04857",
      "Latitude": "55.2888"
    },
    {
      "Number": "96633",
      "CompanyName": "Spar Bindslev",
      "Streetname": "Sønderbro 12",
      "Streetname2": "Pakkeshop: 96633",
      "ZipCode": "9881",
      "CityName": "Bindslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1971",
      "Latitude": "57.5388"
    },
    {
      "Number": "96656",
      "CompanyName": "Øbro Kiosken",
      "Streetname": "Østerbrogade 73",
      "Streetname2": "Pakkeshop: 96656",
      "ZipCode": "9400",
      "CityName": "Nørresundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.9267",
      "Latitude": "57.0579"
    },
    {
      "Number": "96561",
      "CompanyName": "Præstø Boghandel",
      "Streetname": "Adelgade 56",
      "Streetname2": "Pakkeshop: 96561",
      "ZipCode": "4720",
      "CityName": "Præstø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0408",
      "Latitude": "55.1216"
    },
    {
      "Number": "96191",
      "CompanyName": "Dagli´Brugsen Frøslev",
      "Streetname": "Elsøvej 208",
      "Streetname2": "Pakkeshop: 96191",
      "ZipCode": "7900",
      "CityName": "Nykøbing M",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.73523",
      "Latitude": "56.8025"
    },
    {
      "Number": "97642",
      "CompanyName": "Søndergaards Tips & Lotto",
      "Streetname": "Bagsværd Hovedgade 43 D",
      "Streetname2": "Pakkeshop: 97642",
      "ZipCode": "2880",
      "CityName": "Bagsværd",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4602",
      "Latitude": "55.7573"
    },
    {
      "Number": "97517",
      "CompanyName": "Kvickly Haderslev",
      "Streetname": "Jomfrustien 40",
      "Streetname2": "Pakkeshop: 97517",
      "ZipCode": "6100",
      "CityName": "Haderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.49703",
      "Latitude": "55.2509"
    },
    {
      "Number": "97628",
      "CompanyName": "Min Købmand Virring",
      "Streetname": "Gadebakken 36",
      "Streetname2": "Pakkeshop: 97628",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0336",
      "Latitude": "56.0302"
    },
    {
      "Number": "96608",
      "CompanyName": "GLS Pakke Shop",
      "Streetname": "Nystedvej 33",
      "Streetname2": "Pakkeshop: 96608",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.97635",
      "Latitude": "56.1571"
    },
    {
      "Number": "96701",
      "CompanyName": "Spar Engesvang",
      "Streetname": "Gammel Kongevej 62",
      "Streetname2": "Pakkeshop: 96701",
      "ZipCode": "7442",
      "CityName": "Engesvang",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.34549",
      "Latitude": "56.1696"
    },
    {
      "Number": "96346",
      "CompanyName": "Stilling Kiosk",
      "Streetname": "Århusvej 11",
      "Streetname2": "Pakkeshop: 96346",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.98577",
      "Latitude": "56.0609"
    },
    {
      "Number": "96312",
      "CompanyName": "Statoil Råsted",
      "Streetname": "Hovedvejen 7",
      "Streetname2": "Pakkeshop: 96312",
      "ZipCode": "8920",
      "CityName": "Randers NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.9417",
      "Latitude": "56.5175"
    },
    {
      "Number": "96084",
      "CompanyName": "Cykel & Autobørsen",
      "Streetname": "Søndermarken 3",
      "Streetname2": "Pakkeshop: 96084",
      "ZipCode": "7361",
      "CityName": "Ejstrupholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.29755",
      "Latitude": "55.9819"
    },
    {
      "Number": "97113",
      "CompanyName": "RENSEmanden Herluf Trolles gade",
      "Streetname": "Herluf Trolles gade 18",
      "Streetname2": "Pakkeshop: 97113",
      "ZipCode": "1052",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5901",
      "Latitude": "55.6788"
    },
    {
      "Number": "97114",
      "CompanyName": "RENSEmanden Ndr. Frihavnsgade",
      "Streetname": "Ndr. Frihavnsgade 53",
      "Streetname2": "Pakkeshop: 97114",
      "ZipCode": "2100",
      "CityName": "København Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5835",
      "Latitude": "55.7026"
    },
    {
      "Number": "96506",
      "CompanyName": "Zap-In",
      "Streetname": "Toldbodgade 7",
      "Streetname2": "Pakkeshop: 96506",
      "ZipCode": "8900",
      "CityName": "Randers",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.046",
      "Latitude": "56.4606"
    },
    {
      "Number": "96879",
      "CompanyName": "Ebeltoft Papirhandel",
      "Streetname": "Adelgade 25",
      "Streetname2": "Pakkeshop: 96879",
      "ZipCode": "8400",
      "CityName": "Ebeltoft",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6786",
      "Latitude": "56.1992"
    },
    {
      "Number": "96374",
      "CompanyName": "Click",
      "Streetname": "M.D. Madsensvej 12 14",
      "Streetname2": "Pakkeshop: 96374",
      "ZipCode": "3450",
      "CityName": "Allerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3539",
      "Latitude": "55.8698"
    },
    {
      "Number": "96371",
      "CompanyName": "Min Købmand",
      "Streetname": "Assensvej 46",
      "Streetname2": "Pakkeshop: 96371",
      "ZipCode": "5771",
      "CityName": "Stenstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5313",
      "Latitude": "55.1142"
    },
    {
      "Number": "97028",
      "CompanyName": "Arriva",
      "Streetname": "Stationspladsen 3",
      "Streetname2": "Pakkeshop: 97028",
      "ZipCode": "6800",
      "CityName": "Varde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.48424",
      "Latitude": "55.6161"
    },
    {
      "Number": "97153",
      "CompanyName": "Statoil Måløv",
      "Streetname": "Måløv Hovedgade 3",
      "Streetname2": "Pakkeshop: 97153",
      "ZipCode": "2760",
      "CityName": "Måløv",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3237",
      "Latitude": "55.747"
    },
    {
      "Number": "96054",
      "CompanyName": "PhotoCare",
      "Streetname": "Dalumvej 42-44",
      "Streetname2": "Pakkeshop: 96054",
      "ZipCode": "5250",
      "CityName": "Odense SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3711",
      "Latitude": "55.3711"
    },
    {
      "Number": "96053",
      "CompanyName": "Hurup Døgnkiosk",
      "Streetname": "Bredgade 124",
      "Streetname2": "Pakkeshop: 96053",
      "ZipCode": "7760",
      "CityName": "Hurup Thy",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.41949",
      "Latitude": "56.7499"
    },
    {
      "Number": "96055",
      "CompanyName": "HC Bøger Og Papir",
      "Streetname": "Østergade 33",
      "Streetname2": "Pakkeshop: 96055",
      "ZipCode": "5900",
      "CityName": "Rudkøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.7142",
      "Latitude": "54.9356"
    },
    {
      "Number": "96590",
      "CompanyName": "Sørvad Cykler",
      "Streetname": "Langgade 35",
      "Streetname2": "Pakkeshop: 96590",
      "ZipCode": "7550",
      "CityName": "Sørvad",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.65229",
      "Latitude": "56.2621"
    },
    {
      "Number": "96060",
      "CompanyName": "Min Købmand Venslev",
      "Streetname": "Bygaden 22",
      "Streetname2": "Pakkeshop: 96060",
      "ZipCode": "4050",
      "CityName": "Skibby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9059",
      "Latitude": "55.7763"
    },
    {
      "Number": "96069",
      "CompanyName": "Trykkeriet Vamdrup",
      "Streetname": "Østergade 24",
      "Streetname2": "Pakkeshop: 96069",
      "ZipCode": "6580",
      "CityName": "Vamdrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.28625",
      "Latitude": "55.4249"
    },
    {
      "Number": "96396",
      "CompanyName": "Shell Ørbæk",
      "Streetname": "Hovedgaden 2",
      "Streetname2": "Pakkeshop: 96396",
      "ZipCode": "5853",
      "CityName": "Ørbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6725",
      "Latitude": "55.2579"
    },
    {
      "Number": "97024",
      "CompanyName": "Arriva",
      "Streetname": "Søndergade 16 c",
      "Streetname2": "Pakkeshop: 97024",
      "ZipCode": "7800",
      "CityName": "Skive",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.02656",
      "Latitude": "56.562"
    },
    {
      "Number": "97365",
      "CompanyName": "Eurospar Vejby",
      "Streetname": "vejby strandvej 7",
      "Streetname2": "Pakkeshop: 97365",
      "ZipCode": "3210",
      "CityName": "Vejby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1294",
      "Latitude": "56.0818"
    },
    {
      "Number": "96668",
      "CompanyName": "Kirkendrup Nærbutik",
      "Streetname": "Ærtebjerggårdvej 1",
      "Streetname2": "Pakkeshop: 96668",
      "ZipCode": "5270",
      "CityName": "Odense N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3352",
      "Latitude": "55.4305"
    },
    {
      "Number": "96558",
      "CompanyName": "OK Plus Fårvang",
      "Streetname": "Viborgvej 15",
      "Streetname2": "Pakkeshop: 96558",
      "ZipCode": "8882",
      "CityName": "Fårvang",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.71986",
      "Latitude": "56.2768"
    },
    {
      "Number": "97399",
      "CompanyName": "Spar Ydby",
      "Streetname": "Oddesundvej 267",
      "Streetname2": "Pakkeshop: 97399",
      "ZipCode": "7760",
      "CityName": "Hurup Thy",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.41305",
      "Latitude": "56.7086"
    },
    {
      "Number": "96785",
      "CompanyName": "OK Plus Brøndby Strand",
      "Streetname": "Gammel Køge Landevej 722",
      "Streetname2": "Pakkeshop: 96785",
      "ZipCode": "2660",
      "CityName": "Brøndby Strand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.418",
      "Latitude": "55.618"
    },
    {
      "Number": "96021",
      "CompanyName": "Complet Kiosken",
      "Streetname": "Axeltorv 13",
      "Streetname2": "Pakkeshop: 96021",
      "ZipCode": "4900",
      "CityName": "Nakskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.1349",
      "Latitude": "54.8303"
    },
    {
      "Number": "96106",
      "CompanyName": "Dagli´Brugsen Hjortekær",
      "Streetname": "Bjælkevangen 63-65",
      "Streetname2": "Pakkeshop: 96106",
      "ZipCode": "2800",
      "CityName": "Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5369",
      "Latitude": "55.794"
    },
    {
      "Number": "97359",
      "CompanyName": "Shell/7-Eleven Frederikssund",
      "Streetname": "Ny Østergade 12",
      "Streetname2": "Pakkeshop: 97359",
      "ZipCode": "3600",
      "CityName": "Frederikssund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0653",
      "Latitude": "55.8403"
    },
    {
      "Number": "96061",
      "CompanyName": "City Kiosken",
      "Streetname": "Bredgade 62",
      "Streetname2": "Pakkeshop: 96061",
      "ZipCode": "8340",
      "CityName": "Malling",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1934",
      "Latitude": "56.0382"
    },
    {
      "Number": "97644",
      "CompanyName": "Statoil Buen",
      "Streetname": "Buen 13",
      "Streetname2": "Pakkeshop: 97644",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.48081",
      "Latitude": "55.4878"
    },
    {
      "Number": "96263",
      "CompanyName": "Dagli´Brugsen Gylling",
      "Streetname": "Hovedgaden 40",
      "Streetname2": "Pakkeshop: 96263",
      "ZipCode": "8300",
      "CityName": "Odder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.167",
      "Latitude": "55.8927"
    },
    {
      "Number": "96665",
      "CompanyName": "Go´On Benzin",
      "Streetname": "Tangsøgade 92",
      "Streetname2": "Pakkeshop: 96665",
      "ZipCode": "7650",
      "CityName": "Bøvlingebjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.19704",
      "Latitude": "56.439"
    },
    {
      "Number": "96074",
      "CompanyName": "Spar Ø. Brønderslev",
      "Streetname": "Elmevej 62",
      "Streetname2": "Pakkeshop: 96074",
      "ZipCode": "9700",
      "CityName": "Brønderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.99718",
      "Latitude": "57.2488"
    },
    {
      "Number": "96788",
      "CompanyName": "OK Plus Ortved",
      "Streetname": "Roskildevej 398",
      "Streetname2": "Pakkeshop: 96788",
      "ZipCode": "4100",
      "CityName": "Ringsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8505",
      "Latitude": "55.4849"
    },
    {
      "Number": "97134",
      "CompanyName": "Go´on Hadsund",
      "Streetname": "Kystvejen 10",
      "Streetname2": "Pakkeshop: 97134",
      "ZipCode": "9560",
      "CityName": "Hadsund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2702",
      "Latitude": "56.8083"
    },
    {
      "Number": "96905",
      "CompanyName": "Tureby Tanken",
      "Streetname": "Vordingborgvej 336",
      "Streetname2": "Pakkeshop: 96905",
      "ZipCode": "4682",
      "CityName": "Tureby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0843",
      "Latitude": "55.3642"
    },
    {
      "Number": "96898",
      "CompanyName": "Sadolin Farveland",
      "Streetname": "Viborgvej 142",
      "Streetname2": "Pakkeshop: 96898",
      "ZipCode": "8210",
      "CityName": "Århus V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1635",
      "Latitude": "56.1679"
    },
    {
      "Number": "96933",
      "CompanyName": "Døgn Kiosken",
      "Streetname": "Volmersgade 21",
      "Streetname2": "Pakkeshop: 96933",
      "ZipCode": "4760",
      "CityName": "Vordingborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8959",
      "Latitude": "54.9995"
    },
    {
      "Number": "96502",
      "CompanyName": "Zap-In",
      "Streetname": "Sønderbrogade 27-29",
      "Streetname2": "Pakkeshop: 96502",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.84279",
      "Latitude": "55.859"
    },
    {
      "Number": "96503",
      "CompanyName": "Zap-In",
      "Streetname": "Sjællandsgade 12",
      "Streetname2": "Pakkeshop: 96503",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.53941",
      "Latitude": "55.7046"
    },
    {
      "Number": "96606",
      "CompanyName": "GLS Pakke Shop",
      "Streetname": "Kokmose 3",
      "Streetname2": "Pakkeshop: 96606",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.47953",
      "Latitude": "55.5346"
    },
    {
      "Number": "96098",
      "CompanyName": "Shell Skave",
      "Streetname": "Viborgvej 240",
      "Streetname2": "Pakkeshop: 96098",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.80513",
      "Latitude": "56.3904"
    },
    {
      "Number": "96723",
      "CompanyName": "OK Plus Christiansfeld",
      "Streetname": "Haderslevvej 22",
      "Streetname2": "Pakkeshop: 96723",
      "ZipCode": "6070",
      "CityName": "Christiansfeld",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.48454",
      "Latitude": "55.3491"
    },
    {
      "Number": "96277",
      "CompanyName": "Dagli´Brugsen Sønder Felding",
      "Streetname": "Bredgade 22",
      "Streetname2": "Pakkeshop: 96277",
      "ZipCode": "7280",
      "CityName": "Sønder Felding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.7831",
      "Latitude": "55.941"
    },
    {
      "Number": "96766",
      "CompanyName": "Stationskiosken",
      "Streetname": "Storegade 40",
      "Streetname2": "Pakkeshop: 96766",
      "ZipCode": "6670",
      "CityName": "Holsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.91126",
      "Latitude": "55.482"
    },
    {
      "Number": "96778",
      "CompanyName": "Min Købmand",
      "Streetname": "Storegade 2",
      "Streetname2": "Pakkeshop: 96778",
      "ZipCode": "6560",
      "CityName": "Sommersted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.31018",
      "Latitude": "55.3213"
    },
    {
      "Number": "96398",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Markedsgade 23",
      "Streetname2": "Pakkeshop: 96398",
      "ZipCode": "6240",
      "CityName": "Løgumkloster",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.95082",
      "Latitude": "55.0595"
    },
    {
      "Number": "96049",
      "CompanyName": "Min Købmand Lyderslev",
      "Streetname": "Lyderslev Bygade 6",
      "Streetname2": "Pakkeshop: 96049",
      "ZipCode": "4660",
      "CityName": "Store Heddinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2955",
      "Latitude": "55.2741"
    },
    {
      "Number": "96649",
      "CompanyName": "Drugstore",
      "Streetname": "Mikkel Bryggers Gade 10",
      "Streetname2": "Pakkeshop: 96649",
      "ZipCode": "1460",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5714",
      "Latitude": "55.6763"
    },
    {
      "Number": "96648",
      "CompanyName": "Julle´s Kiosk",
      "Streetname": "Hovedgaden 33",
      "Streetname2": "Pakkeshop: 96648",
      "ZipCode": "8961",
      "CityName": "Allingåbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.328",
      "Latitude": "56.4636"
    },
    {
      "Number": "96508",
      "CompanyName": "Zap-In",
      "Streetname": "Håndværkervej 1",
      "Streetname2": "Pakkeshop: 96508",
      "ZipCode": "9000",
      "CityName": "Ålborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92728",
      "Latitude": "57.0377"
    },
    {
      "Number": "96234",
      "CompanyName": "Dagli´Brugsen Egebjerg",
      "Streetname": "Egebjerg Hovedgade 9",
      "Streetname2": "Pakkeshop: 96234",
      "ZipCode": "4500",
      "CityName": "Nykøbing Sjælland",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6794",
      "Latitude": "55.8443"
    },
    {
      "Number": "96230",
      "CompanyName": "Dagli´Brugsen Hillerslev",
      "Streetname": "Ballerumvej 113",
      "Streetname2": "Pakkeshop: 96230",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.72718",
      "Latitude": "57.0113"
    },
    {
      "Number": "96231",
      "CompanyName": "Dagli´Brugsen Bjergby",
      "Streetname": "Skagen Landevej 93",
      "Streetname2": "Pakkeshop: 96231",
      "ZipCode": "9800",
      "CityName": "Hjørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0242",
      "Latitude": "57.5133"
    },
    {
      "Number": "96521",
      "CompanyName": "Årup Boghandel",
      "Streetname": "Bredgade 34",
      "Streetname2": "Pakkeshop: 96521",
      "ZipCode": "5560",
      "CityName": "Aarup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0485",
      "Latitude": "55.3803"
    },
    {
      "Number": "96048",
      "CompanyName": "Statoil Støvring",
      "Streetname": "Hobrovej 58",
      "Streetname2": "Pakkeshop: 96048",
      "ZipCode": "9530",
      "CityName": "Støvring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.83689",
      "Latitude": "56.8938"
    },
    {
      "Number": "96080",
      "CompanyName": "Tanken",
      "Streetname": "Amtsvejen 64",
      "Streetname2": "Pakkeshop: 96080",
      "ZipCode": "3390",
      "CityName": "Hundested",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8577",
      "Latitude": "55.9631"
    },
    {
      "Number": "96241",
      "CompanyName": "Dagli´Brugsen Frem Arnborg",
      "Streetname": "Greenvej 1",
      "Streetname2": "Pakkeshop: 96241",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.9933",
      "Latitude": "56.0142"
    },
    {
      "Number": "96227",
      "CompanyName": "Dagli´Brugsen Hellested",
      "Streetname": "Bygaden 18",
      "Streetname2": "Pakkeshop: 96227",
      "ZipCode": "4652",
      "CityName": "Hårlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2467",
      "Latitude": "55.3287"
    },
    {
      "Number": "96235",
      "CompanyName": "Dagli´Brugsen Sandager",
      "Streetname": "Torupvej 1",
      "Streetname2": "Pakkeshop: 96235",
      "ZipCode": "5610",
      "CityName": "Assens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.93589",
      "Latitude": "55.3267"
    },
    {
      "Number": "96380",
      "CompanyName": "Click",
      "Streetname": "Torvet 9",
      "Streetname2": "Pakkeshop: 96380",
      "ZipCode": "7620",
      "CityName": "Lemvig",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.30923",
      "Latitude": "56.5497"
    },
    {
      "Number": "96184",
      "CompanyName": "Dagli´Brugsen Asperup",
      "Streetname": "Byvejen 38",
      "Streetname2": "Pakkeshop: 96184",
      "ZipCode": "5466",
      "CityName": "Asperup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.90921",
      "Latitude": "55.4896"
    },
    {
      "Number": "96841",
      "CompanyName": "Tanken Skodborg",
      "Streetname": "Træskodal 2",
      "Streetname2": "Pakkeshop: 96841",
      "ZipCode": "6630",
      "CityName": "Rødding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.15094",
      "Latitude": "55.4243"
    },
    {
      "Number": "96313",
      "CompanyName": "Tårs Døgnbutik",
      "Streetname": "Bredgade 73",
      "Streetname2": "Pakkeshop: 96313",
      "ZipCode": "9830",
      "CityName": "Tårs",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1134",
      "Latitude": "57.3861"
    },
    {
      "Number": "96318",
      "CompanyName": "Sæby Nærkøb",
      "Streetname": "Frederikshavnsvej 23",
      "Streetname2": "Pakkeshop: 96318",
      "ZipCode": "9300",
      "CityName": "Sæby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5195",
      "Latitude": "57.3383"
    },
    {
      "Number": "96552",
      "CompanyName": "OK Plus Bandholm",
      "Streetname": "Havnegade 1",
      "Streetname2": "Pakkeshop: 96552",
      "ZipCode": "4941",
      "CityName": "Bandholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4825",
      "Latitude": "54.8338"
    },
    {
      "Number": "96612",
      "CompanyName": "GLS Pakke Shop",
      "Streetname": "Hedelund 6",
      "Streetname2": "Pakkeshop: 96612",
      "ZipCode": "9400",
      "CityName": "Nørresundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.96612",
      "Latitude": "57.0896"
    },
    {
      "Number": "96095",
      "CompanyName": "Vesterports Kiosk",
      "Streetname": "Vestergade 68",
      "Streetname2": "Pakkeshop: 96095",
      "ZipCode": "8900",
      "CityName": "Randers",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.023",
      "Latitude": "56.4624"
    },
    {
      "Number": "96954",
      "CompanyName": "Nærkøb",
      "Streetname": "Forbindelsesvejen 115",
      "Streetname2": "Pakkeshop: 96954",
      "ZipCode": "9400",
      "CityName": "Nørresundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.93499",
      "Latitude": "57.0707"
    },
    {
      "Number": "97025",
      "CompanyName": "Arriva",
      "Streetname": "Bredgade 55",
      "Streetname2": "Pakkeshop: 97025",
      "ZipCode": "6900",
      "CityName": "Skjern",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.49408",
      "Latitude": "55.9465"
    },
    {
      "Number": "96559",
      "CompanyName": "Nærkøb",
      "Streetname": "Bredgade 25",
      "Streetname2": "Pakkeshop: 96559",
      "ZipCode": "7680",
      "CityName": "Thyborøn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.21622",
      "Latitude": "56.7043"
    },
    {
      "Number": "96622",
      "CompanyName": "OK Plus Farsø",
      "Streetname": "Nørregade 71",
      "Streetname2": "Pakkeshop: 96622",
      "ZipCode": "9640",
      "CityName": "Farsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.3412",
      "Latitude": "56.7785"
    },
    {
      "Number": "96880",
      "CompanyName": "Flügger Farver Amagerbrogade",
      "Streetname": "Amagerbrogade 164",
      "Streetname2": "Pakkeshop: 96880",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6106",
      "Latitude": "55.654"
    },
    {
      "Number": "96737",
      "CompanyName": "Uno-X Them",
      "Streetname": "Silkeborgvej 2B",
      "Streetname2": "Pakkeshop: 96737",
      "ZipCode": "8653",
      "CityName": "Them",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.55426",
      "Latitude": "56.0986"
    },
    {
      "Number": "96539",
      "CompanyName": "Super spar Terndrup",
      "Streetname": "Bymidten 4",
      "Streetname2": "Pakkeshop: 96539",
      "ZipCode": "9575",
      "CityName": "Terndrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0575",
      "Latitude": "56.8154"
    },
    {
      "Number": "96917",
      "CompanyName": "Sportigan",
      "Streetname": "Centervej 10A",
      "Streetname2": "Pakkeshop: 96917",
      "ZipCode": "8963",
      "CityName": "Auning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3735",
      "Latitude": "56.4317"
    },
    {
      "Number": "96239",
      "CompanyName": "Dagli´Brugsen Millinge",
      "Streetname": "Assensvej 249",
      "Streetname2": "Pakkeshop: 96239",
      "ZipCode": "5642",
      "CityName": "Millinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2107",
      "Latitude": "55.1307"
    },
    {
      "Number": "97380",
      "CompanyName": "SuperBrugsen Bullerup",
      "Streetname": "Mølledammen 5",
      "Streetname2": "Pakkeshop: 97380",
      "ZipCode": "5320",
      "CityName": "Agedrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4766",
      "Latitude": "55.4282"
    },
    {
      "Number": "96299",
      "CompanyName": "Dagli´Brugsen Græse Bakkeby",
      "Streetname": "Højvang 5",
      "Streetname2": "Pakkeshop: 96299",
      "ZipCode": "3600",
      "CityName": "Frederikssund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0736",
      "Latitude": "55.8602"
    },
    {
      "Number": "96507",
      "CompanyName": "Zap-In",
      "Streetname": "Storgade 227 B",
      "Streetname2": "Pakkeshop: 96507",
      "ZipCode": "6705",
      "CityName": "Esbjerg Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.49594",
      "Latitude": "55.4797"
    },
    {
      "Number": "96987",
      "CompanyName": "Super spar Virklund",
      "Streetname": "Virklundvej 3",
      "Streetname2": "Pakkeshop: 96987",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.56142",
      "Latitude": "56.1309"
    },
    {
      "Number": "96992",
      "CompanyName": "Coma Horreby",
      "Streetname": "Nykøbingvej 177",
      "Streetname2": "Pakkeshop: 96992",
      "ZipCode": "4800",
      "CityName": "Nykøbing F",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9941",
      "Latitude": "54.8043"
    },
    {
      "Number": "96994",
      "CompanyName": "Coma Marrebæk",
      "Streetname": "Gl. Landevej 123",
      "Streetname2": "Pakkeshop: 96994",
      "ZipCode": "4873",
      "CityName": "Væggerløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9031",
      "Latitude": "54.679"
    },
    {
      "Number": "96012",
      "CompanyName": "Købmandsgaarden",
      "Streetname": "Assensvej 141",
      "Streetname2": "Pakkeshop: 96012",
      "ZipCode": "5500",
      "CityName": "Middelfart",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.76579",
      "Latitude": "55.4908"
    },
    {
      "Number": "96124",
      "CompanyName": "Dagli´Brugsen Harndrup",
      "Streetname": "Rugårdsvej 63",
      "Streetname2": "Pakkeshop: 96124",
      "ZipCode": "5463",
      "CityName": "Harndrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0214",
      "Latitude": "55.4655"
    },
    {
      "Number": "96126",
      "CompanyName": "Dagli´Brugsen Rantzausminde",
      "Streetname": "Rantzausmindevej 112",
      "Streetname2": "Pakkeshop: 96126",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5543",
      "Latitude": "55.0386"
    },
    {
      "Number": "96129",
      "CompanyName": "Dagli´Brugsen Ryslinge",
      "Streetname": "Banevænget 1",
      "Streetname2": "Pakkeshop: 96129",
      "ZipCode": "5856",
      "CityName": "Ryslinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.536",
      "Latitude": "55.2413"
    },
    {
      "Number": "96178",
      "CompanyName": "LokalBrugsen Skt Jørgens Gade",
      "Streetname": "Skt. Jørgens Gade 112",
      "Streetname2": "Pakkeshop: 96178",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4053",
      "Latitude": "55.3991"
    },
    {
      "Number": "96789",
      "CompanyName": "Min Købmand Møgeltønder",
      "Streetname": "Møllevej 43",
      "Streetname2": "Pakkeshop: 96789",
      "ZipCode": "6270",
      "CityName": "Tønder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.8019",
      "Latitude": "54.9491"
    },
    {
      "Number": "96793",
      "CompanyName": "MIn Købmand Arnum",
      "Streetname": "Vestergade 1",
      "Streetname2": "Pakkeshop: 96793",
      "ZipCode": "6510",
      "CityName": "Gram",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.96902",
      "Latitude": "55.2476"
    },
    {
      "Number": "96794",
      "CompanyName": "Uno-X Rømø",
      "Streetname": "Vesterhavsvej 15",
      "Streetname2": "Pakkeshop: 96794",
      "ZipCode": "6792",
      "CityName": "Rømø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.55048",
      "Latitude": "55.1522"
    },
    {
      "Number": "96795",
      "CompanyName": "Kwik Spar Vedsted",
      "Streetname": "Tøndervej 36",
      "Streetname2": "Pakkeshop: 96795",
      "ZipCode": "6500",
      "CityName": "Vojens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.36733",
      "Latitude": "55.1954"
    },
    {
      "Number": "96797",
      "CompanyName": "Spar Agerbæk",
      "Streetname": "Nørregade 9",
      "Streetname2": "Pakkeshop: 96797",
      "ZipCode": "6753",
      "CityName": "Agerbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.80155",
      "Latitude": "55.6008"
    },
    {
      "Number": "96903",
      "CompanyName": "Købmandsgaarden",
      "Streetname": "Storegade 17",
      "Streetname2": "Pakkeshop: 96903",
      "ZipCode": "8752",
      "CityName": "Østbirk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.74959",
      "Latitude": "55.9668"
    },
    {
      "Number": "97652",
      "CompanyName": "Shell Dianalund",
      "Streetname": "Karsholtevej 35A",
      "Streetname2": "Pakkeshop: 97652",
      "ZipCode": "4293",
      "CityName": "Dianalund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4871",
      "Latitude": "55.5333"
    },
    {
      "Number": "97609",
      "CompanyName": "Kiosk & Spil",
      "Streetname": "Krudttårnsvej 8",
      "Streetname2": "Pakkeshop: 97609",
      "ZipCode": "2791",
      "CityName": "Dragør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6539",
      "Latitude": "55.5846"
    },
    {
      "Number": "96621",
      "CompanyName": "Blangstedgaard Nærbutik",
      "Streetname": "Blangstedgårds Alle 89",
      "Streetname2": "Pakkeshop: 96621",
      "ZipCode": "5220",
      "CityName": "Odense SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4464",
      "Latitude": "55.3808"
    },
    {
      "Number": "96695",
      "CompanyName": "Shell Herning",
      "Streetname": "Hammerum Hovedgade 132",
      "Streetname2": "Pakkeshop: 96695",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.07431",
      "Latitude": "56.133"
    },
    {
      "Number": "96079",
      "CompanyName": "Jyllandskiosken Hos Mik",
      "Streetname": "Jyllands Allé 8",
      "Streetname2": "Pakkeshop: 96079",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1903",
      "Latitude": "56.1424"
    },
    {
      "Number": "97201",
      "CompanyName": "OK Plus Kastrupvej",
      "Streetname": "Kastrupvej 145",
      "Streetname2": "Pakkeshop: 97201",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6226",
      "Latitude": "55.6478"
    },
    {
      "Number": "96111",
      "CompanyName": "Dagli´Brugsen Kulhuse",
      "Streetname": "Krakasvej 1 A",
      "Streetname2": "Pakkeshop: 96111",
      "ZipCode": "3630",
      "CityName": "Jægerspris",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9159",
      "Latitude": "55.9277"
    },
    {
      "Number": "96205",
      "CompanyName": "SuperBrugsen Skævinge",
      "Streetname": "Hovedgaden 20",
      "Streetname2": "Pakkeshop: 96205",
      "ZipCode": "3320",
      "CityName": "Skævinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1477",
      "Latitude": "55.909"
    },
    {
      "Number": "96716",
      "CompanyName": "Uno-X Extra Ringkøbing",
      "Streetname": "Herningvej 82",
      "Streetname2": "Pakkeshop: 96716",
      "ZipCode": "6950",
      "CityName": "Ringkøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.26754",
      "Latitude": "56.0871"
    },
    {
      "Number": "96637",
      "CompanyName": "Kisa Kiosk & Grill",
      "Streetname": "Stationsvej 4",
      "Streetname2": "Pakkeshop: 96637",
      "ZipCode": "7570",
      "CityName": "Vemb",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.34441",
      "Latitude": "56.3436"
    },
    {
      "Number": "96764",
      "CompanyName": "SuperBrugsen Øster Jølby",
      "Streetname": "Præstbrovej 322",
      "Streetname2": "Pakkeshop: 96764",
      "ZipCode": "7950",
      "CityName": "Erslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.71686",
      "Latitude": "56.8366"
    },
    {
      "Number": "97107",
      "CompanyName": "Min Købmand",
      "Streetname": "Luneborgvej 78",
      "Streetname2": "Pakkeshop: 97107",
      "ZipCode": "9382",
      "CityName": "Tylstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94409",
      "Latitude": "57.1969"
    },
    {
      "Number": "96937",
      "CompanyName": "OK Plus Herning",
      "Streetname": "Gl Landevej 100",
      "Streetname2": "Pakkeshop: 96937",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.96839",
      "Latitude": "56.141"
    },
    {
      "Number": "97102",
      "CompanyName": "Shell Hjørring",
      "Streetname": "Heerfordtsvej 2",
      "Streetname2": "Pakkeshop: 97102",
      "ZipCode": "9800",
      "CityName": "Hjørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0104",
      "Latitude": "57.4496"
    },
    {
      "Number": "96960",
      "CompanyName": "City Kiosken",
      "Streetname": "Bredgade 80",
      "Streetname2": "Pakkeshop: 96960",
      "ZipCode": "6900",
      "CityName": "Skjern",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.49131",
      "Latitude": "55.9491"
    },
    {
      "Number": "96935",
      "CompanyName": "Boligtextil",
      "Streetname": "Kirkegade 4",
      "Streetname2": "Pakkeshop: 96935",
      "ZipCode": "7490",
      "CityName": "Aulum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.79743",
      "Latitude": "56.266"
    },
    {
      "Number": "96086",
      "CompanyName": "Beslag & Værktøj",
      "Streetname": "Thrigesvej 2",
      "Streetname2": "Pakkeshop: 96086",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.56204",
      "Latitude": "56.1985"
    },
    {
      "Number": "97273",
      "CompanyName": "OK Plus Solrød Strand",
      "Streetname": "Solrød Strandvej 150-154",
      "Streetname2": "Pakkeshop: 97273",
      "ZipCode": "2680",
      "CityName": "Solrød Strand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2167",
      "Latitude": "55.5255"
    },
    {
      "Number": "96036",
      "CompanyName": "Statoil Rom",
      "Streetname": "Ringkøbingvej 81",
      "Streetname2": "Pakkeshop: 96036",
      "ZipCode": "7620",
      "CityName": "Lemvig",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.30629",
      "Latitude": "56.5164"
    },
    {
      "Number": "96357",
      "CompanyName": "OK Plus Sommerfuglevej",
      "Streetname": "Sommerfuglevej 2A",
      "Streetname2": "Pakkeshop: 96357",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.50591",
      "Latitude": "55.5067"
    },
    {
      "Number": "96356",
      "CompanyName": "OK Plus Brædstrup",
      "Streetname": "Nørregade 7",
      "Streetname2": "Pakkeshop: 96356",
      "ZipCode": "8740",
      "CityName": "Brædstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.61145",
      "Latitude": "55.9757"
    },
    {
      "Number": "97104",
      "CompanyName": "Min Købmand Lunde",
      "Streetname": "Skolegade 55",
      "Streetname2": "Pakkeshop: 97104",
      "ZipCode": "6830",
      "CityName": "Nørre Nebel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.37007",
      "Latitude": "55.7619"
    },
    {
      "Number": "96059",
      "CompanyName": "Kiosk 25",
      "Streetname": "Randersvej 25",
      "Streetname2": "Pakkeshop: 96059",
      "ZipCode": "8200",
      "CityName": "Århus N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2024",
      "Latitude": "56.1747"
    },
    {
      "Number": "96240",
      "CompanyName": "SuperBrugsen Erritsø",
      "Streetname": "Erritsø Bygade 109",
      "Streetname2": "Pakkeshop: 96240",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.71564",
      "Latitude": "55.5439"
    },
    {
      "Number": "96067",
      "CompanyName": "PhotoCare",
      "Streetname": "Nørregade 11",
      "Streetname2": "Pakkeshop: 96067",
      "ZipCode": "5800",
      "CityName": "Nyborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.792",
      "Latitude": "55.3123"
    },
    {
      "Number": "96934",
      "CompanyName": "Eurospar Henne",
      "Streetname": "Strandvejen 425",
      "Streetname2": "Pakkeshop: 96934",
      "ZipCode": "6854",
      "CityName": "Henne",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.17897",
      "Latitude": "55.7398"
    },
    {
      "Number": "96886",
      "CompanyName": "Min Købmand",
      "Streetname": "Nansensgade 19",
      "Streetname2": "Pakkeshop: 96886",
      "ZipCode": "1366",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5628",
      "Latitude": "55.6818"
    },
    {
      "Number": "96047",
      "CompanyName": "Hjallerup Døgnbutik",
      "Streetname": "Østergade 13",
      "Streetname2": "Pakkeshop: 96047",
      "ZipCode": "9320",
      "CityName": "Hjallerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1484",
      "Latitude": "57.1688"
    },
    {
      "Number": "96090",
      "CompanyName": "Hos Købmand",
      "Streetname": "Gl. Silkeborgvej 1",
      "Streetname2": "Pakkeshop: 96090",
      "ZipCode": "8670",
      "CityName": "Låsby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.81009",
      "Latitude": "56.1486"
    },
    {
      "Number": "96536",
      "CompanyName": "NV Foto",
      "Streetname": "Frederiksborgvej 84",
      "Streetname2": "Pakkeshop: 96536",
      "ZipCode": "2400",
      "CityName": "København NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5323",
      "Latitude": "55.708"
    },
    {
      "Number": "96997",
      "CompanyName": "Min købmand Bruunshåb",
      "Streetname": "Vinkelvej 85",
      "Streetname2": "Pakkeshop: 96997",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.4425",
      "Latitude": "56.4225"
    },
    {
      "Number": "96164",
      "CompanyName": "Lokalbrugsen",
      "Streetname": "Mylius Erichsensvej 74",
      "Streetname2": "Pakkeshop: 96164",
      "ZipCode": "9210",
      "CityName": "Aalborg Sø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.93741",
      "Latitude": "57.0216"
    },
    {
      "Number": "96264",
      "CompanyName": "SuperBrugsen Sorø",
      "Streetname": "Norgesvej 2",
      "Streetname2": "Pakkeshop: 96264",
      "ZipCode": "4180",
      "CityName": "Sorø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.5628",
      "Latitude": "55.415"
    },
    {
      "Number": "96128",
      "CompanyName": "Dagli´Brugsen Herrested",
      "Streetname": "Måre Byvej 17",
      "Streetname2": "Pakkeshop: 96128",
      "ZipCode": "5853",
      "CityName": "Ørbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6131",
      "Latitude": "55.2764"
    },
    {
      "Number": "97511",
      "CompanyName": "Dagli´Brugsen Lindved",
      "Streetname": "Agersbølvej 5",
      "Streetname2": "Pakkeshop: 97511",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.58085",
      "Latitude": "55.7931"
    },
    {
      "Number": "96719",
      "CompanyName": "Shell Løgstør",
      "Streetname": "Bredgade 104",
      "Streetname2": "Pakkeshop: 96719",
      "ZipCode": "9670",
      "CityName": "Løgstør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.27463",
      "Latitude": "56.9688"
    },
    {
      "Number": "96225",
      "CompanyName": "Dagli´Brugsen Smidstrup strand",
      "Streetname": "Smidstrup Strandvej 65",
      "Streetname2": "Pakkeshop: 96225",
      "ZipCode": "3250",
      "CityName": "Gilleleje",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2376",
      "Latitude": "56.1156"
    },
    {
      "Number": "96722",
      "CompanyName": "Uno-X Allerød",
      "Streetname": "Solvang 2",
      "Streetname2": "Pakkeshop: 96722",
      "ZipCode": "3450",
      "CityName": "Allerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3545",
      "Latitude": "55.8877"
    },
    {
      "Number": "96696",
      "CompanyName": "Hammelhus",
      "Streetname": "Østergade 42",
      "Streetname2": "Pakkeshop: 96696",
      "ZipCode": "8450",
      "CityName": "Hammel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.86894",
      "Latitude": "56.2573"
    },
    {
      "Number": "96109",
      "CompanyName": "Dagli´Brugsen Gudhjem",
      "Streetname": "Jernkåsvej 1",
      "Streetname2": "Pakkeshop: 96109",
      "ZipCode": "3760",
      "CityName": "Gudhjem",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.9762",
      "Latitude": "55.2071"
    },
    {
      "Number": "96190",
      "CompanyName": "Dagli´Brugsen Svaneke",
      "Streetname": "Nansensgade 11",
      "Streetname2": "Pakkeshop: 96190",
      "ZipCode": "3740",
      "CityName": "Svaneke",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "15.1415",
      "Latitude": "55.1368"
    },
    {
      "Number": "96198",
      "CompanyName": "SuperBrugsen Kværndrup",
      "Streetname": "Svendborgvej 10",
      "Streetname2": "Pakkeshop: 96198",
      "ZipCode": "5772",
      "CityName": "Kværndrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5248",
      "Latitude": "55.1777"
    },
    {
      "Number": "96199",
      "CompanyName": "Dagli´Brugsen Særslev",
      "Streetname": "Vestergade 18",
      "Streetname2": "Pakkeshop: 96199",
      "ZipCode": "5471",
      "CityName": "Søndersø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1717",
      "Latitude": "55.5132"
    },
    {
      "Number": "96201",
      "CompanyName": "SuperBrugsen Kerteminde",
      "Streetname": "Hans Schacksvej 2",
      "Streetname2": "Pakkeshop: 96201",
      "ZipCode": "5300",
      "CityName": "Kerteminde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6612",
      "Latitude": "55.4507"
    },
    {
      "Number": "96323",
      "CompanyName": "Click",
      "Streetname": "Gerritsgade 22a",
      "Streetname2": "Pakkeshop: 96323",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6085",
      "Latitude": "55.059"
    },
    {
      "Number": "96337",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Jernbanegade 24",
      "Streetname2": "Pakkeshop: 96337",
      "ZipCode": "5450",
      "CityName": "Otterup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3969",
      "Latitude": "55.5136"
    },
    {
      "Number": "97682",
      "CompanyName": "Skjold Burne",
      "Streetname": "Falkonér Allé 6",
      "Streetname2": "Pakkeshop: 97682",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5335",
      "Latitude": "55.6789"
    },
    {
      "Number": "96501",
      "CompanyName": "Zap-In",
      "Streetname": "Grønløkkevej 6",
      "Streetname2": "Pakkeshop: 96501",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3649",
      "Latitude": "55.3926"
    },
    {
      "Number": "96604",
      "CompanyName": "GLS Pakke Shop",
      "Streetname": "Fabriksvej 10",
      "Streetname2": "Pakkeshop: 96604",
      "ZipCode": "5260",
      "CityName": "Odense S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4059",
      "Latitude": "55.3475"
    },
    {
      "Number": "96262",
      "CompanyName": "Dagli´Brugsen Snerlevej",
      "Streetname": "Snerlevej 1",
      "Streetname2": "Pakkeshop: 96262",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1042",
      "Latitude": "55.636"
    },
    {
      "Number": "96113",
      "CompanyName": "Dagli´Brugsen Osted",
      "Streetname": "Nørretoften 1",
      "Streetname2": "Pakkeshop: 96113",
      "ZipCode": "4320",
      "CityName": "Lejre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9632",
      "Latitude": "55.5662"
    },
    {
      "Number": "96114",
      "CompanyName": "Dagli´Brugsen Skuldelev",
      "Streetname": "Østergade 6",
      "Streetname2": "Pakkeshop: 96114",
      "ZipCode": "4050",
      "CityName": "Skibby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0166",
      "Latitude": "55.7836"
    },
    {
      "Number": "96555",
      "CompanyName": "Gevinsten",
      "Streetname": "Kettevej 5",
      "Streetname2": "Pakkeshop: 96555",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4605",
      "Latitude": "55.6446"
    },
    {
      "Number": "96120",
      "CompanyName": "Dagli´Brugsen Snertinge",
      "Streetname": "Kalundborgvej 24",
      "Streetname2": "Pakkeshop: 96120",
      "ZipCode": "4460",
      "CityName": "Snertinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3829",
      "Latitude": "55.7115"
    },
    {
      "Number": "96891",
      "CompanyName": "Satnam Købmanden",
      "Streetname": "Parkvej 1",
      "Streetname2": "Pakkeshop: 96891",
      "ZipCode": "3550",
      "CityName": "Slangerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.172",
      "Latitude": "55.8536"
    },
    {
      "Number": "96265",
      "CompanyName": "SuperBrugsen Kolt",
      "Streetname": "Kolt Østervej 37 - 39",
      "Streetname2": "Pakkeshop: 96265",
      "ZipCode": "8361",
      "CityName": "Hasselager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0768",
      "Latitude": "56.1092"
    },
    {
      "Number": "96846",
      "CompanyName": "Click",
      "Streetname": "Taastrup Hovedgade 117",
      "Streetname2": "Pakkeshop: 96846",
      "ZipCode": "2630",
      "CityName": "Taastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2994",
      "Latitude": "55.6473"
    },
    {
      "Number": "97264",
      "CompanyName": "OK Plus Sæby",
      "Streetname": "Trafikcenter Sæby Syd 1",
      "Streetname2": "Pakkeshop: 97264",
      "ZipCode": "9300",
      "CityName": "Sæby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4497",
      "Latitude": "57.3131"
    },
    {
      "Number": "97648",
      "CompanyName": "Jagt- og Fiskerihuset",
      "Streetname": "Bindeledet 13",
      "Streetname2": "Pakkeshop: 97648",
      "ZipCode": "2880",
      "CityName": "Bagsværd",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4536",
      "Latitude": "55.7624"
    },
    {
      "Number": "96500",
      "CompanyName": "Zap-In",
      "Streetname": "Ro´s Have 13",
      "Streetname2": "Pakkeshop: 96500",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1032",
      "Latitude": "55.6421"
    },
    {
      "Number": "96035",
      "CompanyName": "Ålestrup Radio og Tv",
      "Streetname": "Vestergade 9",
      "Streetname2": "Pakkeshop: 96035",
      "ZipCode": "9620",
      "CityName": "Aalestrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.49437",
      "Latitude": "56.694"
    },
    {
      "Number": "96735",
      "CompanyName": "Imerco",
      "Streetname": "Adelgade 64",
      "Streetname2": "Pakkeshop: 96735",
      "ZipCode": "5400",
      "CityName": "Bogense",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0914",
      "Latitude": "55.5651"
    },
    {
      "Number": "96626",
      "CompanyName": "SuperBest Søndervig",
      "Streetname": "Badevej 1",
      "Streetname2": "Pakkeshop: 96626",
      "ZipCode": "6950",
      "CityName": "Ringkøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.11636",
      "Latitude": "56.1189"
    },
    {
      "Number": "97520",
      "CompanyName": "Dagli´Brugsen Klejtrup",
      "Streetname": "Skårupvej 14",
      "Streetname2": "Pakkeshop: 97520",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.63274",
      "Latitude": "56.5898"
    },
    {
      "Number": "97106",
      "CompanyName": "OK Plus Brovst",
      "Streetname": "Østergade 63",
      "Streetname2": "Pakkeshop: 97106",
      "ZipCode": "9460",
      "CityName": "Brovst",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.53428",
      "Latitude": "57.0985"
    },
    {
      "Number": "96530",
      "CompanyName": "Flügger Farver Lyngbyvej",
      "Streetname": "Lyngbyvej 72",
      "Streetname2": "Pakkeshop: 96530",
      "ZipCode": "2100",
      "CityName": "København Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5602",
      "Latitude": "55.7121"
    },
    {
      "Number": "96151",
      "CompanyName": "Dagli´Brugsen Herskind",
      "Streetname": "Langelinie 62",
      "Streetname2": "Pakkeshop: 96151",
      "ZipCode": "8464",
      "CityName": "Galten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.96311",
      "Latitude": "56.184"
    },
    {
      "Number": "96077",
      "CompanyName": "Go´on Stoholm",
      "Streetname": "Østergade 24",
      "Streetname2": "Pakkeshop: 96077",
      "ZipCode": "7850",
      "CityName": "Stoholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.15487",
      "Latitude": "56.4851"
    },
    {
      "Number": "96553",
      "CompanyName": "OK Plus Hadsten",
      "Streetname": "Hadbjergvej 6",
      "Streetname2": "Pakkeshop: 96553",
      "ZipCode": "8370",
      "CityName": "Hadsten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0515",
      "Latitude": "56.3337"
    },
    {
      "Number": "96165",
      "CompanyName": "Dagli´Brugsen Hundelev",
      "Streetname": "Løkkensvej 669",
      "Streetname2": "Pakkeshop: 96165",
      "ZipCode": "9480",
      "CityName": "Løkken",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.84362",
      "Latitude": "57.4252"
    },
    {
      "Number": "96171",
      "CompanyName": "Dagli´Brugsen Mølleparken",
      "Streetname": "L.P.Houmøllersvej 22",
      "Streetname2": "Pakkeshop: 96171",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5112",
      "Latitude": "57.4252"
    },
    {
      "Number": "96203",
      "CompanyName": "SuperBrugsen Dronninglund",
      "Streetname": "Slotsgade 25",
      "Streetname2": "Pakkeshop: 96203",
      "ZipCode": "9330",
      "CityName": "Dronninglund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2866",
      "Latitude": "57.1594"
    },
    {
      "Number": "96226",
      "CompanyName": "Dagli´Brugsen Gjøl",
      "Streetname": "Limfjordsgade 53",
      "Streetname2": "Pakkeshop: 96226",
      "ZipCode": "9440",
      "CityName": "Aabybro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.71027",
      "Latitude": "57.0671"
    },
    {
      "Number": "96304",
      "CompanyName": "2tal",
      "Streetname": "Bredgade 61",
      "Streetname2": "Pakkeshop: 96304",
      "ZipCode": "9490",
      "CityName": "Pandrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.67617",
      "Latitude": "57.2197"
    },
    {
      "Number": "96238",
      "CompanyName": "Dagli´Brugsen Bårdesø",
      "Streetname": "Tørresøvej 4",
      "Streetname2": "Pakkeshop: 96238",
      "ZipCode": "5450",
      "CityName": "Otterup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3943",
      "Latitude": "55.5742"
    },
    {
      "Number": "96388",
      "CompanyName": "Skjold Burne",
      "Streetname": "Sct. Jacobsvej 1",
      "Streetname2": "Pakkeshop: 96388",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3627",
      "Latitude": "55.732"
    },
    {
      "Number": "97319",
      "CompanyName": "Skjold Burne",
      "Streetname": "Vesterkøb 22",
      "Streetname2": "Pakkeshop: 97319",
      "ZipCode": "2640",
      "CityName": "Hedehusene",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1965",
      "Latitude": "55.6515"
    },
    {
      "Number": "96027",
      "CompanyName": "Kim´s Handel",
      "Streetname": "Landevejen 140",
      "Streetname2": "Pakkeshop: 96027",
      "ZipCode": "5883",
      "CityName": "Oure",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.7233",
      "Latitude": "55.1201"
    },
    {
      "Number": "96893",
      "CompanyName": "Ham & Hende",
      "Streetname": "Algade 55",
      "Streetname2": "Pakkeshop: 96893",
      "ZipCode": "5683",
      "CityName": "Haarby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1215",
      "Latitude": "55.2236"
    },
    {
      "Number": "97810",
      "CompanyName": "Shell 7-Eleven Valby",
      "Streetname": "Gl. Køge Landevej 16",
      "Streetname2": "Pakkeshop: 97810",
      "ZipCode": "2500",
      "CityName": "Valby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5154",
      "Latitude": "55.6606"
    },
    {
      "Number": "96100",
      "CompanyName": "Dagli´Brugsen Skyttegården",
      "Streetname": "Vigerslevvej 125",
      "Streetname2": "Pakkeshop: 96100",
      "ZipCode": "2500",
      "CityName": "Valby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4835",
      "Latitude": "55.6619"
    },
    {
      "Number": "97616",
      "CompanyName": "Eurospar Ebberup",
      "Streetname": "Ebberupvej 75",
      "Streetname2": "Pakkeshop: 97616",
      "ZipCode": "5631",
      "CityName": "Ebberup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.98139",
      "Latitude": "55.242"
    },
    {
      "Number": "96545",
      "CompanyName": "Falkevejens Nærbutik",
      "Streetname": "Falkevej 2",
      "Streetname2": "Pakkeshop: 96545",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.38897",
      "Latitude": "56.449"
    },
    {
      "Number": "96946",
      "CompanyName": "Pavo Hestefoder",
      "Streetname": "Søndergård Allé 22",
      "Streetname2": "Pakkeshop: 96946",
      "ZipCode": "6500",
      "CityName": "Vojens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.40701",
      "Latitude": "55.2425"
    },
    {
      "Number": "96949",
      "CompanyName": "OK Plus Bredballe",
      "Streetname": "Horsensvej 329",
      "Streetname2": "Pakkeshop: 96949",
      "ZipCode": "7120",
      "CityName": "Vejle Øst",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.60318",
      "Latitude": "55.7321"
    },
    {
      "Number": "96068",
      "CompanyName": "Super spar Løkken",
      "Streetname": "Toldbodvej 9",
      "Streetname2": "Pakkeshop: 96068",
      "ZipCode": "9480",
      "CityName": "Løkken",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.71166",
      "Latitude": "57.37"
    },
    {
      "Number": "96953",
      "CompanyName": "OK Plus Sønderborg",
      "Streetname": "Dybbølgade 43",
      "Streetname2": "Pakkeshop: 96953",
      "ZipCode": "6400",
      "CityName": "Sønderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.77189",
      "Latitude": "54.91"
    },
    {
      "Number": "96957",
      "CompanyName": "Videokiosken",
      "Streetname": "Von Støckens Plads 2",
      "Streetname2": "Pakkeshop: 96957",
      "ZipCode": "6760",
      "CityName": "Ribe",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.7628",
      "Latitude": "55.3277"
    },
    {
      "Number": "96967",
      "CompanyName": "Spillehjørnet",
      "Streetname": "Kongevej 16C",
      "Streetname2": "Pakkeshop: 96967",
      "ZipCode": "6270",
      "CityName": "Tønder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.86287",
      "Latitude": "54.9354"
    },
    {
      "Number": "97369",
      "CompanyName": "Spar Munkebo",
      "Streetname": "Bycentret 208",
      "Streetname2": "Pakkeshop: 97369",
      "ZipCode": "5330",
      "CityName": "Munkebo",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5611",
      "Latitude": "55.46"
    },
    {
      "Number": "96153",
      "CompanyName": "Dagli´Brugsen Voldby",
      "Streetname": "Dolmervej 2",
      "Streetname2": "Pakkeshop: 96153",
      "ZipCode": "8500",
      "CityName": "Grenaa",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.8674",
      "Latitude": "56.4601"
    },
    {
      "Number": "96154",
      "CompanyName": "Dagli´Brugsen Nimtofte",
      "Streetname": "Torvet 8",
      "Streetname2": "Pakkeshop: 96154",
      "ZipCode": "8581",
      "CityName": "Nimtofte",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5682",
      "Latitude": "56.4087"
    },
    {
      "Number": "96155",
      "CompanyName": "Dagli´Brugsen Bønnerup",
      "Streetname": "Bønnerupvej 12",
      "Streetname2": "Pakkeshop: 96155",
      "ZipCode": "8585",
      "CityName": "Glesborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.7051",
      "Latitude": "56.5287"
    },
    {
      "Number": "96156",
      "CompanyName": "Dagli´Brugsen Fjellerup",
      "Streetname": "Strandvejen 8",
      "Streetname2": "Pakkeshop: 96156",
      "ZipCode": "8585",
      "CityName": "Glesborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5883",
      "Latitude": "56.5066"
    },
    {
      "Number": "96157",
      "CompanyName": "Dagli´Brugsen Ørum Djurs",
      "Streetname": "Åbrovej 61",
      "Streetname2": "Pakkeshop: 96157",
      "ZipCode": "8586",
      "CityName": "Ørum Djurs",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6763",
      "Latitude": "56.4422"
    },
    {
      "Number": "96222",
      "CompanyName": "Dagli´Brugsen Vrinners",
      "Streetname": "Vrinners Bygade 37",
      "Streetname2": "Pakkeshop: 96222",
      "ZipCode": "8420",
      "CityName": "Knebel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4933",
      "Latitude": "56.2431"
    },
    {
      "Number": "96301",
      "CompanyName": "Kolind Boghandel",
      "Streetname": "Bredgade 20",
      "Streetname2": "Pakkeshop: 96301",
      "ZipCode": "8560",
      "CityName": "Kolind",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5892",
      "Latitude": "56.3615"
    },
    {
      "Number": "97519",
      "CompanyName": "Dagli´Brugsen Jordrup",
      "Streetname": "Hovedgaden 43",
      "Streetname2": "Pakkeshop: 97519",
      "ZipCode": "6064",
      "CityName": "Jordrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.31234",
      "Latitude": "55.5539"
    },
    {
      "Number": "97649",
      "CompanyName": "Bog & Idé Fredericia",
      "Streetname": "Gothersgade 37",
      "Streetname2": "Pakkeshop: 97649",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.75675",
      "Latitude": "55.5646"
    },
    {
      "Number": "96504",
      "CompanyName": "Zap-In",
      "Streetname": "Søren Frichsvej 3",
      "Streetname2": "Pakkeshop: 96504",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1885",
      "Latitude": "56.1525"
    },
    {
      "Number": "96094",
      "CompanyName": "MIn Købmand",
      "Streetname": "Menstrup Bygade 33",
      "Streetname2": "Pakkeshop: 96094",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.5808",
      "Latitude": "55.2131"
    },
    {
      "Number": "96931",
      "CompanyName": "Min Købmand",
      "Streetname": "Vig Hovedgade 8",
      "Streetname2": "Pakkeshop: 96931",
      "ZipCode": "4560",
      "CityName": "Vig",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.5814",
      "Latitude": "55.8513"
    },
    {
      "Number": "96860",
      "CompanyName": "Eurospar Græsted",
      "Streetname": "Græsted Hovedgade 25",
      "Streetname2": "Pakkeshop: 96860",
      "ZipCode": "3230",
      "CityName": "Græsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2856",
      "Latitude": "56.0652"
    },
    {
      "Number": "97801",
      "CompanyName": "Shell 7-Eleven Herlev",
      "Streetname": "Hjortespringvej 24",
      "Streetname2": "Pakkeshop: 97801",
      "ZipCode": "2730",
      "CityName": "Herlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4388",
      "Latitude": "55.7285"
    },
    {
      "Number": "96117",
      "CompanyName": "Dagli´Brugsen Jystrup",
      "Streetname": "Aalbækvej 1",
      "Streetname2": "Pakkeshop: 96117",
      "ZipCode": "4174",
      "CityName": "Jystrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8604",
      "Latitude": "55.5129"
    },
    {
      "Number": "96118",
      "CompanyName": "Dagli´Brugsen Frølunde",
      "Streetname": "Stibjergvej 2",
      "Streetname2": "Pakkeshop: 96118",
      "ZipCode": "4220",
      "CityName": "Korsør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.1716",
      "Latitude": "55.3648"
    },
    {
      "Number": "97221",
      "CompanyName": "OK Plus Store Fuglede",
      "Streetname": "Bjerge Landevej 6",
      "Streetname2": "Pakkeshop: 97221",
      "ZipCode": "4480",
      "CityName": "Store Fuglede",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.185",
      "Latitude": "55.5901"
    },
    {
      "Number": "97608",
      "CompanyName": "Q8 / F24",
      "Streetname": "Elverdamsvej 308",
      "Streetname2": "Pakkeshop: 97608",
      "ZipCode": "4070",
      "CityName": "Kirke Hyllinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8994",
      "Latitude": "55.7098"
    },
    {
      "Number": "96192",
      "CompanyName": "Dagli´Brugsen Høm",
      "Streetname": "Næstvedvej 230",
      "Streetname2": "Pakkeshop: 96192",
      "ZipCode": "4100",
      "CityName": "Ringsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7838",
      "Latitude": "55.42"
    },
    {
      "Number": "96131",
      "CompanyName": "Dagli´Brugsen Bredebo",
      "Streetname": "Brede Bygade 20",
      "Streetname2": "Pakkeshop: 96131",
      "ZipCode": "6261",
      "CityName": "Bredebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.82058",
      "Latitude": "55.06"
    },
    {
      "Number": "96133",
      "CompanyName": "Dagli´Brugsen Gørding",
      "Streetname": "Nørregade 82-90",
      "Streetname2": "Pakkeshop: 96133",
      "ZipCode": "6690",
      "CityName": "Gørding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.79692",
      "Latitude": "55.4753"
    },
    {
      "Number": "96134",
      "CompanyName": "Dagli´Brugsen Tarp",
      "Streetname": "Tarp Byvej 51",
      "Streetname2": "Pakkeshop: 96134",
      "ZipCode": "6715",
      "CityName": "Esbjerg N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.46172",
      "Latitude": "55.5258"
    },
    {
      "Number": "96085",
      "CompanyName": "AK Computers",
      "Streetname": "Banegårdsgade 15",
      "Streetname2": "Pakkeshop: 96085",
      "ZipCode": "8300",
      "CityName": "Odder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1495",
      "Latitude": "55.9708"
    },
    {
      "Number": "96145",
      "CompanyName": "Dagli´Brugsen Ny Nørup",
      "Streetname": "Billundvej 35",
      "Streetname2": "Pakkeshop: 96145",
      "ZipCode": "7182",
      "CityName": "Bredsten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.30571",
      "Latitude": "55.704"
    },
    {
      "Number": "96172",
      "CompanyName": "Dagli´Brugsen Smidstrup",
      "Streetname": "Torpsgade 17",
      "Streetname2": "Pakkeshop: 96172",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.5665",
      "Latitude": "55.6126"
    },
    {
      "Number": "96173",
      "CompanyName": "Dagli´Brugsen Ovtrup",
      "Streetname": "Storegade 27",
      "Streetname2": "Pakkeshop: 96173",
      "ZipCode": "6855",
      "CityName": "Ovtrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.34355",
      "Latitude": "55.7202"
    },
    {
      "Number": "96176",
      "CompanyName": "Dagli´Brugsen Jels",
      "Streetname": "Søvej 6",
      "Streetname2": "Pakkeshop: 96176",
      "ZipCode": "6630",
      "CityName": "Rødding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.20368",
      "Latitude": "55.3563"
    },
    {
      "Number": "96181",
      "CompanyName": "Dagli´Brugsen Ulkebøl",
      "Streetname": "Torvet 1",
      "Streetname2": "Pakkeshop: 96181",
      "ZipCode": "6400",
      "CityName": "Sønderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.82078",
      "Latitude": "54.9246"
    },
    {
      "Number": "96182",
      "CompanyName": "SuperBrugsen Skærbæk",
      "Streetname": "Kirkevej 1",
      "Streetname2": "Pakkeshop: 96182",
      "ZipCode": "6780",
      "CityName": "Skærbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.76392",
      "Latitude": "55.1588"
    },
    {
      "Number": "96397",
      "CompanyName": "Tørring Servicecenter",
      "Streetname": "Ågade 26",
      "Streetname2": "Pakkeshop: 96397",
      "ZipCode": "7160",
      "CityName": "Tørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.48467",
      "Latitude": "55.855"
    },
    {
      "Number": "96832",
      "CompanyName": "Vojens Boghandel",
      "Streetname": "Vestergade 14",
      "Streetname2": "Pakkeshop: 96832",
      "ZipCode": "6500",
      "CityName": "Vojens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.30167",
      "Latitude": "55.2462"
    },
    {
      "Number": "97110",
      "CompanyName": "Købmanden i Ørsted",
      "Streetname": "Frøbjergvej 13",
      "Streetname2": "Pakkeshop: 97110",
      "ZipCode": "5620",
      "CityName": "Glamsbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0594",
      "Latitude": "55.3289"
    },
    {
      "Number": "96243",
      "CompanyName": "SuperBrugsen Karlslunde",
      "Streetname": "Møllevej 10",
      "Streetname2": "Pakkeshop: 96243",
      "ZipCode": "2690",
      "CityName": "Karlslunde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2254",
      "Latitude": "55.5715"
    },
    {
      "Number": "96244",
      "CompanyName": "Dagli´Brugsen Dronningmølle",
      "Streetname": "Dronningmølle Strandvej 645 B",
      "Streetname2": "Pakkeshop: 96244",
      "ZipCode": "3120",
      "CityName": "Dronningmølle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3867",
      "Latitude": "56.0984"
    },
    {
      "Number": "96889",
      "CompanyName": "Service Kiosken",
      "Streetname": "Flodvej 75C",
      "Streetname2": "Pakkeshop: 96889",
      "ZipCode": "2765",
      "CityName": "Smørum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3065",
      "Latitude": "55.7324"
    },
    {
      "Number": "96600",
      "CompanyName": "GLS Pakke Shop",
      "Streetname": "Højager 2-4",
      "Streetname2": "Pakkeshop: 96600",
      "ZipCode": "2630",
      "CityName": "Taastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2571",
      "Latitude": "55.636"
    },
    {
      "Number": "96532",
      "CompanyName": "Alfa Møbler",
      "Streetname": "Centerparken 34",
      "Streetname2": "Pakkeshop: 96532",
      "ZipCode": "2500",
      "CityName": "Valby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4892",
      "Latitude": "55.6545"
    },
    {
      "Number": "97610",
      "CompanyName": "Uno-X Extra Tune",
      "Streetname": "Bøgevej 1",
      "Streetname2": "Pakkeshop: 97610",
      "ZipCode": "4030",
      "CityName": "Tune",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1771",
      "Latitude": "55.5961"
    },
    {
      "Number": "96072",
      "CompanyName": "Bramming Bøger & Papir",
      "Streetname": "Nørregade 8",
      "Streetname2": "Pakkeshop: 96072",
      "ZipCode": "6740",
      "CityName": "Bramming",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.70076",
      "Latitude": "55.4653"
    },
    {
      "Number": "96845",
      "CompanyName": "iBOB",
      "Streetname": "Falkevej 3A",
      "Streetname2": "Pakkeshop: 96845",
      "ZipCode": "6705",
      "CityName": "Esbjerg Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.46642",
      "Latitude": "55.4888"
    },
    {
      "Number": "96847",
      "CompanyName": "Nybom Vine",
      "Streetname": "Solrød Center 115",
      "Streetname2": "Pakkeshop: 96847",
      "ZipCode": "2680",
      "CityName": "Solrød Strand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.222",
      "Latitude": "55.533"
    },
    {
      "Number": "97729",
      "CompanyName": "Steenberg Bog & Idé",
      "Streetname": "Nørrebrogade 163",
      "Streetname2": "Pakkeshop: 97729",
      "ZipCode": "2200",
      "CityName": "København N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5474",
      "Latitude": "55.6951"
    },
    {
      "Number": "97742",
      "CompanyName": "Min Købmand",
      "Streetname": "Brøderupvej 1",
      "Streetname2": "Pakkeshop: 97742",
      "ZipCode": "4733",
      "CityName": "Tappernøje",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9746",
      "Latitude": "55.1781"
    },
    {
      "Number": "97749",
      "CompanyName": "Shell Ørslev",
      "Streetname": "Københavnsvej 302",
      "Streetname2": "Pakkeshop: 97749",
      "ZipCode": "4760",
      "CityName": "Vordingborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9488",
      "Latitude": "55.035"
    },
    {
      "Number": "97760",
      "CompanyName": "Statoil Virum",
      "Streetname": "Kongevejen 205",
      "Streetname2": "Pakkeshop: 97760",
      "ZipCode": "2830",
      "CityName": "Virum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4811",
      "Latitude": "55.7973"
    },
    {
      "Number": "97528",
      "CompanyName": "Kvickly Storcenter",
      "Streetname": "Vestergade 167",
      "Streetname2": "Pakkeshop: 97528",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5904",
      "Latitude": "55.0643"
    },
    {
      "Number": "97728",
      "CompanyName": "OK Plus Otterup",
      "Streetname": "Søndergade 30",
      "Streetname2": "Pakkeshop: 97728",
      "ZipCode": "5450",
      "CityName": "Otterup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4001",
      "Latitude": "55.5112"
    },
    {
      "Number": "97733",
      "CompanyName": "Shell Allegade",
      "Streetname": "Allegade 63",
      "Streetname2": "Pakkeshop: 97733",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.84476",
      "Latitude": "55.8675"
    },
    {
      "Number": "97731",
      "CompanyName": "Shell Århus C",
      "Streetname": "Silkeborgvej 4",
      "Streetname2": "Pakkeshop: 97731",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1913",
      "Latitude": "56.1574"
    },
    {
      "Number": "97751",
      "CompanyName": "Statoil Nybrovej",
      "Streetname": "Nybrovej 45",
      "Streetname2": "Pakkeshop: 97751",
      "ZipCode": "2820",
      "CityName": "Gentofte",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5129",
      "Latitude": "55.755"
    },
    {
      "Number": "97752",
      "CompanyName": "Statoil Røde Vejrmølle",
      "Streetname": "Roskildevej 2",
      "Streetname2": "Pakkeshop: 97752",
      "ZipCode": "2620",
      "CityName": "Albertslund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3704",
      "Latitude": "55.6642"
    },
    {
      "Number": "97754",
      "CompanyName": "Statoil Birkerød",
      "Streetname": "Bistrupvej 80",
      "Streetname2": "Pakkeshop: 97754",
      "ZipCode": "3460",
      "CityName": "Birkerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4293",
      "Latitude": "55.8318"
    },
    {
      "Number": "97755",
      "CompanyName": "Statoil Glostrup",
      "Streetname": "Ndr. Ringvej 7",
      "Streetname2": "Pakkeshop: 97755",
      "ZipCode": "2600",
      "CityName": "Glostrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3883",
      "Latitude": "55.6665"
    },
    {
      "Number": "97758",
      "CompanyName": "Statoil Hvidovre",
      "Streetname": "Kettevej 2",
      "Streetname2": "Pakkeshop: 97758",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4598",
      "Latitude": "55.6453"
    },
    {
      "Number": "97759",
      "CompanyName": "Statoil Jyllingevej",
      "Streetname": "Jyllingevej 166",
      "Streetname2": "Pakkeshop: 97759",
      "ZipCode": "2610",
      "CityName": "Rødovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4626",
      "Latitude": "55.6924"
    },
    {
      "Number": "97764",
      "CompanyName": "Statoil Holbæk",
      "Streetname": "Roskildevej 195",
      "Streetname2": "Pakkeshop: 97764",
      "ZipCode": "4300",
      "CityName": "Holbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7267",
      "Latitude": "55.6977"
    },
    {
      "Number": "97768",
      "CompanyName": "Ringe Nærkøb",
      "Streetname": "Algade 62-64",
      "Streetname2": "Pakkeshop: 97768",
      "ZipCode": "5750",
      "CityName": "Ringe",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4782",
      "Latitude": "55.2389"
    },
    {
      "Number": "97741",
      "CompanyName": "Shell Stilling",
      "Streetname": "Ørstedsvej 6",
      "Streetname2": "Pakkeshop: 97741",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.97814",
      "Latitude": "56.0688"
    },
    {
      "Number": "97730",
      "CompanyName": "Shell Grenaa",
      "Streetname": "Østerbrogade 8-10",
      "Streetname2": "Pakkeshop: 97730",
      "ZipCode": "8500",
      "CityName": "Grenaa",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.8831",
      "Latitude": "56.4137"
    },
    {
      "Number": "97747",
      "CompanyName": "Shell Randers SV",
      "Streetname": "Århusvej 62",
      "Streetname2": "Pakkeshop: 97747",
      "ZipCode": "8940",
      "CityName": "Randers sv",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0484",
      "Latitude": "56.4426"
    },
    {
      "Number": "97745",
      "CompanyName": "Shell Hobro",
      "Streetname": "Aalborgvej 2",
      "Streetname2": "Pakkeshop: 97745",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.79449",
      "Latitude": "56.6499"
    },
    {
      "Number": "97543",
      "CompanyName": "SuperBrugsen Fensmark",
      "Streetname": "Næstvedvej 2",
      "Streetname2": "Pakkeshop: 97543",
      "ZipCode": "4684",
      "CityName": "Holmegaard",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8034",
      "Latitude": "55.2792"
    },
    {
      "Number": "97756",
      "CompanyName": "Statoil Tempovej",
      "Streetname": "Tempovej 25",
      "Streetname2": "Pakkeshop: 97756",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3772",
      "Latitude": "55.7229"
    },
    {
      "Number": "97763",
      "CompanyName": "Statoil Ballerup Byvej",
      "Streetname": "Ballerup Byvej 115",
      "Streetname2": "Pakkeshop: 97763",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3751",
      "Latitude": "55.7314"
    },
    {
      "Number": "97765",
      "CompanyName": "Statoil Skovlunde",
      "Streetname": "Torvevej 50",
      "Streetname2": "Pakkeshop: 97765",
      "ZipCode": "2740",
      "CityName": "Skovlunde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4032",
      "Latitude": "55.7197"
    },
    {
      "Number": "97766",
      "CompanyName": "Statoil Kalundborg",
      "Streetname": "Esbern Snaresvej 4",
      "Streetname2": "Pakkeshop: 97766",
      "ZipCode": "4400",
      "CityName": "Kalundborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.0908",
      "Latitude": "55.6843"
    },
    {
      "Number": "97770",
      "CompanyName": "Statoil Snertinge",
      "Streetname": "Kalundborgvej 26",
      "Streetname2": "Pakkeshop: 97770",
      "ZipCode": "4460",
      "CityName": "Snertinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3825",
      "Latitude": "55.7116"
    },
    {
      "Number": "97774",
      "CompanyName": "Bredgades Kiosk",
      "Streetname": "Bredgade 29",
      "Streetname2": "Pakkeshop: 97774",
      "ZipCode": "6920",
      "CityName": "Videbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.63092",
      "Latitude": "56.0911"
    },
    {
      "Number": "97541",
      "CompanyName": "Dagli´Brugsen Tebstrup",
      "Streetname": "Horsensvej 101",
      "Streetname2": "Pakkeshop: 97541",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.87885",
      "Latitude": "55.9736"
    },
    {
      "Number": "97743",
      "CompanyName": "Shell Randers NV",
      "Streetname": "Viborgvej 94",
      "Streetname2": "Pakkeshop: 97743",
      "ZipCode": "8920",
      "CityName": "Randers NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0038",
      "Latitude": "56.4654"
    },
    {
      "Number": "97660",
      "CompanyName": "Super spar Suldrup",
      "Streetname": "Hjedsbækvej 349",
      "Streetname2": "Pakkeshop: 97660",
      "ZipCode": "9541",
      "CityName": "Suldrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.70012",
      "Latitude": "56.8469"
    },
    {
      "Number": "97744",
      "CompanyName": "Shell Hadsund",
      "Streetname": "Himmerlandsgade 12",
      "Streetname2": "Pakkeshop: 97744",
      "ZipCode": "9560",
      "CityName": "Hadsund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1108",
      "Latitude": "56.7178"
    },
    {
      "Number": "97746",
      "CompanyName": "Shell Aars",
      "Streetname": "Aggersundvej 77 B",
      "Streetname2": "Pakkeshop: 97746",
      "ZipCode": "9600",
      "CityName": "Aars",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.53939",
      "Latitude": "56.8018"
    },
    {
      "Number": "97762",
      "CompanyName": "Statoil Asnæs",
      "Streetname": "Centervej 1",
      "Streetname2": "Pakkeshop: 97762",
      "ZipCode": "4550",
      "CityName": "Asnæs",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4991",
      "Latitude": "55.8129"
    },
    {
      "Number": "97769",
      "CompanyName": "Uno-X Århus C",
      "Streetname": "Spanien 63",
      "Streetname2": "Pakkeshop: 97769",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2098",
      "Latitude": "56.1489"
    },
    {
      "Number": "97775",
      "CompanyName": "OK Plus Padborg",
      "Streetname": "Lejrvejen 12",
      "Streetname2": "Pakkeshop: 97775",
      "ZipCode": "6330",
      "CityName": "Padborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.34254",
      "Latitude": "54.8352"
    },
    {
      "Number": "97727",
      "CompanyName": "Spar Asferg",
      "Streetname": "Vestergade 16",
      "Streetname2": "Pakkeshop: 97727",
      "ZipCode": "8990",
      "CityName": "Fårup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.9295",
      "Latitude": "56.5465"
    },
    {
      "Number": "97773",
      "CompanyName": "Shell Kjellerup",
      "Streetname": "Thorningvej 8",
      "Streetname2": "Pakkeshop: 97773",
      "ZipCode": "8620",
      "CityName": "Kjellerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.42088",
      "Latitude": "56.2879"
    },
    {
      "Number": "97726",
      "CompanyName": "Spar Ravnkilde",
      "Streetname": "Bygaden 8",
      "Streetname2": "Pakkeshop: 97726",
      "ZipCode": "9610",
      "CityName": "Nørager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.75358",
      "Latitude": "56.7551"
    },
    {
      "Number": "97158",
      "CompanyName": "Shell Ravnstrup",
      "Streetname": "Holstebrovej 141",
      "Streetname2": "Pakkeshop: 97158",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.29052",
      "Latitude": "56.4481"
    },
    {
      "Number": "97544",
      "CompanyName": "Dagli´Brugsen Tornby",
      "Streetname": "Gl.Landevej 7",
      "Streetname2": "Pakkeshop: 97544",
      "ZipCode": "9850",
      "CityName": "Hirtshals",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94906",
      "Latitude": "57.5292"
    },
    {
      "Number": "97790",
      "CompanyName": "Eurospar Snejbjerg",
      "Streetname": "Toustrupvej 2",
      "Streetname2": "Pakkeshop: 97790",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.89891",
      "Latitude": "56.1321"
    },
    {
      "Number": "97787",
      "CompanyName": "SuperBest Bryggervangen",
      "Streetname": "Bryggervangen 17",
      "Streetname2": "Pakkeshop: 97787",
      "ZipCode": "2100",
      "CityName": "København Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.564",
      "Latitude": "55.7101"
    },
    {
      "Number": "97407",
      "CompanyName": "SuperBest Hjørring",
      "Streetname": "Frederikshavnsvej 42-48",
      "Streetname2": "Pakkeshop: 97407",
      "ZipCode": "9800",
      "CityName": "Hjørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.005",
      "Latitude": "57.4552"
    },
    {
      "Number": "97408",
      "CompanyName": "Eurospar Gl. Skagensvej",
      "Streetname": "Gl. Skagensvej 85",
      "Streetname2": "Pakkeshop: 97408",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5284",
      "Latitude": "57.454"
    },
    {
      "Number": "96246",
      "CompanyName": "OK Plus Faaborg",
      "Streetname": "Banegårdspladsen 31",
      "Streetname2": "Pakkeshop: 96246",
      "ZipCode": "5600",
      "CityName": "Faaborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2496",
      "Latitude": "55.0943"
    },
    {
      "Number": "96853",
      "CompanyName": "Galten Kiosk",
      "Streetname": "Nørregade 10",
      "Streetname2": "Pakkeshop: 96853",
      "ZipCode": "8464",
      "CityName": "Galten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.90349",
      "Latitude": "56.1558"
    },
    {
      "Number": "96594",
      "CompanyName": "Super-Kiosken",
      "Streetname": "Niels Kjeldsens Vej 24",
      "Streetname2": "Pakkeshop: 96594",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.6099",
      "Latitude": "56.3528"
    },
    {
      "Number": "96544",
      "CompanyName": "Centrum Kiosken",
      "Streetname": "Bredgade 36",
      "Streetname2": "Pakkeshop: 96544",
      "ZipCode": "8870",
      "CityName": "Langå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.89588",
      "Latitude": "56.3891"
    },
    {
      "Number": "96267",
      "CompanyName": "SuperBrugsen Fuglebjerg",
      "Streetname": "Byagervej 3",
      "Streetname2": "Pakkeshop: 96267",
      "ZipCode": "4250",
      "CityName": "Fuglebjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.5454",
      "Latitude": "55.3024"
    },
    {
      "Number": "96245",
      "CompanyName": "SuperBrugsen Holbæk",
      "Streetname": "Ladegårdsparken Vest 167",
      "Streetname2": "Pakkeshop: 96245",
      "ZipCode": "4300",
      "CityName": "Holbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6989",
      "Latitude": "55.7065"
    },
    {
      "Number": "96858",
      "CompanyName": "Stenløse Boghandel",
      "Streetname": "Egedal Centret 4",
      "Streetname2": "Pakkeshop: 96858",
      "ZipCode": "3660",
      "CityName": "Stenløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.195",
      "Latitude": "55.7678"
    },
    {
      "Number": "97403",
      "CompanyName": "Min Købmand",
      "Streetname": "Ejbymosevej 7",
      "Streetname2": "Pakkeshop: 97403",
      "ZipCode": "2600",
      "CityName": "Glostrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4077",
      "Latitude": "55.6974"
    },
    {
      "Number": "97404",
      "CompanyName": "Shell Hornbæk",
      "Streetname": "Nordre Strandvej 359",
      "Streetname2": "Pakkeshop: 97404",
      "ZipCode": "3100",
      "CityName": "Hornbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4531",
      "Latitude": "56.0895"
    },
    {
      "Number": "97159",
      "CompanyName": "Shell Glamsbjerg",
      "Streetname": "Søndergade 36-38",
      "Streetname2": "Pakkeshop: 97159",
      "ZipCode": "5620",
      "CityName": "Glamsbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1068",
      "Latitude": "55.2762"
    },
    {
      "Number": "97547",
      "CompanyName": "Dagli´Brugsen Tistrup",
      "Streetname": "Torvet 3",
      "Streetname2": "Pakkeshop: 97547",
      "ZipCode": "6862",
      "CityName": "Tistrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.60184",
      "Latitude": "55.7164"
    },
    {
      "Number": "97780",
      "CompanyName": "SuperBest Hjallesevej",
      "Streetname": "Hjallesevej 130-132",
      "Streetname2": "Pakkeshop: 97780",
      "ZipCode": "5230",
      "CityName": "Odense M",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3964",
      "Latitude": "55.3806"
    },
    {
      "Number": "97278",
      "CompanyName": "OK Plus Gilleleje",
      "Streetname": "Bonderupvej 40-42",
      "Streetname2": "Pakkeshop: 97278",
      "ZipCode": "3250",
      "CityName": "Gilleleje",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3293",
      "Latitude": "56.1117"
    },
    {
      "Number": "97772",
      "CompanyName": "Shell Gørlev",
      "Streetname": "Gørlev Landevej 5",
      "Streetname2": "Pakkeshop: 97772",
      "ZipCode": "4281",
      "CityName": "Gørlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2241",
      "Latitude": "55.5346"
    },
    {
      "Number": "97405",
      "CompanyName": "Eurospar Kennedy Arkaden",
      "Streetname": "John F. Kennedys Plads 1",
      "Streetname2": "Pakkeshop: 97405",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91848",
      "Latitude": "57.0418"
    },
    {
      "Number": "97545",
      "CompanyName": "SuperBrugsen Stenlille",
      "Streetname": "Stationsvej 6",
      "Streetname2": "Pakkeshop: 97545",
      "ZipCode": "4295",
      "CityName": "Stenlille",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.5909",
      "Latitude": "55.5388"
    },
    {
      "Number": "97546",
      "CompanyName": "Dagli´Brugsen Flakkebjerg",
      "Streetname": "Hovedgaden 17",
      "Streetname2": "Pakkeshop: 97546",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3956",
      "Latitude": "55.3124"
    },
    {
      "Number": "97776",
      "CompanyName": "Shell Skælskør",
      "Streetname": "Næstvedvej 48",
      "Streetname2": "Pakkeshop: 97776",
      "ZipCode": "4230",
      "CityName": "Skælskør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3065",
      "Latitude": "55.2548"
    },
    {
      "Number": "97424",
      "CompanyName": "Eurospar Farum",
      "Streetname": "Farum Hovedgade 48",
      "Streetname2": "Pakkeshop: 97424",
      "ZipCode": "3520",
      "CityName": "Farum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3667",
      "Latitude": "55.8109"
    },
    {
      "Number": "97426",
      "CompanyName": "Spar Godthåbsvej",
      "Streetname": "Godthåbsvej 142",
      "Streetname2": "Pakkeshop: 97426",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5198",
      "Latitude": "55.6898"
    },
    {
      "Number": "97788",
      "CompanyName": "SuperBest Friheden",
      "Streetname": "Strandmarksvej 20",
      "Streetname2": "Pakkeshop: 97788",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.485",
      "Latitude": "55.6267"
    },
    {
      "Number": "97409",
      "CompanyName": "SuperBest H.C. Ørstedsvej",
      "Streetname": "H.C. Ørsteds Vej 5",
      "Streetname2": "Pakkeshop: 97409",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.497",
      "Latitude": "57.4449"
    },
    {
      "Number": "97418",
      "CompanyName": "SuperBest Hobro",
      "Streetname": "Søndre Ringvej 12",
      "Streetname2": "Pakkeshop: 97418",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.80508",
      "Latitude": "56.627"
    },
    {
      "Number": "97783",
      "CompanyName": "SuperBest Karlslunde",
      "Streetname": "Karlslunde Parkvej 7",
      "Streetname2": "Pakkeshop: 97783",
      "ZipCode": "2690",
      "CityName": "Karlslunde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2662",
      "Latitude": "55.5626"
    },
    {
      "Number": "97818",
      "CompanyName": "7-Eleven Hellerup",
      "Streetname": "strandvejen 151",
      "Streetname2": "Pakkeshop: 97818",
      "ZipCode": "2900",
      "CityName": "Hellerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5759",
      "Latitude": "55.7309"
    },
    {
      "Number": "97781",
      "CompanyName": "Eurospar Tønder",
      "Streetname": "Kongevej 5",
      "Streetname2": "Pakkeshop: 97781",
      "ZipCode": "6270",
      "CityName": "Tønder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.87106",
      "Latitude": "54.9387"
    },
    {
      "Number": "97427",
      "CompanyName": "Døgneren Ulfborg",
      "Streetname": "Holmegade 18",
      "Streetname2": "Pakkeshop: 97427",
      "ZipCode": "6990",
      "CityName": "Ulfborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.32167",
      "Latitude": "56.2737"
    },
    {
      "Number": "97420",
      "CompanyName": "SuperBest Hadsten",
      "Streetname": "Nørregade 2",
      "Streetname2": "Pakkeshop: 97420",
      "ZipCode": "8370",
      "CityName": "Hadsten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0474",
      "Latitude": "56.3281"
    },
    {
      "Number": "97778",
      "CompanyName": "Eurospar Hammel",
      "Streetname": "Østergade 20",
      "Streetname2": "Pakkeshop: 97778",
      "ZipCode": "8450",
      "CityName": "Hammel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.86655",
      "Latitude": "56.2565"
    },
    {
      "Number": "97281",
      "CompanyName": "OK Plus Hobro",
      "Streetname": "Randersvej 20",
      "Streetname2": "Pakkeshop: 97281",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.80056",
      "Latitude": "56.6312"
    },
    {
      "Number": "97422",
      "CompanyName": "SuperBest Skalborg Bakke",
      "Streetname": "Otto Mønsteds Vej 1",
      "Streetname2": "Pakkeshop: 97422",
      "ZipCode": "9200",
      "CityName": "Aalborg SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.89539",
      "Latitude": "57.0147"
    },
    {
      "Number": "97414",
      "CompanyName": "SuperBest Sæby",
      "Streetname": "Stygge Krumpens Vej 2",
      "Streetname2": "Pakkeshop: 97414",
      "ZipCode": "9300",
      "CityName": "Sæby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5033",
      "Latitude": "57.3327"
    },
    {
      "Number": "97819",
      "CompanyName": "Shell Frederikshavn",
      "Streetname": "Danmarksgade 15",
      "Streetname2": "Pakkeshop: 97819",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.539",
      "Latitude": "57.4442"
    },
    {
      "Number": "97820",
      "CompanyName": "Shell Sæby",
      "Streetname": "Ålborgvej 60",
      "Streetname2": "Pakkeshop: 97820",
      "ZipCode": "9300",
      "CityName": "sæby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4996",
      "Latitude": "57.3283"
    },
    {
      "Number": "97792",
      "CompanyName": "SuperBest Herning",
      "Streetname": "Dæmningen 17",
      "Streetname2": "Pakkeshop: 97792",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.96045",
      "Latitude": "56.1326"
    },
    {
      "Number": "97171",
      "CompanyName": "Shell Bregnevej",
      "Streetname": "Bregnevej 5",
      "Streetname2": "Pakkeshop: 97171",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.55839",
      "Latitude": "56.1861"
    },
    {
      "Number": "97168",
      "CompanyName": "Shell Karolinelundsvej",
      "Streetname": "Karolinelundsvej 45",
      "Streetname2": "Pakkeshop: 97168",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.93447",
      "Latitude": "57.0434"
    },
    {
      "Number": "97279",
      "CompanyName": "Ok Plus Bellahøjvej",
      "Streetname": "Bellahøjvej 154",
      "Streetname2": "Pakkeshop: 97279",
      "ZipCode": "2720",
      "CityName": "Vanløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4986",
      "Latitude": "55.6953"
    },
    {
      "Number": "97280",
      "CompanyName": "OK Plus Lysbro",
      "Streetname": "Vestre Ringvej 24",
      "Streetname2": "Pakkeshop: 97280",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.50718",
      "Latitude": "56.162"
    },
    {
      "Number": "97431",
      "CompanyName": "Spillecaféen Gevinsten",
      "Streetname": "Rådhus Allé 12",
      "Streetname2": "Pakkeshop: 97431",
      "ZipCode": "3650",
      "CityName": "Ølstykke",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1578",
      "Latitude": "55.7941"
    },
    {
      "Number": "97789",
      "CompanyName": "SuperBest Lyngby",
      "Streetname": "Lyngby Hovedgade 80",
      "Streetname2": "Pakkeshop: 97789",
      "ZipCode": "2800",
      "CityName": "Kgs. Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5056",
      "Latitude": "55.7688"
    },
    {
      "Number": "97799",
      "CompanyName": "SuperBest Birkerød",
      "Streetname": "Vasevej 119 A",
      "Streetname2": "Pakkeshop: 97799",
      "ZipCode": "3460",
      "CityName": "Birkerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4319",
      "Latitude": "55.8274"
    },
    {
      "Number": "97423",
      "CompanyName": "SuperBest Egedahl Centret",
      "Streetname": "centertorvet 93",
      "Streetname2": "Pakkeshop: 97423",
      "ZipCode": "3660",
      "CityName": "Stenløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.195",
      "Latitude": "55.7682"
    },
    {
      "Number": "97167",
      "CompanyName": "Shell Nørresundby",
      "Streetname": "Løvbakken 2",
      "Streetname2": "Pakkeshop: 97167",
      "ZipCode": "9400",
      "CityName": "Nørresundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92682",
      "Latitude": "57.0712"
    },
    {
      "Number": "97779",
      "CompanyName": "SuperBest Korup",
      "Streetname": "Åbakkevej 69",
      "Streetname2": "Pakkeshop: 97779",
      "ZipCode": "5210",
      "CityName": "Odense NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2725",
      "Latitude": "55.4181"
    },
    {
      "Number": "97428",
      "CompanyName": "Statoil Esbjerg",
      "Streetname": "Sædding Ringvej 6",
      "Streetname2": "Pakkeshop: 97428",
      "ZipCode": "6710",
      "CityName": "Esbjerg V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.40743",
      "Latitude": "55.5036"
    },
    {
      "Number": "97777",
      "CompanyName": "SuperBest Bøsbrovej",
      "Streetname": "Bøsbrovej 54",
      "Streetname2": "Pakkeshop: 97777",
      "ZipCode": "8940",
      "CityName": "Randers SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0385",
      "Latitude": "56.446"
    },
    {
      "Number": "97782",
      "CompanyName": "Eurospar Risskov",
      "Streetname": "Tornebakken 1",
      "Streetname2": "Pakkeshop: 97782",
      "ZipCode": "8240",
      "CityName": "Risskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2124",
      "Latitude": "56.203"
    },
    {
      "Number": "97798",
      "CompanyName": "SuperBest Viborg",
      "Streetname": "Fabrikvej 2",
      "Streetname2": "Pakkeshop: 97798",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.40078",
      "Latitude": "56.4669"
    },
    {
      "Number": "97406",
      "CompanyName": "Eurospar - Løvang shopping center",
      "Streetname": "Løvbakken 4",
      "Streetname2": "Pakkeshop: 97406",
      "ZipCode": "9400",
      "CityName": "Nørresundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92675",
      "Latitude": "57.072"
    },
    {
      "Number": "97436",
      "CompanyName": "Min Købmand Astrup",
      "Streetname": "Højevej 25 B",
      "Streetname2": "Pakkeshop: 97436",
      "ZipCode": "6900",
      "CityName": "Skjern",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.60066",
      "Latitude": "56.0056"
    },
    {
      "Number": "97439",
      "CompanyName": "Bog & Idé Nørrebro Bycenter",
      "Streetname": "Lygten 2, L3",
      "Streetname2": "Pakkeshop: 97439",
      "ZipCode": "2400",
      "CityName": "København NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5376",
      "Latitude": "55.7027"
    },
    {
      "Number": "97549",
      "CompanyName": "Dagli´Brugsen Sejet",
      "Streetname": "Gl. Sognevej 4",
      "Streetname2": "Pakkeshop: 97549",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92799",
      "Latitude": "55.8174"
    },
    {
      "Number": "97166",
      "CompanyName": "Shell Engtoftevej",
      "Streetname": "Engtoftevej 41",
      "Streetname2": "Pakkeshop: 97166",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.89242",
      "Latitude": "57.0538"
    },
    {
      "Number": "97771",
      "CompanyName": "Flügger Farver Hvidovre",
      "Streetname": "Hvidovrevej 94",
      "Streetname2": "Pakkeshop: 97771",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4735",
      "Latitude": "55.6633"
    },
    {
      "Number": "97548",
      "CompanyName": "Dagli´Brugsen Lejre",
      "Streetname": "Bygaden 21",
      "Streetname2": "Pakkeshop: 97548",
      "ZipCode": "4320",
      "CityName": "Lejre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9737",
      "Latitude": "55.604"
    },
    {
      "Number": "97413",
      "CompanyName": "Eurospar Tranekærcenteret",
      "Streetname": "Hobrovej 134",
      "Streetname2": "Pakkeshop: 97413",
      "ZipCode": "8920",
      "CityName": "Randers C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0115",
      "Latitude": "56.4739"
    },
    {
      "Number": "97442",
      "CompanyName": "Spar Hobro",
      "Streetname": "Løgstørvej 3",
      "Streetname2": "Pakkeshop: 97442",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.77969",
      "Latitude": "56.6488"
    },
    {
      "Number": "96872",
      "CompanyName": "Højene Kiosk",
      "Streetname": "Skagensvej 156",
      "Streetname2": "Pakkeshop: 96872",
      "ZipCode": "9800",
      "CityName": "Hjørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.99119",
      "Latitude": "57.4778"
    },
    {
      "Number": "96874",
      "CompanyName": "Actum Grafisk",
      "Streetname": "Vesterbrogade 129",
      "Streetname2": "Pakkeshop: 96874",
      "ZipCode": "1620",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.543",
      "Latitude": "55.6709"
    },
    {
      "Number": "96875",
      "CompanyName": "Bog & Idé Varde",
      "Streetname": "Vestergade 18",
      "Streetname2": "Pakkeshop: 96875",
      "ZipCode": "6800",
      "CityName": "Varde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.47904",
      "Latitude": "55.6213"
    },
    {
      "Number": "96613",
      "CompanyName": "GLS Pakke Shop",
      "Streetname": "Sigma 7",
      "Streetname2": "Pakkeshop: 96613",
      "ZipCode": "8382",
      "CityName": "Hinnerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1083",
      "Latitude": "56.2325"
    },
    {
      "Number": "96882",
      "CompanyName": "Den nye Købmand",
      "Streetname": "Gyrstinge Bygade 26",
      "Streetname2": "Pakkeshop: 96882",
      "ZipCode": "4100",
      "CityName": "Ringsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6848",
      "Latitude": "55.4873"
    },
    {
      "Number": "96885",
      "CompanyName": "LokalBrugsen Fjeldstedvej",
      "Streetname": "Fjeldstedvej 56",
      "Streetname2": "Pakkeshop: 96885",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4619",
      "Latitude": "55.6338"
    },
    {
      "Number": "96254",
      "CompanyName": "OK Kiosken",
      "Streetname": "Algade 18",
      "Streetname2": "Pakkeshop: 96254",
      "ZipCode": "4500",
      "CityName": "Nykøbing Sjælland",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6674",
      "Latitude": "55.9221"
    },
    {
      "Number": "96897",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Storegade 13",
      "Streetname2": "Pakkeshop: 96897",
      "ZipCode": "6430",
      "CityName": "Nordborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.74308",
      "Latitude": "55.0578"
    },
    {
      "Number": "97176",
      "CompanyName": "Bog & Ide Købmagergade",
      "Streetname": "Købmagergade 45",
      "Streetname2": "Pakkeshop: 97176",
      "ZipCode": "1150",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5767",
      "Latitude": "55.6809"
    },
    {
      "Number": "97551",
      "CompanyName": "SuperBrugsen Mariager",
      "Streetname": "Fruensgaard Plads 1",
      "Streetname2": "Pakkeshop: 97551",
      "ZipCode": "9550",
      "CityName": "Mariager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.98217",
      "Latitude": "56.6524"
    },
    {
      "Number": "97793",
      "CompanyName": "SuperBest Præstø",
      "Streetname": "Svend Gønges Torv 9",
      "Streetname2": "Pakkeshop: 97793",
      "ZipCode": "4720",
      "CityName": "Præstø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0386",
      "Latitude": "55.1218"
    },
    {
      "Number": "97445",
      "CompanyName": "Shell Haarby",
      "Streetname": "Akkerupvej 1",
      "Streetname2": "Pakkeshop: 97445",
      "ZipCode": "5683",
      "CityName": "Haarby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.129",
      "Latitude": "55.2232"
    },
    {
      "Number": "97447",
      "CompanyName": "Shell Vejlevej",
      "Streetname": "Vejlevej 168",
      "Streetname2": "Pakkeshop: 97447",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.4571",
      "Latitude": "55.5074"
    },
    {
      "Number": "97449",
      "CompanyName": "Shell Vejlevej",
      "Streetname": "Vejlevej 26",
      "Streetname2": "Pakkeshop: 97449",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.72372",
      "Latitude": "55.5697"
    },
    {
      "Number": "97552",
      "CompanyName": "Dagli´Brugsen Vester Nebel",
      "Streetname": "Koldingvej 29",
      "Streetname2": "Pakkeshop: 97552",
      "ZipCode": "6040",
      "CityName": "Egtved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.40486",
      "Latitude": "55.5653"
    },
    {
      "Number": "97446",
      "CompanyName": "Shell Rønne",
      "Streetname": "Zahrtmannsvej 100",
      "Streetname2": "Pakkeshop: 97446",
      "ZipCode": "3700",
      "CityName": "Rønne",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.7129",
      "Latitude": "55.0975"
    },
    {
      "Number": "97284",
      "CompanyName": "OK Tanken",
      "Streetname": "Kongelundsvej 285",
      "Streetname2": "Pakkeshop: 97284",
      "ZipCode": "2770",
      "CityName": "Kastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5859",
      "Latitude": "55.6174"
    },
    {
      "Number": "97454",
      "CompanyName": "Min Købmand",
      "Streetname": "Bylderup-Bov Bygade 3",
      "Streetname2": "Pakkeshop: 97454",
      "ZipCode": "6372",
      "CityName": "Bylderup-Bov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.08652",
      "Latitude": "54.9419"
    },
    {
      "Number": "97784",
      "CompanyName": "SuperBest Amager",
      "Streetname": "Vermlandsgade 51",
      "Streetname2": "Pakkeshop: 97784",
      "ZipCode": "2300",
      "CityName": "københavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6068",
      "Latitude": "55.6683"
    },
    {
      "Number": "97821",
      "CompanyName": "Shell 7-Eleven Dragør",
      "Streetname": "Kirkevej 177-179",
      "Streetname2": "Pakkeshop: 97821",
      "ZipCode": "2791",
      "CityName": "Dragør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6684",
      "Latitude": "55.5944"
    },
    {
      "Number": "97458",
      "CompanyName": "Shell Kalundborg",
      "Streetname": "Sct. Jørgensbjerg 42",
      "Streetname2": "Pakkeshop: 97458",
      "ZipCode": "4400",
      "CityName": "Kalundborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.101",
      "Latitude": "55.6806"
    },
    {
      "Number": "97451",
      "CompanyName": "Klitmøller Indkøbscenter",
      "Streetname": "Ørhagevej 71",
      "Streetname2": "Pakkeshop: 97451",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.49791",
      "Latitude": "57.0399"
    },
    {
      "Number": "97177",
      "CompanyName": "Eurospar Gjellerup",
      "Streetname": "Præstehaven 22",
      "Streetname2": "Pakkeshop: 97177",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.04548",
      "Latitude": "56.1469"
    },
    {
      "Number": "97164",
      "CompanyName": "Shell Ishøj",
      "Streetname": "Ishøj Parkvej 2",
      "Streetname2": "Pakkeshop: 97164",
      "ZipCode": "2635",
      "CityName": "Ishøj",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3457",
      "Latitude": "55.6178"
    },
    {
      "Number": "97824",
      "CompanyName": "Shell 7-Eleven Hillerød",
      "Streetname": "Frederiksværksgade 87",
      "Streetname2": "Pakkeshop: 97824",
      "ZipCode": "3400",
      "CityName": "Hillerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2802",
      "Latitude": "55.9387"
    },
    {
      "Number": "97450",
      "CompanyName": "Shell Gram",
      "Streetname": "Gammel Skjoldagervej 2",
      "Streetname2": "Pakkeshop: 97450",
      "ZipCode": "6510",
      "CityName": "Gram",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.06107",
      "Latitude": "55.2828"
    },
    {
      "Number": "97174",
      "CompanyName": "Errindlev Købmandshandel",
      "Streetname": "Egelundvej 1",
      "Streetname2": "Pakkeshop: 97174",
      "ZipCode": "4895",
      "CityName": "Errindlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4977",
      "Latitude": "54.6684"
    },
    {
      "Number": "97430",
      "CompanyName": "Super spar Rødby",
      "Streetname": "Østergade 12",
      "Streetname2": "Pakkeshop: 97430",
      "ZipCode": "4970",
      "CityName": "Rødby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3885",
      "Latitude": "54.6956"
    },
    {
      "Number": "97455",
      "CompanyName": "Tips og Lotto Kiosken",
      "Streetname": "Vestervej 15",
      "Streetname2": "Pakkeshop: 97455",
      "ZipCode": "4960",
      "CityName": "Holeby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4713",
      "Latitude": "54.7092"
    },
    {
      "Number": "97173",
      "CompanyName": "Shell Billund",
      "Streetname": "Grindstedvej 10",
      "Streetname2": "Pakkeshop: 97173",
      "ZipCode": "7190",
      "CityName": "Billund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.10409",
      "Latitude": "55.735"
    },
    {
      "Number": "97453",
      "CompanyName": "Shell Odder",
      "Streetname": "Rådhusgade 13",
      "Streetname2": "Pakkeshop: 97453",
      "ZipCode": "8300",
      "CityName": "Odder",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1501",
      "Latitude": "55.9749"
    },
    {
      "Number": "97465",
      "CompanyName": "Eurospar Skagavej",
      "Streetname": "Skagavej 104",
      "Streetname2": "Pakkeshop: 97465",
      "ZipCode": "9990",
      "CityName": "Skagen",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5922",
      "Latitude": "57.7275"
    },
    {
      "Number": "97466",
      "CompanyName": "Eurospar Dokkerbanke",
      "Streetname": "Doggerbanke 2",
      "Streetname2": "Pakkeshop: 97466",
      "ZipCode": "9990",
      "CityName": "Skagen",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5496",
      "Latitude": "57.7296"
    },
    {
      "Number": "97460",
      "CompanyName": "Shell Hedehusene",
      "Streetname": "Roskildevej 335",
      "Streetname2": "Pakkeshop: 97460",
      "ZipCode": "2640",
      "CityName": "Hedehusene",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2214",
      "Latitude": "55.651"
    },
    {
      "Number": "97461",
      "CompanyName": "Shell Osted",
      "Streetname": "Hovedvejen 141",
      "Streetname2": "Pakkeshop: 97461",
      "ZipCode": "4320",
      "CityName": "Lejre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9613",
      "Latitude": "55.5596"
    },
    {
      "Number": "97462",
      "CompanyName": "Shell Roskilde",
      "Streetname": "Søndre Ringvej 26",
      "Streetname2": "Pakkeshop: 97462",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0825",
      "Latitude": "55.6309"
    },
    {
      "Number": "97463",
      "CompanyName": "Eurospar Bjerringbro",
      "Streetname": "Torvegade 5",
      "Streetname2": "Pakkeshop: 97463",
      "ZipCode": "8850",
      "CityName": "Bjerringbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.65766",
      "Latitude": "56.3756"
    },
    {
      "Number": "97483",
      "CompanyName": "Kragenæs Skibsproviantering",
      "Streetname": "Kragenæsvej 82",
      "Streetname2": "Pakkeshop: 97483",
      "ZipCode": "4943",
      "CityName": "Torrig L",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.356",
      "Latitude": "54.9154"
    },
    {
      "Number": "97457",
      "CompanyName": "Shell Middelfart",
      "Streetname": "Hessgade 1",
      "Streetname2": "Pakkeshop: 97457",
      "ZipCode": "5500",
      "CityName": "Middelfart",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.72845",
      "Latitude": "55.5042"
    },
    {
      "Number": "97467",
      "CompanyName": "Shell Grindsted",
      "Streetname": "Vestergade 69",
      "Streetname2": "Pakkeshop: 97467",
      "ZipCode": "7200",
      "CityName": "Grindsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.91525",
      "Latitude": "55.7602"
    },
    {
      "Number": "97825",
      "CompanyName": "Shell 7-Eleven Solrød Strand",
      "Streetname": "Janesvej 9",
      "Streetname2": "Pakkeshop: 97825",
      "ZipCode": "2680",
      "CityName": "Solrød Strand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2068",
      "Latitude": "55.533"
    },
    {
      "Number": "97478",
      "CompanyName": "Shell Vejen",
      "Streetname": "Fr. d. 7´s gade 40",
      "Streetname2": "Pakkeshop: 97478",
      "ZipCode": "6600",
      "CityName": "Vejen",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.14753",
      "Latitude": "55.483"
    },
    {
      "Number": "97456",
      "CompanyName": "SuperBest Domus Vista",
      "Streetname": "Nordens Plads 12",
      "Streetname2": "Pakkeshop: 97456",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.502",
      "Latitude": "55.6711"
    },
    {
      "Number": "97482",
      "CompanyName": "Brød Med Mere",
      "Streetname": "Vangedevej 234",
      "Streetname2": "Pakkeshop: 97482",
      "ZipCode": "2870",
      "CityName": "Dyssegård",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5247",
      "Latitude": "55.7295"
    },
    {
      "Number": "97178",
      "CompanyName": "Shell Haderslevvej",
      "Streetname": "Haderslevvej 189",
      "Streetname2": "Pakkeshop: 97178",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.47103",
      "Latitude": "55.4713"
    },
    {
      "Number": "97468",
      "CompanyName": "Shell Hornslet",
      "Streetname": "Rosenholmsvej 29",
      "Streetname2": "Pakkeshop: 97468",
      "ZipCode": "8543",
      "CityName": "Hornslet",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3226",
      "Latitude": "56.3192"
    },
    {
      "Number": "97469",
      "CompanyName": "Min Købmand Mørke",
      "Streetname": "Ebeltoftvej 20",
      "Streetname2": "Pakkeshop: 97469",
      "ZipCode": "8544",
      "CityName": "Mørke",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3759",
      "Latitude": "56.3376"
    },
    {
      "Number": "97434",
      "CompanyName": "Uno-X Extra Fårevejle",
      "Streetname": "Adelers Allé 142",
      "Streetname2": "Pakkeshop: 97434",
      "ZipCode": "4540",
      "CityName": "Fårevejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4667",
      "Latitude": "55.7863"
    },
    {
      "Number": "97470",
      "CompanyName": "Statoil Egå",
      "Streetname": "Grenåvej 503",
      "Streetname2": "Pakkeshop: 97470",
      "ZipCode": "8250",
      "CityName": "Egå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2898",
      "Latitude": "56.2258"
    },
    {
      "Number": "97163",
      "CompanyName": "Shell Køge",
      "Streetname": "Københavnsvej 110",
      "Streetname2": "Pakkeshop: 97163",
      "ZipCode": "4600",
      "CityName": "Køge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1863",
      "Latitude": "55.4803"
    },
    {
      "Number": "97472",
      "CompanyName": "Min Købmand",
      "Streetname": "Vestergade 69",
      "Streetname2": "Pakkeshop: 97472",
      "ZipCode": "9700",
      "CityName": "Brønderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94062",
      "Latitude": "57.2702"
    },
    {
      "Number": "97474",
      "CompanyName": "Shell Brøndby Park Alle",
      "Streetname": "Park Alle 240",
      "Streetname2": "Pakkeshop: 97474",
      "ZipCode": "2605",
      "CityName": "Brøndby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4054",
      "Latitude": "55.6544"
    },
    {
      "Number": "97826",
      "CompanyName": "Shell 7-Eleven Ballerup",
      "Streetname": "Hedeparken 49",
      "Streetname2": "Pakkeshop: 97826",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3568",
      "Latitude": "55.718"
    },
    {
      "Number": "97459",
      "CompanyName": "Elextra Aalborg",
      "Streetname": "Vesterbro 85",
      "Streetname2": "Pakkeshop: 97459",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91611",
      "Latitude": "57.0492"
    },
    {
      "Number": "97471",
      "CompanyName": "Nærkøb Rughaven",
      "Streetname": "Rughaven 6",
      "Streetname2": "Pakkeshop: 97471",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94751",
      "Latitude": "57.0341"
    },
    {
      "Number": "97473",
      "CompanyName": "Eurospar Horne",
      "Streetname": "Horne Landevej 25A",
      "Streetname2": "Pakkeshop: 97473",
      "ZipCode": "5600",
      "CityName": "Fåborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1703",
      "Latitude": "55.1092"
    },
    {
      "Number": "97556",
      "CompanyName": "LokalBrugsen Vorrevangen",
      "Streetname": "Vorregårds allé 96",
      "Streetname2": "Pakkeshop: 97556",
      "ZipCode": "8200",
      "CityName": "Aarhus N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2028",
      "Latitude": "56.1846"
    },
    {
      "Number": "97559",
      "CompanyName": "Dagli´Brugsen Nr. Jernløse",
      "Streetname": "Nørupvej 16",
      "Streetname2": "Pakkeshop: 97559",
      "ZipCode": "4420",
      "CityName": "Regstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6174",
      "Latitude": "55.6731"
    },
    {
      "Number": "97484",
      "CompanyName": "Uno-X Extra Grenaa",
      "Streetname": "Havnevej 243",
      "Streetname2": "Pakkeshop: 97484",
      "ZipCode": "8500",
      "CityName": "Grenaa",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.9154",
      "Latitude": "56.4099"
    },
    {
      "Number": "97181",
      "CompanyName": "Shell Holte",
      "Streetname": "Kongevejen 394",
      "Streetname2": "Pakkeshop: 97181",
      "ZipCode": "2840",
      "CityName": "Holte",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4685",
      "Latitude": "55.819"
    },
    {
      "Number": "97823",
      "CompanyName": "Shell Hobrovej",
      "Streetname": "Hobrovej 48",
      "Streetname2": "Pakkeshop: 97823",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.90851",
      "Latitude": "57.0342"
    },
    {
      "Number": "97157",
      "CompanyName": "Hos Anita",
      "Streetname": "Storegade 18",
      "Streetname2": "Pakkeshop: 97157",
      "ZipCode": "6880",
      "CityName": "Tarm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.52072",
      "Latitude": "55.9073"
    },
    {
      "Number": "96888",
      "CompanyName": "Kiosk Trekanten",
      "Streetname": "Nørre Boulevard 127",
      "Streetname2": "Pakkeshop: 96888",
      "ZipCode": "4600",
      "CityName": "Køge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1811",
      "Latitude": "55.4672"
    },
    {
      "Number": "96890",
      "CompanyName": "Ok Plus Frederikshavn Øst",
      "Streetname": "Hjørringvej 12",
      "Streetname2": "Pakkeshop: 96890",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5285",
      "Latitude": "57.4486"
    },
    {
      "Number": "96248",
      "CompanyName": "Dagli´Brugsen Nørreby",
      "Streetname": "Bundgårdsballe 24",
      "Streetname2": "Pakkeshop: 96248",
      "ZipCode": "5400",
      "CityName": "Bogense",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2552",
      "Latitude": "55.5909"
    },
    {
      "Number": "96283",
      "CompanyName": "Dagli´Brugsen Blokhus",
      "Streetname": "Torvet 1",
      "Streetname2": "Pakkeshop: 96283",
      "ZipCode": "9492",
      "CityName": "Blokhus",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.58391",
      "Latitude": "57.2519"
    },
    {
      "Number": "97146",
      "CompanyName": "Købmanden i Søllerød",
      "Streetname": "Vangebovej 56",
      "Streetname2": "Pakkeshop: 97146",
      "ZipCode": "2840",
      "CityName": "Holte",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5024",
      "Latitude": "55.8098"
    },
    {
      "Number": "97026",
      "CompanyName": "Arriva",
      "Streetname": "Jernbanegade 29",
      "Streetname2": "Pakkeshop: 97026",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.68814",
      "Latitude": "56.953"
    },
    {
      "Number": "96073",
      "CompanyName": "XL-Byg Mou",
      "Streetname": "Vester Fjordvej 4-6",
      "Streetname2": "Pakkeshop: 96073",
      "ZipCode": "9280",
      "CityName": "Storvorde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.222",
      "Latitude": "56.9683"
    },
    {
      "Number": "97421",
      "CompanyName": "Eurospar Hillerød Øst",
      "Streetname": "Centervænget 9-17",
      "Streetname2": "Pakkeshop: 97421",
      "ZipCode": "3400",
      "CityName": "Hillerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3465",
      "Latitude": "55.9298"
    },
    {
      "Number": "97558",
      "CompanyName": "SuperBrugsen Ubby",
      "Streetname": "Torvet 3",
      "Streetname2": "Pakkeshop: 97558",
      "ZipCode": "4490",
      "CityName": "Jerslev Sjælland",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2133",
      "Latitude": "55.6183"
    },
    {
      "Number": "97479",
      "CompanyName": "Shell Ribe",
      "Streetname": "Bohrsvej 1",
      "Streetname2": "Pakkeshop: 97479",
      "ZipCode": "6760",
      "CityName": "Ribe",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.77772",
      "Latitude": "55.3517"
    },
    {
      "Number": "97480",
      "CompanyName": "Shell Varde",
      "Streetname": "Ribevej 27 B",
      "Streetname2": "Pakkeshop: 97480",
      "ZipCode": "6800",
      "CityName": "Varde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.49313",
      "Latitude": "55.6104"
    },
    {
      "Number": "97481",
      "CompanyName": "Shell Esbjerg",
      "Streetname": "Strandby Plads 100",
      "Streetname2": "Pakkeshop: 97481",
      "ZipCode": "6700",
      "CityName": "Esbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.43643",
      "Latitude": "55.4734"
    },
    {
      "Number": "97477",
      "CompanyName": "Shell Skjern",
      "Streetname": "Østergade 83",
      "Streetname2": "Pakkeshop: 97477",
      "ZipCode": "6900",
      "CityName": "Skjern",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.50435",
      "Latitude": "55.9515"
    },
    {
      "Number": "97417",
      "CompanyName": "Eurospar Skanderborg",
      "Streetname": "Højvang Centret 4",
      "Streetname2": "Pakkeshop: 97417",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.948",
      "Latitude": "56.0445"
    },
    {
      "Number": "97179",
      "CompanyName": "Shell Hellerup",
      "Streetname": "Kildegårdsvej 105",
      "Streetname2": "Pakkeshop: 97179",
      "ZipCode": "2900",
      "CityName": "Hellerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5408",
      "Latitude": "55.7376"
    },
    {
      "Number": "97476",
      "CompanyName": "Shell Roskildevej",
      "Streetname": "Roskildevej 453",
      "Streetname2": "Pakkeshop: 97476",
      "ZipCode": "2605",
      "CityName": "Brøndby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4369",
      "Latitude": "55.6692"
    },
    {
      "Number": "97827",
      "CompanyName": "7-Eleven Holbæk",
      "Streetname": "Gl. Ringstedvej 35",
      "Streetname2": "Pakkeshop: 97827",
      "ZipCode": "4300",
      "CityName": "Holbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.711",
      "Latitude": "55.7066"
    },
    {
      "Number": "97485",
      "CompanyName": "Statoil Nykøbing Sj.",
      "Streetname": "Rørvigvej 3",
      "Streetname2": "Pakkeshop: 97485",
      "ZipCode": "4500",
      "CityName": "Nykøbing Sj.",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6708",
      "Latitude": "55.9265"
    },
    {
      "Number": "97557",
      "CompanyName": "Dagli´Brugsen Bagenkop",
      "Streetname": "Østergade 2 A",
      "Streetname2": "Pakkeshop: 97557",
      "ZipCode": "5935",
      "CityName": "Bagenkop",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.672",
      "Latitude": "54.7499"
    },
    {
      "Number": "97183",
      "CompanyName": "Shell Nybrovej",
      "Streetname": "Nybrovej 190-192",
      "Streetname2": "Pakkeshop: 97183",
      "ZipCode": "2800",
      "CityName": "Kongens Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.489",
      "Latitude": "55.7654"
    },
    {
      "Number": "97487",
      "CompanyName": "Egebjerg Kiosk",
      "Streetname": "Egebjerg Bygade 37 A",
      "Streetname2": "Pakkeshop: 97487",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3776",
      "Latitude": "55.7505"
    },
    {
      "Number": "97560",
      "CompanyName": "Dagli´Brugsen Lindknud",
      "Streetname": "Hovborgvej 31",
      "Streetname2": "Pakkeshop: 97560",
      "ZipCode": "6650",
      "CityName": "Brørup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.01413",
      "Latitude": "55.5669"
    },
    {
      "Number": "97491",
      "CompanyName": "Ordrup Vin og Tobak",
      "Streetname": "Ordrupvej 102",
      "Streetname2": "Pakkeshop: 97491",
      "ZipCode": "2920",
      "CityName": "Charlottenlund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5705",
      "Latitude": "55.7599"
    },
    {
      "Number": "97185",
      "CompanyName": "Shell Svendborgvej",
      "Streetname": "Svendborgvej 85-87",
      "Streetname2": "Pakkeshop: 97185",
      "ZipCode": "5260",
      "CityName": "Odense s",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3989",
      "Latitude": "55.3571"
    },
    {
      "Number": "97184",
      "CompanyName": "Shell Hjallesevej",
      "Streetname": "Hjallesevej 25",
      "Streetname2": "Pakkeshop: 97184",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3961",
      "Latitude": "55.3904"
    },
    {
      "Number": "97187",
      "CompanyName": "Shell Dalumvej",
      "Streetname": "Dalumvej 61-65",
      "Streetname2": "Pakkeshop: 97187",
      "ZipCode": "5250",
      "CityName": "Odense SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3713",
      "Latitude": "55.369"
    },
    {
      "Number": "97489",
      "CompanyName": "Sportigan Kædecenter",
      "Streetname": "Jyllinge Centret 12 D",
      "Streetname2": "Pakkeshop: 97489",
      "ZipCode": "4040",
      "CityName": "Jyllinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1085",
      "Latitude": "55.7498"
    },
    {
      "Number": "97828",
      "CompanyName": "Shell/7-Eleven Nyborgvej",
      "Streetname": "Nyborgvej 114",
      "Streetname2": "Pakkeshop: 97828",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6303",
      "Latitude": "55.0688"
    },
    {
      "Number": "97490",
      "CompanyName": "Super Spar Gjern",
      "Streetname": "Østergade 4",
      "Streetname2": "Pakkeshop: 97490",
      "ZipCode": "8883",
      "CityName": "Gjern",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.73896",
      "Latitude": "56.2302"
    },
    {
      "Number": "97182",
      "CompanyName": "Shell Hjortespringvej",
      "Streetname": "Hjortespringvej 115",
      "Streetname2": "Pakkeshop: 97182",
      "ZipCode": "2730",
      "CityName": "Herlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4317",
      "Latitude": "55.7376"
    },
    {
      "Number": "97494",
      "CompanyName": "Shell Farum",
      "Streetname": "Frederiksborgvej 31",
      "Streetname2": "Pakkeshop: 97494",
      "ZipCode": "3520",
      "CityName": "Farum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3770939",
      "Latitude": "55.811064"
    },
    {
      "Number": "97499",
      "CompanyName": "Shell Helsingør",
      "Streetname": "Kongevejen 115",
      "Streetname2": "Pakkeshop: 97499",
      "ZipCode": "3000",
      "CityName": "Helsingør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5866",
      "Latitude": "56.0259"
    },
    {
      "Number": "97191",
      "CompanyName": "Kiosken Rødby Havn",
      "Streetname": "Havnegade 44",
      "Streetname2": "Pakkeshop: 97191",
      "ZipCode": "4970",
      "CityName": "Rødby Havn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3568",
      "Latitude": "54.6611"
    },
    {
      "Number": "97829",
      "CompanyName": "Shell 7-Eleven Sdr. Borup",
      "Streetname": "Gl. Århusvej 3",
      "Streetname2": "Pakkeshop: 97829",
      "ZipCode": "8940",
      "CityName": "Randers SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.075",
      "Latitude": "56.4129"
    },
    {
      "Number": "97180",
      "CompanyName": "Shell Nærum",
      "Streetname": "Skodsborgvej 313",
      "Streetname2": "Pakkeshop: 97180",
      "ZipCode": "2850",
      "CityName": "Nærum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5363",
      "Latitude": "55.816"
    },
    {
      "Number": "97562",
      "CompanyName": "SuperBrugsen Billund",
      "Streetname": "Butikstorvet 15",
      "Streetname2": "Pakkeshop: 97562",
      "ZipCode": "7190",
      "CityName": "Billund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.11566",
      "Latitude": "55.7296"
    },
    {
      "Number": "97563",
      "CompanyName": "Dagli´´Brugsen Rødding",
      "Streetname": "Kirkegade 21",
      "Streetname2": "Pakkeshop: 97563",
      "ZipCode": "8830",
      "CityName": "Tjele",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.50429",
      "Latitude": "56.5001"
    },
    {
      "Number": "97830",
      "CompanyName": "Shell/ 7-Eleven Nyborg",
      "Streetname": "Kastanievej 2",
      "Streetname2": "Pakkeshop: 97830",
      "ZipCode": "5800",
      "CityName": "Nyborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.7819",
      "Latitude": "55.3036"
    },
    {
      "Number": "97561",
      "CompanyName": "Dagli´´Brugsen Gjerlev",
      "Streetname": "Hammergårdsvej 2",
      "Streetname2": "Pakkeshop: 97561",
      "ZipCode": "8983",
      "CityName": "Gjerlev J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1322",
      "Latitude": "56.5876"
    },
    {
      "Number": "97564",
      "CompanyName": "Dagli´Brugsen Trige",
      "Streetname": "Smedebroen 15",
      "Streetname2": "Pakkeshop: 97564",
      "ZipCode": "8380",
      "CityName": "Trige",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1457",
      "Latitude": "56.2529"
    },
    {
      "Number": "97188",
      "CompanyName": "Shell Tarup",
      "Streetname": "Rugvang 34",
      "Streetname2": "Pakkeshop: 97188",
      "ZipCode": "5210",
      "CityName": "Odense NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3397",
      "Latitude": "55.4102"
    },
    {
      "Number": "97195",
      "CompanyName": "Stationskiosken",
      "Streetname": "Søndergade 2",
      "Streetname2": "Pakkeshop: 97195",
      "ZipCode": "4130",
      "CityName": "Viby Sjælland",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0243",
      "Latitude": "55.5496"
    },
    {
      "Number": "97194",
      "CompanyName": "Spar Nørager",
      "Streetname": "Munkhusevej 9",
      "Streetname2": "Pakkeshop: 97194",
      "ZipCode": "8961",
      "CityName": "Allingåbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5055",
      "Latitude": "56.4772"
    },
    {
      "Number": "97186",
      "CompanyName": "Shell Ejbygade",
      "Streetname": "Ejbygade 2",
      "Streetname2": "Pakkeshop: 97186",
      "ZipCode": "5220",
      "CityName": "Odense SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4217",
      "Latitude": "55.3935"
    },
    {
      "Number": "97831",
      "CompanyName": "Shell Ballerup",
      "Streetname": "Hold-An Vej 2",
      "Streetname2": "Pakkeshop: 97831",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3623",
      "Latitude": "55.7356"
    },
    {
      "Number": "97492",
      "CompanyName": "Shell Frederikssund",
      "Streetname": "Askelundsvej 1",
      "Streetname2": "Pakkeshop: 97492",
      "ZipCode": "3600",
      "CityName": "Frederikssund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0738",
      "Latitude": "55.8439"
    },
    {
      "Number": "97493",
      "CompanyName": "Shell Ølstykke",
      "Streetname": "Frederikssundsvej 225",
      "Streetname2": "Pakkeshop: 97493",
      "ZipCode": "3650",
      "CityName": "Ølstykke",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1739",
      "Latitude": "55.779"
    },
    {
      "Number": "97832",
      "CompanyName": "Shell Vordingborg",
      "Streetname": "Algade 133",
      "Streetname2": "Pakkeshop: 97832",
      "ZipCode": "4760",
      "CityName": "Vordingborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9155",
      "Latitude": "55.0071"
    },
    {
      "Number": "97486",
      "CompanyName": "Kwik Spar Thise",
      "Streetname": "Sundsørevej 91",
      "Streetname2": "Pakkeshop: 97486",
      "ZipCode": "7870",
      "CityName": "Roslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.12624",
      "Latitude": "56.7036"
    },
    {
      "Number": "97193",
      "CompanyName": "Min Købmand St. Andst",
      "Streetname": "Mark Dannersvej 23",
      "Streetname2": "Pakkeshop: 97193",
      "ZipCode": "6600",
      "CityName": "Vejen",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.23304",
      "Latitude": "55.4824"
    },
    {
      "Number": "97893",
      "CompanyName": "Shell Horsensvej",
      "Streetname": "Horsensvej 78",
      "Streetname2": "Pakkeshop: 97893",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.56273",
      "Latitude": "55.7192"
    },
    {
      "Number": "96259",
      "CompanyName": "Kiosk 36",
      "Streetname": "Kongelundsvej 36",
      "Streetname2": "Pakkeshop: 96259",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5888",
      "Latitude": "55.6399"
    },
    {
      "Number": "96290",
      "CompanyName": "Dagli´Brugsen Bisserup",
      "Streetname": "Bisserup Byvej 3",
      "Streetname2": "Pakkeshop: 96290",
      "ZipCode": "4243",
      "CityName": "Rude",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4956",
      "Latitude": "55.2073"
    },
    {
      "Number": "96261",
      "CompanyName": "SuperBrugsen Vester Hassing",
      "Streetname": "Springvandspladsen 2",
      "Streetname2": "Pakkeshop: 96261",
      "ZipCode": "9310",
      "CityName": "Vodskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1295",
      "Latitude": "57.0664"
    },
    {
      "Number": "96540",
      "CompanyName": "Hvidovre Sport",
      "Streetname": "Hvidovrevej 158",
      "Streetname2": "Pakkeshop: 96540",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4734",
      "Latitude": "55.655"
    },
    {
      "Number": "96538",
      "CompanyName": "Spar Silkeborg",
      "Streetname": "Balle Bygade 2",
      "Streetname2": "Pakkeshop: 96538",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.52288",
      "Latitude": "56.1966"
    },
    {
      "Number": "96550",
      "CompanyName": "Købmanden På Boulevarden",
      "Streetname": "Boulevarden 33",
      "Streetname2": "Pakkeshop: 96550",
      "ZipCode": "9000",
      "CityName": "Ålborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91833",
      "Latitude": "57.0448"
    },
    {
      "Number": "96546",
      "CompanyName": "Amagerbro Kiosk",
      "Streetname": "Amagerbrogade 5",
      "Streetname2": "Pakkeshop: 96546",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5968",
      "Latitude": "55.6685"
    },
    {
      "Number": "97614",
      "CompanyName": "OK Plus Stubbekøbing",
      "Streetname": "Nykøbingvej 50",
      "Streetname2": "Pakkeshop: 97614",
      "ZipCode": "4850",
      "CityName": "Stubbekøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.036",
      "Latitude": "54.886"
    },
    {
      "Number": "96253",
      "CompanyName": "Flügger Farver Søborg",
      "Streetname": "Søborg Hovedgade 49",
      "Streetname2": "Pakkeshop: 96253",
      "ZipCode": "2860",
      "CityName": "Søborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5185",
      "Latitude": "55.7321"
    },
    {
      "Number": "96563",
      "CompanyName": "Ellegaard´s",
      "Streetname": "Hovedgaden 6",
      "Streetname2": "Pakkeshop: 96563",
      "ZipCode": "4330",
      "CityName": "Hvalsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8626",
      "Latitude": "55.5943"
    },
    {
      "Number": "97211",
      "CompanyName": "OK Plus Roskilde",
      "Streetname": "Helligkorsvej 6 B",
      "Streetname2": "Pakkeshop: 97211",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0706",
      "Latitude": "55.6394"
    },
    {
      "Number": "96258",
      "CompanyName": "Nærkøb Center Kiosken",
      "Streetname": "Vendsysselvej 5C",
      "Streetname2": "Pakkeshop: 96258",
      "ZipCode": "4800",
      "CityName": "Nykøbing F",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8908",
      "Latitude": "54.755"
    },
    {
      "Number": "96256",
      "CompanyName": "Grenå Nærkøb",
      "Streetname": "Bavnehøjvej 6",
      "Streetname2": "Pakkeshop: 96256",
      "ZipCode": "8500",
      "CityName": "Grenå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.8676",
      "Latitude": "56.4179"
    },
    {
      "Number": "96548",
      "CompanyName": "SuperBest Allerød",
      "Streetname": "Kirsebærgården 2-22",
      "Streetname2": "Pakkeshop: 96548",
      "ZipCode": "3450",
      "CityName": "Allerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3322",
      "Latitude": "55.8666"
    },
    {
      "Number": "97899",
      "CompanyName": "Shell Glumsø",
      "Streetname": "Østergade 1",
      "Streetname2": "Pakkeshop: 97899",
      "ZipCode": "4171",
      "CityName": "Glumsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6918",
      "Latitude": "55.3533"
    },
    {
      "Number": "95001",
      "CompanyName": "Statoil Søften",
      "Streetname": "Århusvej 60",
      "Streetname2": "Pakkeshop: 95001",
      "ZipCode": "8382",
      "CityName": "Hinnerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.09",
      "Latitude": "56.2374"
    },
    {
      "Number": "97842",
      "CompanyName": "7- Eleven Istedgade",
      "Streetname": "Istedgade 2",
      "Streetname2": "Pakkeshop: 97842",
      "ZipCode": "1650",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5631",
      "Latitude": "55.6723"
    },
    {
      "Number": "97872",
      "CompanyName": "7-Eleven Tarup",
      "Streetname": "Rugårdsvej 280",
      "Streetname2": "Pakkeshop: 97872",
      "ZipCode": "5210",
      "CityName": "Odense NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3332",
      "Latitude": "55.4096"
    },
    {
      "Number": "95023",
      "CompanyName": "YX Hvam",
      "Streetname": "Hannerupvej 17",
      "Streetname2": "Pakkeshop: 95023",
      "ZipCode": "9620",
      "CityName": "Aalestrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.52265",
      "Latitude": "56.6654"
    },
    {
      "Number": "97285",
      "CompanyName": "OK Plus Helsingør",
      "Streetname": "Esrumvej 90",
      "Streetname2": "Pakkeshop: 97285",
      "ZipCode": "3000",
      "CityName": "Helsingør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5872",
      "Latitude": "56.0408"
    },
    {
      "Number": "97572",
      "CompanyName": "Dagli´Brugsen Vestermarie",
      "Streetname": "Vestermarievej 32",
      "Streetname2": "Pakkeshop: 97572",
      "ZipCode": "3700",
      "CityName": "Rønne",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.8217",
      "Latitude": "55.1066"
    },
    {
      "Number": "97870",
      "CompanyName": "7-Eleven Stationscentret",
      "Streetname": "Stationscentret 5",
      "Streetname2": "Pakkeshop: 97870",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0853",
      "Latitude": "55.6379"
    },
    {
      "Number": "97873",
      "CompanyName": "Shell 7-Eleven Ørbækvej",
      "Streetname": "Ørbækvej 87",
      "Streetname2": "Pakkeshop: 97873",
      "ZipCode": "5220",
      "CityName": "Odense SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4308",
      "Latitude": "55.3823"
    },
    {
      "Number": "97879",
      "CompanyName": "Shell 7-Eleven Diagonalvejen",
      "Streetname": "Diagonalvejen 33",
      "Streetname2": "Pakkeshop: 97879",
      "ZipCode": "7323",
      "CityName": "Give",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.24648",
      "Latitude": "55.8549"
    },
    {
      "Number": "97889",
      "CompanyName": "7-Eleven Jomfru Ane Gade",
      "Streetname": "Jomfru Ane Gade 2",
      "Streetname2": "Pakkeshop: 97889",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91858",
      "Latitude": "57.0494"
    },
    {
      "Number": "97890",
      "CompanyName": "7-Eleven Reberbansgade",
      "Streetname": "Reberbansgade 16 B",
      "Streetname2": "Pakkeshop: 97890",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91258",
      "Latitude": "57.0496"
    },
    {
      "Number": "97891",
      "CompanyName": "Shell 7-Eleven Østergade",
      "Streetname": "Østergade 27-29",
      "Streetname2": "Pakkeshop: 97891",
      "ZipCode": "9400",
      "CityName": "Nørresundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92832",
      "Latitude": "57.0588"
    },
    {
      "Number": "97892",
      "CompanyName": "Shell 7-Eleven Sprogøvej",
      "Streetname": "Sprogøvej 1",
      "Streetname2": "Pakkeshop: 97892",
      "ZipCode": "9800",
      "CityName": "Hjørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0414",
      "Latitude": "57.4558"
    },
    {
      "Number": "97865",
      "CompanyName": "Shell 7-Eleven Kongevejen",
      "Streetname": "Kongevejen 242",
      "Streetname2": "Pakkeshop: 97865",
      "ZipCode": "2830",
      "CityName": "Virum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4825",
      "Latitude": "55.7969"
    },
    {
      "Number": "97869",
      "CompanyName": "Shell 7-Eleven Frederikssundsvej",
      "Streetname": "Frederikssundsvej 175",
      "Streetname2": "Pakkeshop: 97869",
      "ZipCode": "3660",
      "CityName": "Stenløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2009",
      "Latitude": "55.7691"
    },
    {
      "Number": "97881",
      "CompanyName": "Shell 7-Eleven Viborgvej",
      "Streetname": "Viborgvej 4 D",
      "Streetname2": "Pakkeshop: 97881",
      "ZipCode": "7800",
      "CityName": "Skive",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.03841",
      "Latitude": "56.5631"
    },
    {
      "Number": "95005",
      "CompanyName": "DSB 7-Eleven Jernbanegade",
      "Streetname": "Jernbanegade 29",
      "Streetname2": "Pakkeshop: 95005",
      "ZipCode": "8900",
      "CityName": "Randers C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0219",
      "Latitude": "56.462"
    },
    {
      "Number": "97888",
      "CompanyName": "Shell 7-Eleven Havkærvej",
      "Streetname": "Havkærvej 114",
      "Streetname2": "Pakkeshop: 97888",
      "ZipCode": "8381",
      "CityName": "Tilst/Mundelstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1225",
      "Latitude": "56.1823"
    },
    {
      "Number": "95012",
      "CompanyName": "Shell Dalby",
      "Streetname": "Vordingborgvej 424",
      "Streetname2": "Pakkeshop: 95012",
      "ZipCode": "4690",
      "CityName": "Haslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0497",
      "Latitude": "55.3098"
    },
    {
      "Number": "97835",
      "CompanyName": "7-Eleven Torvegade",
      "Streetname": "Torvegade 49",
      "Streetname2": "Pakkeshop: 97835",
      "ZipCode": "1400",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5924",
      "Latitude": "55.672"
    },
    {
      "Number": "97839",
      "CompanyName": "7-Eleven Ved Vesterport",
      "Streetname": "Ved Vesterport 3",
      "Streetname2": "Pakkeshop: 97839",
      "ZipCode": "1612",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.563",
      "Latitude": "55.6755"
    },
    {
      "Number": "97858",
      "CompanyName": "Shell 7-Eleven Egelundsvej",
      "Streetname": "Egelundsvej 5",
      "Streetname2": "Pakkeshop: 97858",
      "ZipCode": "2620",
      "CityName": "Albertslund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3325",
      "Latitude": "55.6609"
    },
    {
      "Number": "97196",
      "CompanyName": "Tanken Nærkøb",
      "Streetname": "Assensvej 218",
      "Streetname2": "Pakkeshop: 97196",
      "ZipCode": "5771",
      "CityName": "Stenstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5001",
      "Latitude": "55.1299"
    },
    {
      "Number": "97877",
      "CompanyName": "Shell 7-Eleven Sønderborg",
      "Streetname": "Nørrekobbel 23",
      "Streetname2": "Pakkeshop: 97877",
      "ZipCode": "6400",
      "CityName": "Sønderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.80665",
      "Latitude": "54.924"
    },
    {
      "Number": "97878",
      "CompanyName": "Shell 7-Eleven Stormgade",
      "Streetname": "Stormgade 206",
      "Streetname2": "Pakkeshop: 97878",
      "ZipCode": "6700",
      "CityName": "Esbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.44897",
      "Latitude": "55.4871"
    },
    {
      "Number": "95006",
      "CompanyName": "DSB 7-Eleven Holstebro",
      "Streetname": "Stationsvej 15",
      "Streetname2": "Pakkeshop: 95006",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.62088",
      "Latitude": "56.3654"
    },
    {
      "Number": "95020",
      "CompanyName": "Toreby Købmandshandel",
      "Streetname": "Torebyvej 25",
      "Streetname2": "Pakkeshop: 95020",
      "ZipCode": "4891",
      "CityName": "Toreby L",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7824",
      "Latitude": "54.7551"
    },
    {
      "Number": "97852",
      "CompanyName": "7-Eleven Amagerbrogade 43",
      "Streetname": "Amagerbrogade 43",
      "Streetname2": "Pakkeshop: 97852",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6012",
      "Latitude": "55.664"
    },
    {
      "Number": "97871",
      "CompanyName": "Shell 7-Eleven Næsbyvej",
      "Streetname": "Næsbyvej 51",
      "Streetname2": "Pakkeshop: 97871",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3691",
      "Latitude": "55.411"
    },
    {
      "Number": "95021",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Skomagergade 1",
      "Streetname2": "Pakkeshop: 95021",
      "ZipCode": "9240",
      "CityName": "Nibe",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.63688",
      "Latitude": "56.9818"
    },
    {
      "Number": "95024",
      "CompanyName": "Kwik Spar Rørbæk",
      "Streetname": "Skovmosevej 1",
      "Streetname2": "Pakkeshop: 95024",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.71421",
      "Latitude": "56.7059"
    },
    {
      "Number": "97880",
      "CompanyName": "Shell 7-Eleven Thisted",
      "Streetname": "Østerbakken 64",
      "Streetname2": "Pakkeshop: 97880",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.7068",
      "Latitude": "56.9569"
    },
    {
      "Number": "97574",
      "CompanyName": "Dagli´Brugsen Pindstrup",
      "Streetname": "Storegade 62",
      "Streetname2": "Pakkeshop: 97574",
      "ZipCode": "8550",
      "CityName": "Ryomgård",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4113",
      "Latitude": "56.3934"
    },
    {
      "Number": "97886",
      "CompanyName": "7-Eleven Risskov",
      "Streetname": "Grenåvej 189",
      "Streetname2": "Pakkeshop: 97886",
      "ZipCode": "8240",
      "CityName": "Risskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2192",
      "Latitude": "56.1954"
    },
    {
      "Number": "97856",
      "CompanyName": "7-Eleven Toftegårds Alle",
      "Streetname": "Toftegårds Alle 34",
      "Streetname2": "Pakkeshop: 97856",
      "ZipCode": "2500",
      "CityName": "Valby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5161",
      "Latitude": "55.6632"
    },
    {
      "Number": "95022",
      "CompanyName": "OK Plus Linde",
      "Streetname": "Vilhelmsborgvej 45",
      "Streetname2": "Pakkeshop: 95022",
      "ZipCode": "7600",
      "CityName": "Struer",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.48511",
      "Latitude": "56.416"
    },
    {
      "Number": "95030",
      "CompanyName": "Rækker Mølle Købmand",
      "Streetname": "Søvejen 3",
      "Streetname2": "Pakkeshop: 95030",
      "ZipCode": "6900",
      "CityName": "Skjern",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.53631",
      "Latitude": "56.0216"
    },
    {
      "Number": "95026",
      "CompanyName": "Statoil Maribo",
      "Streetname": "Vesterbrogade 45",
      "Streetname2": "Pakkeshop: 95026",
      "ZipCode": "4930",
      "CityName": "Maribo",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4885",
      "Latitude": "54.7753"
    },
    {
      "Number": "97845",
      "CompanyName": "7-Eleven Falkoner Alle 11",
      "Streetname": "Falkoner Alle 11",
      "Streetname2": "Pakkeshop: 97845",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5337",
      "Latitude": "55.68"
    },
    {
      "Number": "97853",
      "CompanyName": "7-Eleven Artillerivej",
      "Streetname": "Artillerivej 50",
      "Streetname2": "Pakkeshop: 97853",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5835",
      "Latitude": "55.6643"
    },
    {
      "Number": "97855",
      "CompanyName": "7-Eleven Frederikssundsvej",
      "Streetname": "Frederikssundsvej 3",
      "Streetname2": "Pakkeshop: 97855",
      "ZipCode": "2400",
      "CityName": "København NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5374",
      "Latitude": "55.7009"
    },
    {
      "Number": "97864",
      "CompanyName": "7-Eleven Lyngby Storcenter",
      "Streetname": "Lyngby Storcenter 61",
      "Streetname2": "Pakkeshop: 97864",
      "ZipCode": "2800",
      "CityName": "Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5066",
      "Latitude": "55.7725"
    },
    {
      "Number": "95029",
      "CompanyName": "Tousparkens Kiosk",
      "Streetname": "Tousparken 1",
      "Streetname2": "Pakkeshop: 95029",
      "ZipCode": "8230",
      "CityName": "Åbyhøj",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1543",
      "Latitude": "56.149"
    },
    {
      "Number": "95033",
      "CompanyName": "Østerhøj Nærkøb",
      "Streetname": "Østerhøj Bygade 123 A",
      "Streetname2": "Pakkeshop: 95033",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3362",
      "Latitude": "55.7496"
    },
    {
      "Number": "97003",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Over Bølgen 1",
      "Streetname2": "Pakkeshop: 97003",
      "ZipCode": "2670",
      "CityName": "Greve",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3255",
      "Latitude": "55.5987"
    },
    {
      "Number": "97005",
      "CompanyName": "Bilka Servicecenter",
      "Streetname": "Ishøj Lille Torv 1",
      "Streetname2": "Pakkeshop: 97005",
      "ZipCode": "2635",
      "CityName": "Ishøj",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3545",
      "Latitude": "55.6144"
    },
    {
      "Number": "97006",
      "CompanyName": "Bilka servicecenter",
      "Streetname": "Idagårdsvej 1",
      "Streetname2": "Pakkeshop: 97006",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3536",
      "Latitude": "55.3911"
    },
    {
      "Number": "97013",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Arne Jacobsens Alle 24",
      "Streetname2": "Pakkeshop: 97013",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5795",
      "Latitude": "55.631"
    },
    {
      "Number": "97007",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Næstved Storcenter 1",
      "Streetname2": "Pakkeshop: 97007",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7796",
      "Latitude": "55.2519"
    },
    {
      "Number": "97004",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Niels Bohrs Alle 150",
      "Streetname2": "Pakkeshop: 97004",
      "ZipCode": "5230",
      "CityName": "Odense M",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.432",
      "Latitude": "55.3771"
    },
    {
      "Number": "97009",
      "CompanyName": "Bilka Kundeservice",
      "Streetname": "Stormgade 157",
      "Streetname2": "Pakkeshop: 97009",
      "ZipCode": "6715",
      "CityName": "Esbjerg N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.45627",
      "Latitude": "55.5111"
    },
    {
      "Number": "97010",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Solkilde Alle 2",
      "Streetname2": "Pakkeshop: 97010",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.58114",
      "Latitude": "55.7247"
    },
    {
      "Number": "97011",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Skovvangen 40",
      "Streetname2": "Pakkeshop: 97011",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.45912",
      "Latitude": "55.5119"
    },
    {
      "Number": "97012",
      "CompanyName": "Bilka Servicecenter",
      "Streetname": "Høegh Guldbergs Gade 10",
      "Streetname2": "Pakkeshop: 97012",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.8542",
      "Latitude": "55.8591"
    },
    {
      "Number": "97015",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Grundtvigsalle 195",
      "Streetname2": "Pakkeshop: 97015",
      "ZipCode": "6400",
      "CityName": "Sønderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.80794",
      "Latitude": "54.9233"
    },
    {
      "Number": "97008",
      "CompanyName": "Bilka servicecentret - vareudlevering",
      "Streetname": "lundholmvej 7",
      "Streetname2": "Pakkeshop: 97008",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.61739",
      "Latitude": "56.3787"
    },
    {
      "Number": "97016",
      "CompanyName": "Bilka servicecenter",
      "Streetname": "Golfvej 5",
      "Streetname2": "Pakkeshop: 97016",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.00492",
      "Latitude": "56.1362"
    },
    {
      "Number": "97001",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Agerøvej 7",
      "Streetname2": "Pakkeshop: 97001",
      "ZipCode": "8381",
      "CityName": "Tilst/Mundelstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1048",
      "Latitude": "56.1824"
    },
    {
      "Number": "97014",
      "CompanyName": "Bilka Servicecenter",
      "Streetname": "Holstebrovej 79",
      "Streetname2": "Pakkeshop: 97014",
      "ZipCode": "8800",
      "CityName": "viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.36734",
      "Latitude": "56.4476"
    },
    {
      "Number": "97002",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Hobrovej 450",
      "Streetname2": "Pakkeshop: 97002",
      "ZipCode": "9200",
      "CityName": "Aalborg SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.8761",
      "Latitude": "57.0047"
    },
    {
      "Number": "95057",
      "CompanyName": "7-Eleven Vesterbrogade 77",
      "Streetname": "Vesterbrogade 77",
      "Streetname2": "Pakkeshop: 95057",
      "ZipCode": "1620",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5493",
      "Latitude": "55.6725"
    },
    {
      "Number": "95059",
      "CompanyName": "Superbest Frederiksværk",
      "Streetname": "Nørregade 38",
      "Streetname2": "Pakkeshop: 95059",
      "ZipCode": "3300",
      "CityName": "Frederiksværk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0196",
      "Latitude": "55.9758"
    },
    {
      "Number": "95065",
      "CompanyName": "Eurospar Hadsund",
      "Streetname": "Butikstorvet 4",
      "Streetname2": "Pakkeshop: 95065",
      "ZipCode": "9560",
      "CityName": "Hadsund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1137",
      "Latitude": "56.718"
    },
    {
      "Number": "95066",
      "CompanyName": "Din Tøjmand Kongerslev",
      "Streetname": "Danmarksgade 12",
      "Streetname2": "Pakkeshop: 95066",
      "ZipCode": "9293",
      "CityName": "Kongerslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1141",
      "Latitude": "56.887"
    },
    {
      "Number": "97587",
      "CompanyName": "Dagli´Brugsen Hou",
      "Streetname": "Østergade 80",
      "Streetname2": "Pakkeshop: 97587",
      "ZipCode": "5953",
      "CityName": "Tranekær",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.9203",
      "Latitude": "55.1333"
    },
    {
      "Number": "95068",
      "CompanyName": "Min Købmand",
      "Streetname": "Østergade 2",
      "Streetname2": "Pakkeshop: 95068",
      "ZipCode": "6823",
      "CityName": "Ansager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.75425",
      "Latitude": "55.7046"
    },
    {
      "Number": "97588",
      "CompanyName": "Dagli´Brugsen Bryrup",
      "Streetname": "Hovedgaden 13",
      "Streetname2": "Pakkeshop: 97588",
      "ZipCode": "8654",
      "CityName": "Bryrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.51134",
      "Latitude": "56.0245"
    },
    {
      "Number": "95063",
      "CompanyName": "Kattegat Købmanden Overby Lyng",
      "Streetname": "Oddenvej 137",
      "Streetname2": "Pakkeshop: 95063",
      "ZipCode": "4583",
      "CityName": "Sjællands Odde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4606",
      "Latitude": "55.9601"
    },
    {
      "Number": "97585",
      "CompanyName": "Dagli´Brugsen Boeslunde",
      "Streetname": "Boeslunde Byvej 137",
      "Streetname2": "Pakkeshop: 97585",
      "ZipCode": "4242",
      "CityName": "Boeslunde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2673",
      "Latitude": "55.304"
    },
    {
      "Number": "95062",
      "CompanyName": "Harre Købmand",
      "Streetname": "Sallingsundvej 122",
      "Streetname2": "Pakkeshop: 95062",
      "ZipCode": "7870",
      "CityName": "Roslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.92484",
      "Latitude": "56.7137"
    },
    {
      "Number": "95070",
      "CompanyName": "Spar Sallerup",
      "Streetname": "Sallerup Gade 2",
      "Streetname2": "Pakkeshop: 95070",
      "ZipCode": "4750",
      "CityName": "Lundby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8244",
      "Latitude": "55.0843"
    },
    {
      "Number": "97586",
      "CompanyName": "Dagli´Brugsen Sundhøj",
      "Streetname": "Solvej 1",
      "Streetname2": "Pakkeshop: 97586",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6119",
      "Latitude": "55.0397"
    },
    {
      "Number": "95074",
      "CompanyName": "Statoil Struer",
      "Streetname": "Holstebrovej 56",
      "Streetname2": "Pakkeshop: 95074",
      "ZipCode": "7600",
      "CityName": "Struer",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.58346",
      "Latitude": "56.4888"
    },
    {
      "Number": "95073",
      "CompanyName": "Superbest Rønde",
      "Streetname": "Hovedgaden 49",
      "Streetname2": "Pakkeshop: 95073",
      "ZipCode": "8410",
      "CityName": "Rønde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4758",
      "Latitude": "56.3006"
    },
    {
      "Number": "95072",
      "CompanyName": "Ecez Slik",
      "Streetname": "Vigerslevvej 67",
      "Streetname2": "Pakkeshop: 95072",
      "ZipCode": "2500",
      "CityName": "Valby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4865",
      "Latitude": "55.6669"
    },
    {
      "Number": "95077",
      "CompanyName": "Sportigan",
      "Streetname": "Storegade 20 B",
      "Streetname2": "Pakkeshop: 95077",
      "ZipCode": "8382",
      "CityName": "Hinnerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0634699",
      "Latitude": "56.2649193"
    },
    {
      "Number": "95105",
      "CompanyName": "Shell København SV",
      "Streetname": "Borgmester Christiansens Gade 59",
      "Streetname2": "Pakkeshop: 95105",
      "ZipCode": "2450",
      "CityName": "København SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5411",
      "Latitude": "55.6471"
    },
    {
      "Number": "97290",
      "CompanyName": "OK Plus Kongsted",
      "Streetname": "Bøgevej 1",
      "Streetname2": "Pakkeshop: 97290",
      "ZipCode": "4683",
      "CityName": "Rønnede",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0242",
      "Latitude": "55.2583"
    },
    {
      "Number": "95108",
      "CompanyName": "Statoil",
      "Streetname": "Odensevej 136",
      "Streetname2": "Pakkeshop: 95108",
      "ZipCode": "5400",
      "CityName": "Bogense",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.092",
      "Latitude": "55.5512"
    },
    {
      "Number": "95102",
      "CompanyName": "Statoil Helsinge",
      "Streetname": "Rundinsvej 52",
      "Streetname2": "Pakkeshop: 95102",
      "ZipCode": "3200",
      "CityName": "Helsinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1986",
      "Latitude": "56.016"
    },
    {
      "Number": "97594",
      "CompanyName": "Dagli´Brugsen Rødovre",
      "Streetname": "Islevbrovej 24",
      "Streetname2": "Pakkeshop: 97594",
      "ZipCode": "2610",
      "CityName": "Rødovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4472",
      "Latitude": "55.7052"
    },
    {
      "Number": "95095",
      "CompanyName": "Spar Agerskov",
      "Streetname": "Hovedgaden 14",
      "Streetname2": "Pakkeshop: 95095",
      "ZipCode": "6534",
      "CityName": "Agerskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.13014",
      "Latitude": "55.1299"
    },
    {
      "Number": "96565",
      "CompanyName": "Min Købmand Tandslet",
      "Streetname": "Mommarksvej 268",
      "Streetname2": "Pakkeshop: 96565",
      "ZipCode": "6470",
      "CityName": "Sydals",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.97036",
      "Latitude": "54.9259"
    },
    {
      "Number": "96569",
      "CompanyName": "Bøger & Papir",
      "Streetname": "Nærumvænge Torv 16",
      "Streetname2": "Pakkeshop: 96569",
      "ZipCode": "2850",
      "CityName": "Nærum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5297",
      "Latitude": "55.8144"
    },
    {
      "Number": "97638",
      "CompanyName": "Electronics Center",
      "Streetname": "Strandbygade 33",
      "Streetname2": "Pakkeshop: 97638",
      "ZipCode": "6700",
      "CityName": "Esbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.43986",
      "Latitude": "55.4699"
    },
    {
      "Number": "97331",
      "CompanyName": "Hafnia Foto",
      "Streetname": "Nørrebrogade 30",
      "Streetname2": "Pakkeshop: 97331",
      "ZipCode": "2200",
      "CityName": "København N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.559",
      "Latitude": "55.6886"
    },
    {
      "Number": "97321",
      "CompanyName": "Spar Rostrup",
      "Streetname": "Lundgårdvej 2",
      "Streetname2": "Pakkeshop: 97321",
      "ZipCode": "9510",
      "CityName": "Arden",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.9329",
      "Latitude": "56.7313"
    },
    {
      "Number": "97398",
      "CompanyName": "Centerkiosken",
      "Streetname": "Nørreallé 7",
      "Streetname2": "Pakkeshop: 97398",
      "ZipCode": "8362",
      "CityName": "Hørning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0367",
      "Latitude": "56.0861"
    },
    {
      "Number": "97332",
      "CompanyName": "OK Tanken",
      "Streetname": "Hovedgaden 1",
      "Streetname2": "Pakkeshop: 97332",
      "ZipCode": "8831",
      "CityName": "Løgstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.3419",
      "Latitude": "56.5027"
    },
    {
      "Number": "96286",
      "CompanyName": "SuperBrugsen Nørre Aaby",
      "Streetname": "Grønnegade 12",
      "Streetname2": "Pakkeshop: 96286",
      "ZipCode": "5580",
      "CityName": "Nørre Aaby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.87745",
      "Latitude": "55.4611"
    },
    {
      "Number": "96576",
      "CompanyName": "Spar Bælum",
      "Streetname": "Østergade 8",
      "Streetname2": "Pakkeshop: 96576",
      "ZipCode": "9574",
      "CityName": "Bælum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1209",
      "Latitude": "56.8302"
    },
    {
      "Number": "96583",
      "CompanyName": "Ø-Kiosken",
      "Streetname": "Læsøgade 15",
      "Streetname2": "Pakkeshop: 96583",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94094",
      "Latitude": "57.0409"
    },
    {
      "Number": "96575",
      "CompanyName": "Hagested Købmand",
      "Streetname": "Præstebrovej 8",
      "Streetname2": "Pakkeshop: 96575",
      "ZipCode": "4300",
      "CityName": "Holbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6171",
      "Latitude": "55.7466"
    },
    {
      "Number": "96585",
      "CompanyName": "Spar Voldum",
      "Streetname": "Voldum Rudvej 17",
      "Streetname2": "Pakkeshop: 96585",
      "ZipCode": "8370",
      "CityName": "Hadsten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1673",
      "Latitude": "56.3649"
    },
    {
      "Number": "96586",
      "CompanyName": "Nr.Nebel Minimarked",
      "Streetname": "Bredgade 56",
      "Streetname2": "Pakkeshop: 96586",
      "ZipCode": "6830",
      "CityName": "Nr. Nebel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.29266",
      "Latitude": "55.7787"
    },
    {
      "Number": "96589",
      "CompanyName": "Ørsted bageren",
      "Streetname": "Rougsøvej 124",
      "Streetname2": "Pakkeshop: 96589",
      "ZipCode": "8950",
      "CityName": "Ørsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3352",
      "Latitude": "56.5016"
    },
    {
      "Number": "97328",
      "CompanyName": "Hjørnekiosken",
      "Streetname": "Classensgade 46, st. tv",
      "Streetname2": "Pakkeshop: 97328",
      "ZipCode": "2100",
      "CityName": "København Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5859",
      "Latitude": "55.6976"
    },
    {
      "Number": "96582",
      "CompanyName": "Mini Centret",
      "Streetname": "Møllegade 99",
      "Streetname2": "Pakkeshop: 96582",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91764",
      "Latitude": "56.039"
    },
    {
      "Number": "96816",
      "CompanyName": "Flügger Farver Dragør",
      "Streetname": "Møllegade 4",
      "Streetname2": "Pakkeshop: 96816",
      "ZipCode": "2791",
      "CityName": "Dragør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6351",
      "Latitude": "55.596"
    },
    {
      "Number": "96817",
      "CompanyName": "Guldsmeden i Dragør",
      "Streetname": "Kongevejen 20",
      "Streetname2": "Pakkeshop: 96817",
      "ZipCode": "2791",
      "CityName": "Dragør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6733",
      "Latitude": "55.5941"
    },
    {
      "Number": "97425",
      "CompanyName": "Kiosk 55",
      "Streetname": "kronprinsessegade 55",
      "Streetname2": "Pakkeshop: 97425",
      "ZipCode": "1306",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5855",
      "Latitude": "55.6885"
    },
    {
      "Number": "96266",
      "CompanyName": "SuperBrugsen Ølsemagle",
      "Streetname": "Ølsemaglevej 19",
      "Streetname2": "Pakkeshop: 96266",
      "ZipCode": "4600",
      "CityName": "Køge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1871",
      "Latitude": "55.4927"
    },
    {
      "Number": "96596",
      "CompanyName": "Min Købmand",
      "Streetname": "Bredningen 101",
      "Streetname2": "Pakkeshop: 96596",
      "ZipCode": "9700",
      "CityName": "Brønderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.81406",
      "Latitude": "57.284"
    },
    {
      "Number": "96595",
      "CompanyName": "Flügger Farver Holstebro",
      "Streetname": "Struervej 73",
      "Streetname2": "Pakkeshop: 96595",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.61699",
      "Latitude": "56.3681"
    },
    {
      "Number": "97229",
      "CompanyName": "OK Plus Havnegade",
      "Streetname": "Havnegade 1",
      "Streetname2": "Pakkeshop: 97229",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.385",
      "Latitude": "55.4065"
    },
    {
      "Number": "97234",
      "CompanyName": "OK Plus Blommenslyst",
      "Streetname": "Middelfartvej 428",
      "Streetname2": "Pakkeshop: 97234",
      "ZipCode": "5491",
      "CityName": "Blommenslyst",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2615",
      "Latitude": "55.3901"
    },
    {
      "Number": "97253",
      "CompanyName": "OK Plus Skive",
      "Streetname": "Kåstrupvej 26",
      "Streetname2": "Pakkeshop: 97253",
      "ZipCode": "7800",
      "CityName": "Skive",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.98429",
      "Latitude": "56.6446"
    },
    {
      "Number": "97381",
      "CompanyName": "Super spar Hanstholm",
      "Streetname": "Kai Lindbergsgade 75",
      "Streetname2": "Pakkeshop: 97381",
      "ZipCode": "7730",
      "CityName": "Hanstholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.59724",
      "Latitude": "57.1183"
    },
    {
      "Number": "97263",
      "CompanyName": "OK Plus Randers Nord",
      "Streetname": "Mariagervej 135",
      "Streetname2": "Pakkeshop: 97263",
      "ZipCode": "8920",
      "CityName": "Randers NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0273",
      "Latitude": "56.4769"
    },
    {
      "Number": "97210",
      "CompanyName": "OK Plus Jægerspris",
      "Streetname": "Lyngerupvej 69",
      "Streetname2": "Pakkeshop: 97210",
      "ZipCode": "3630",
      "CityName": "Jægerspris",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9812",
      "Latitude": "55.8041"
    },
    {
      "Number": "97388",
      "CompanyName": "Eurospar Frederiksværk",
      "Streetname": "Ellevej 34",
      "Streetname2": "Pakkeshop: 97388",
      "ZipCode": "3300",
      "CityName": "Frederiksværk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0118",
      "Latitude": "55.985"
    },
    {
      "Number": "97268",
      "CompanyName": "OK Plus Grundtvigsvej",
      "Streetname": "Grundtvigsvej 82",
      "Streetname2": "Pakkeshop: 97268",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.476",
      "Latitude": "57.4822"
    },
    {
      "Number": "97269",
      "CompanyName": "OK Plus Gl. Skagensvej",
      "Streetname": "Gl. Skagensvej 30",
      "Streetname2": "Pakkeshop: 97269",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5333",
      "Latitude": "57.4509"
    },
    {
      "Number": "97144",
      "CompanyName": "Min Købmand",
      "Streetname": "Marsk Billesvej 23",
      "Streetname2": "Pakkeshop: 97144",
      "ZipCode": "5672",
      "CityName": "Broby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2566",
      "Latitude": "55.2297"
    },
    {
      "Number": "96289",
      "CompanyName": "Dagli´Brugsen Vemmelev",
      "Streetname": "Akacievej 2",
      "Streetname2": "Pakkeshop: 96289",
      "ZipCode": "4241",
      "CityName": "Vemmelev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2609",
      "Latitude": "55.3639"
    },
    {
      "Number": "97243",
      "CompanyName": "OK Plus Holsted",
      "Streetname": "Energivej 2",
      "Streetname2": "Pakkeshop: 97243",
      "ZipCode": "6670",
      "CityName": "Holsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.90262",
      "Latitude": "55.5233"
    },
    {
      "Number": "97105",
      "CompanyName": "Din Nye Guldsmed",
      "Streetname": "Tallerupvej 26",
      "Streetname2": "Pakkeshop: 97105",
      "ZipCode": "5690",
      "CityName": "Tommerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1811",
      "Latitude": "55.3467"
    },
    {
      "Number": "97266",
      "CompanyName": "OK Plus Onsild",
      "Streetname": "Viborg Landevej 22",
      "Streetname2": "Pakkeshop: 97266",
      "ZipCode": "9500",
      "CityName": "Hobro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.7612",
      "Latitude": "56.5863"
    },
    {
      "Number": "97208",
      "CompanyName": "OK Plus Mårum",
      "Streetname": "Ny Mårumvej 174",
      "Streetname2": "Pakkeshop: 97208",
      "ZipCode": "3230",
      "CityName": "Græsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.28",
      "Latitude": "56.0279"
    },
    {
      "Number": "97663",
      "CompanyName": "Farveuniverset",
      "Streetname": "Kildebakkegårds Alle 121",
      "Streetname2": "Pakkeshop: 97663",
      "ZipCode": "2860",
      "CityName": "Søborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5068",
      "Latitude": "55.7418"
    },
    {
      "Number": "97245",
      "CompanyName": "OK Plus Sønder Omme",
      "Streetname": "Vejlevej 5",
      "Streetname2": "Pakkeshop: 97245",
      "ZipCode": "7260",
      "CityName": "Sønder Omme",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.89661",
      "Latitude": "55.8384"
    },
    {
      "Number": "97246",
      "CompanyName": "OK Plus Blåhøj",
      "Streetname": "Sdr. Ommevej 71",
      "Streetname2": "Pakkeshop: 97246",
      "ZipCode": "7330",
      "CityName": "Brande",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.02848",
      "Latitude": "55.8755"
    },
    {
      "Number": "97261",
      "CompanyName": "OK Plus Viborg",
      "Streetname": "Koldingvej 37",
      "Streetname2": "Pakkeshop: 97261",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.39535",
      "Latitude": "56.4349"
    },
    {
      "Number": "97262",
      "CompanyName": "OK Plus Ørum",
      "Streetname": "Østergade 2",
      "Streetname2": "Pakkeshop: 97262",
      "ZipCode": "8830",
      "CityName": "Tjele",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.62576",
      "Latitude": "56.4815"
    },
    {
      "Number": "97213",
      "CompanyName": "OK Plus Slimminge",
      "Streetname": "Ringstedvej 669",
      "Streetname2": "Pakkeshop: 97213",
      "ZipCode": "4100",
      "CityName": "Ringsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9592",
      "Latitude": "55.4483"
    },
    {
      "Number": "97220",
      "CompanyName": "OK Plus Kalundborg",
      "Streetname": "Sydhavnsvej 1",
      "Streetname2": "Pakkeshop: 97220",
      "ZipCode": "4400",
      "CityName": "Kalundborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.1045",
      "Latitude": "55.6765"
    },
    {
      "Number": "97393",
      "CompanyName": "Thorsøe Foto & Video",
      "Streetname": "Finsensvej 8",
      "Streetname2": "Pakkeshop: 97393",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5204",
      "Latitude": "55.6811"
    },
    {
      "Number": "97252",
      "CompanyName": "OK Plus Thisted",
      "Streetname": "Vilsundvej 15",
      "Streetname2": "Pakkeshop: 97252",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.62654",
      "Latitude": "56.8829"
    },
    {
      "Number": "97389",
      "CompanyName": "Min Købmand",
      "Streetname": "Klintvej 5",
      "Streetname2": "Pakkeshop: 97389",
      "ZipCode": "4500",
      "CityName": "Nykøbing Sj",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6057",
      "Latitude": "55.9335"
    },
    {
      "Number": "97202",
      "CompanyName": "OK Plus Vallensbæk",
      "Streetname": "Jydekrogen 1",
      "Streetname2": "Pakkeshop: 97202",
      "ZipCode": "2625",
      "CityName": "Vallensbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3742",
      "Latitude": "55.6444"
    },
    {
      "Number": "97101",
      "CompanyName": "OK Plus Kibæk",
      "Streetname": "Møllegårdsvej 33",
      "Streetname2": "Pakkeshop: 97101",
      "ZipCode": "6933",
      "CityName": "Kibæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.86526",
      "Latitude": "56.0363"
    },
    {
      "Number": "97224",
      "CompanyName": "OK Plus Haslev",
      "Streetname": "Køgevej 1",
      "Streetname2": "Pakkeshop: 97224",
      "ZipCode": "4690",
      "CityName": "Haslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9734",
      "Latitude": "55.3192"
    },
    {
      "Number": "97248",
      "CompanyName": "OK Plus Sunds",
      "Streetname": "ilskovvej 4",
      "Streetname2": "Pakkeshop: 97248",
      "ZipCode": "7451",
      "CityName": "Sunds",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.01997",
      "Latitude": "56.2005"
    },
    {
      "Number": "97249",
      "CompanyName": "OK Plus Karup J",
      "Streetname": "Bredgade 22",
      "Streetname2": "Pakkeshop: 97249",
      "ZipCode": "7470",
      "CityName": "Karup J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.16625",
      "Latitude": "56.3085"
    },
    {
      "Number": "97225",
      "CompanyName": "OK Plus Nykøbing F",
      "Streetname": "Østerbrogade 145",
      "Streetname2": "Pakkeshop: 97225",
      "ZipCode": "4800",
      "CityName": "Nykøbing F",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8902",
      "Latitude": "54.7598"
    },
    {
      "Number": "97632",
      "CompanyName": "Super spar Øster Tørslev",
      "Streetname": "Udbyhøjvej 570",
      "Streetname2": "Pakkeshop: 97632",
      "ZipCode": "8983",
      "CityName": "Gjerlev J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1901",
      "Latitude": "56.5803"
    },
    {
      "Number": "97228",
      "CompanyName": "OK Plus Nakskov",
      "Streetname": "Maribovej 134 C",
      "Streetname2": "Pakkeshop: 97228",
      "ZipCode": "4900",
      "CityName": "Nakskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.163",
      "Latitude": "54.8325"
    },
    {
      "Number": "97241",
      "CompanyName": "OK Plus Rødding",
      "Streetname": "Kongevej 52",
      "Streetname2": "Pakkeshop: 97241",
      "ZipCode": "6630",
      "CityName": "Rødding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.05818",
      "Latitude": "55.3738"
    },
    {
      "Number": "97255",
      "CompanyName": "OK Plus Viby J",
      "Streetname": "Rosenhøj 30",
      "Streetname2": "Pakkeshop: 97255",
      "ZipCode": "8260",
      "CityName": "Viby J.",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1521",
      "Latitude": "56.114"
    },
    {
      "Number": "97230",
      "CompanyName": "OK Plus Sandhusvej",
      "Streetname": "Sandhusvej 19",
      "Streetname2": "Pakkeshop: 97230",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4046",
      "Latitude": "55.4177"
    },
    {
      "Number": "96399",
      "CompanyName": "OK Plus Torsted",
      "Streetname": "Vejlevej 82",
      "Streetname2": "Pakkeshop: 96399",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.8205",
      "Latitude": "55.8435"
    },
    {
      "Number": "97223",
      "CompanyName": "OK Plus Havdrup",
      "Streetname": "Hovedgade 54",
      "Streetname2": "Pakkeshop: 97223",
      "ZipCode": "4622",
      "CityName": "Havdrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1174",
      "Latitude": "55.5389"
    },
    {
      "Number": "96276",
      "CompanyName": "Dagli´Brugsen Taulov",
      "Streetname": "Adelvej 7",
      "Streetname2": "Pakkeshop: 96276",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.60681",
      "Latitude": "55.5346"
    },
    {
      "Number": "97019",
      "CompanyName": "Bilka kundeservice",
      "Streetname": "Slotsarkaderne 26",
      "Streetname2": "Pakkeshop: 97019",
      "ZipCode": "3400",
      "CityName": "Hillerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2979",
      "Latitude": "55.929"
    },
    {
      "Number": "97383",
      "CompanyName": "Spar Borbjerg",
      "Streetname": "Naltoftevej 27",
      "Streetname2": "Pakkeshop: 97383",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.75259",
      "Latitude": "56.4031"
    },
    {
      "Number": "97021",
      "CompanyName": "Arriva",
      "Streetname": "Drewsensvej 5",
      "Streetname2": "Pakkeshop: 97021",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.54492",
      "Latitude": "56.1646"
    },
    {
      "Number": "97387",
      "CompanyName": "Shop In Glyngøre",
      "Streetname": "Bredgade 63",
      "Streetname2": "Pakkeshop: 97387",
      "ZipCode": "7870",
      "CityName": "Roslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.87066",
      "Latitude": "56.7582"
    },
    {
      "Number": "97236",
      "CompanyName": "OK Plus Ejby",
      "Streetname": "Nørregade 129",
      "Streetname2": "Pakkeshop: 97236",
      "ZipCode": "5592",
      "CityName": "Ejby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94387",
      "Latitude": "55.4404"
    },
    {
      "Number": "97259",
      "CompanyName": "OK Plus Ry",
      "Streetname": "Randersvej 25",
      "Streetname2": "Pakkeshop: 97259",
      "ZipCode": "8680",
      "CityName": "Ry",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.76104",
      "Latitude": "56.0949"
    },
    {
      "Number": "97256",
      "CompanyName": "OK Plus Ødum",
      "Streetname": "Landevejen 203",
      "Streetname2": "Pakkeshop: 97256",
      "ZipCode": "8370",
      "CityName": "Hadsten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1343",
      "Latitude": "56.3114"
    },
    {
      "Number": "97023",
      "CompanyName": "Arriva",
      "Streetname": "Nørredige 3A",
      "Streetname2": "Pakkeshop: 97023",
      "ZipCode": "6950",
      "CityName": "Ringkøbing",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.24966",
      "Latitude": "56.0931"
    },
    {
      "Number": "97143",
      "CompanyName": "Shell/7-Eleven Slagelse",
      "Streetname": "Strandvejen 49",
      "Streetname2": "Pakkeshop: 97143",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3301",
      "Latitude": "55.3992"
    },
    {
      "Number": "96592",
      "CompanyName": "Klim Elforretning",
      "Streetname": "Fabriksvej 19",
      "Streetname2": "Pakkeshop: 96592",
      "ZipCode": "9690",
      "CityName": "Fjerritslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.24962",
      "Latitude": "57.0875"
    },
    {
      "Number": "97314",
      "CompanyName": "Centerkiosken",
      "Streetname": "Søndergade 6",
      "Streetname2": "Pakkeshop: 97314",
      "ZipCode": "7600",
      "CityName": "Struer",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.5978",
      "Latitude": "56.4914"
    },
    {
      "Number": "96829",
      "CompanyName": "Trip Ind",
      "Streetname": "Vodskovvej 50",
      "Streetname2": "Pakkeshop: 96829",
      "ZipCode": "9310",
      "CityName": "Vodskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0315",
      "Latitude": "57.1053"
    },
    {
      "Number": "96828",
      "CompanyName": "Skjold Burne",
      "Streetname": "Frederiksborgvej 186",
      "Streetname2": "Pakkeshop: 96828",
      "ZipCode": "2400",
      "CityName": "København NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5312",
      "Latitude": "55.721"
    },
    {
      "Number": "97301",
      "CompanyName": "Min Købmand",
      "Streetname": "Fuglevænget 39 A",
      "Streetname2": "Pakkeshop: 97301",
      "ZipCode": "8500",
      "CityName": "Grenå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.8787",
      "Latitude": "56.4075"
    },
    {
      "Number": "97302",
      "CompanyName": "Flügger Farver Holmbladsgade",
      "Streetname": "Holmbladsgade 25",
      "Streetname2": "Pakkeshop: 97302",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6059",
      "Latitude": "55.665"
    },
    {
      "Number": "97510",
      "CompanyName": "Dagli´Brugsen Bogø",
      "Streetname": "Bogø Hovedgade 131",
      "Streetname2": "Pakkeshop: 97510",
      "ZipCode": "4793",
      "CityName": "Bogø By",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0479",
      "Latitude": "54.9277"
    },
    {
      "Number": "97615",
      "CompanyName": "Eurospar Tornhøjcentret",
      "Streetname": "Tornhøjvej 4",
      "Streetname2": "Pakkeshop: 97615",
      "ZipCode": "9220",
      "CityName": "Aalborg Ø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0017",
      "Latitude": "57.0257"
    },
    {
      "Number": "97516",
      "CompanyName": "Dagli´Brugsen Janderup",
      "Streetname": "Vesterled 30",
      "Streetname2": "Pakkeshop: 97516",
      "ZipCode": "6851",
      "CityName": "Janderup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.37278",
      "Latitude": "55.624"
    },
    {
      "Number": "97627",
      "CompanyName": "Nærkøb",
      "Streetname": "Østergade 41",
      "Streetname2": "Pakkeshop: 97627",
      "ZipCode": "6200",
      "CityName": "Aabenraa",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.50492",
      "Latitude": "54.9806"
    },
    {
      "Number": "97514",
      "CompanyName": "Dagli´Brugsen Sjørup",
      "Streetname": "Vestre Skivevej 169",
      "Streetname2": "Pakkeshop: 97514",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.0837",
      "Latitude": "56.4269"
    },
    {
      "Number": "97508",
      "CompanyName": "Dagli´Brugsen Gedsted",
      "Streetname": "Vesterbro 2",
      "Streetname2": "Pakkeshop: 97508",
      "ZipCode": "9631",
      "CityName": "Gedsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.3356",
      "Latitude": "56.6902"
    },
    {
      "Number": "97308",
      "CompanyName": "OK Plus Dronningborg",
      "Streetname": "Udbyhøjvej 154",
      "Streetname2": "Pakkeshop: 97308",
      "ZipCode": "8930",
      "CityName": "Randers NØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0679",
      "Latitude": "56.4727"
    },
    {
      "Number": "97336",
      "CompanyName": "Miljø- & EnergiCentret",
      "Streetname": "Høje Taastrup Boulevard 54",
      "Streetname2": "Pakkeshop: 97336",
      "ZipCode": "2630",
      "CityName": "taastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2696",
      "Latitude": "55.648"
    },
    {
      "Number": "97306",
      "CompanyName": "Statoil Randers NØ",
      "Streetname": "Hadsundvej 114",
      "Streetname2": "Pakkeshop: 97306",
      "ZipCode": "8930",
      "CityName": "Randers NØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0421",
      "Latitude": "56.4762"
    },
    {
      "Number": "97313",
      "CompanyName": "Superkiosken Overlund",
      "Streetname": "Odshøjvej 1",
      "Streetname2": "Pakkeshop: 97313",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.44717",
      "Latitude": "56.4625"
    },
    {
      "Number": "97601",
      "CompanyName": "Puls - Sillebroen Shoppingcenter",
      "Streetname": "nygade 1",
      "Streetname2": "Pakkeshop: 97601",
      "ZipCode": "3600",
      "CityName": "Frederiksund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0644",
      "Latitude": "55.8365"
    },
    {
      "Number": "97333",
      "CompanyName": "Nærkøb Bellinge",
      "Streetname": "Brændekildevej 17",
      "Streetname2": "Pakkeshop: 97333",
      "ZipCode": "5250",
      "CityName": "Odense SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3081",
      "Latitude": "55.3379"
    },
    {
      "Number": "97802",
      "CompanyName": "Shell Rødovre",
      "Streetname": "Roskildevej 360",
      "Streetname2": "Pakkeshop: 97802",
      "ZipCode": "2610",
      "CityName": "Rødovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4516",
      "Latitude": "55.6709"
    },
    {
      "Number": "97800",
      "CompanyName": "Shell Hvidovre",
      "Streetname": "Bibliotekvej 56",
      "Streetname2": "Pakkeshop: 97800",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4697",
      "Latitude": "55.6414"
    },
    {
      "Number": "97509",
      "CompanyName": "Dagli´Brugsen Karrebæk",
      "Streetname": "Kirkebakken 19",
      "Streetname2": "Pakkeshop: 97509",
      "ZipCode": "4736",
      "CityName": "Karrebæksminde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6534",
      "Latitude": "55.1914"
    },
    {
      "Number": "97344",
      "CompanyName": "Uno-X Extra Odense NØ",
      "Streetname": "Åsumvej 39",
      "Streetname2": "Pakkeshop: 97344",
      "ZipCode": "5240",
      "CityName": "Odense NØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4237",
      "Latitude": "55.4016"
    },
    {
      "Number": "96724",
      "CompanyName": "Q8 Skødstrup",
      "Streetname": "Grenåvej 742",
      "Streetname2": "Pakkeshop: 96724",
      "ZipCode": "8541",
      "CityName": "Skødstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3148",
      "Latitude": "56.275"
    },
    {
      "Number": "97347",
      "CompanyName": "Købmand Kiosk",
      "Streetname": "Tuborgvej 62, st.",
      "Streetname2": "Pakkeshop: 97347",
      "ZipCode": "2900",
      "CityName": "Hellerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5642",
      "Latitude": "55.7281"
    },
    {
      "Number": "97135",
      "CompanyName": "OK Plus Vestergade",
      "Streetname": "Vestergade 99",
      "Streetname2": "Pakkeshop: 97135",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.83164",
      "Latitude": "55.8716"
    },
    {
      "Number": "97352",
      "CompanyName": "Kiosk & Spil Sundby",
      "Streetname": "Sundbyvester Plads 5",
      "Streetname2": "Pakkeshop: 97352",
      "ZipCode": "2300",
      "CityName": "København S",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6136",
      "Latitude": "55.6461"
    },
    {
      "Number": "97812",
      "CompanyName": "Shell 7-Eleven Sorø",
      "Streetname": "Alleen 5",
      "Streetname2": "Pakkeshop: 97812",
      "ZipCode": "4180",
      "CityName": "Sorø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.558",
      "Latitude": "55.4359"
    },
    {
      "Number": "97814",
      "CompanyName": "Shell 7-Eleven Ørnumvej",
      "Streetname": "Ørnumvej 1",
      "Streetname2": "Pakkeshop: 97814",
      "ZipCode": "4220",
      "CityName": "Korsør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.1421",
      "Latitude": "55.3477"
    },
    {
      "Number": "97377",
      "CompanyName": "KMK - Alt Til Kontoret",
      "Streetname": "Strandvejen 74",
      "Streetname2": "Pakkeshop: 97377",
      "ZipCode": "4600",
      "CityName": "Køge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1889",
      "Latitude": "55.4486"
    },
    {
      "Number": "97378",
      "CompanyName": "Click",
      "Streetname": "Boulevarden 12",
      "Streetname2": "Pakkeshop: 97378",
      "ZipCode": "9000",
      "CityName": "Aalborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91958",
      "Latitude": "57.0468"
    },
    {
      "Number": "97695",
      "CompanyName": "Hoka Tæpper & Gulve",
      "Streetname": "Vestre Engvej 18",
      "Streetname2": "Pakkeshop: 97695",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.52635",
      "Latitude": "55.7076"
    },
    {
      "Number": "97699",
      "CompanyName": "Candy Megastore",
      "Streetname": "Kultorvet 2",
      "Streetname2": "Pakkeshop: 97699",
      "ZipCode": "1175",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5746",
      "Latitude": "55.6825"
    },
    {
      "Number": "97702",
      "CompanyName": "Shop n Play",
      "Streetname": "Rosenørns Alle 38",
      "Streetname2": "Pakkeshop: 97702",
      "ZipCode": "1970",
      "CityName": "Frederiksberg C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5505",
      "Latitude": "55.6826"
    },
    {
      "Number": "96274",
      "CompanyName": "Brugsen Halsnæs",
      "Streetname": "Torupvejen 156",
      "Streetname2": "Pakkeshop: 96274",
      "ZipCode": "3390",
      "CityName": "Hundested",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9416",
      "Latitude": "55.9826"
    },
    {
      "Number": "97811",
      "CompanyName": "Shell 7-Eleven Skovvej",
      "Streetname": "Skovvej 30",
      "Streetname2": "Pakkeshop: 97811",
      "ZipCode": "4220",
      "CityName": "Korsør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.1491",
      "Latitude": "55.3251"
    },
    {
      "Number": "97351",
      "CompanyName": "Treldevejens Kiosk",
      "Streetname": "Treldevej 48",
      "Streetname2": "Pakkeshop: 97351",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.76698",
      "Latitude": "55.5774"
    },
    {
      "Number": "97349",
      "CompanyName": "Spisekrogen Kiosk Og Spillehal",
      "Streetname": "Løgstørvej 4",
      "Streetname2": "Pakkeshop: 97349",
      "ZipCode": "9240",
      "CityName": "Nibe",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.62457",
      "Latitude": "56.9725"
    },
    {
      "Number": "97354",
      "CompanyName": "Lopa Kiosken",
      "Streetname": "Vestergade ´3",
      "Streetname2": "Pakkeshop: 97354",
      "ZipCode": "5492",
      "CityName": "Vissenbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1315",
      "Latitude": "55.3855"
    },
    {
      "Number": "96270",
      "CompanyName": "Dagli´Brugsen Helgenes",
      "Streetname": "Asgilhøjevej 16",
      "Streetname2": "Pakkeshop: 96270",
      "ZipCode": "8420",
      "CityName": "Knebel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5162",
      "Latitude": "56.1444"
    },
    {
      "Number": "97360",
      "CompanyName": "Nordsjællands Materieludlejning",
      "Streetname": "Industrivænget 44",
      "Streetname2": "Pakkeshop: 97360",
      "ZipCode": "3400",
      "CityName": "Hillerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2822",
      "Latitude": "55.931"
    },
    {
      "Number": "97371",
      "CompanyName": "Shell Assens",
      "Streetname": "Fåborgvej 14",
      "Streetname2": "Pakkeshop: 97371",
      "ZipCode": "5610",
      "CityName": "Assens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.91036",
      "Latitude": "55.2611"
    },
    {
      "Number": "97326",
      "CompanyName": "Kwik Spar Mammen",
      "Streetname": "Mammen byvej 54a",
      "Streetname2": "Pakkeshop: 97326",
      "ZipCode": "8850",
      "CityName": "Bjerringbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.61391",
      "Latitude": "56.4105"
    },
    {
      "Number": "96269",
      "CompanyName": "Dagli´Brugsen Landet",
      "Streetname": "Skovballevej 20",
      "Streetname2": "Pakkeshop: 96269",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5974",
      "Latitude": "54.9982"
    },
    {
      "Number": "97343",
      "CompanyName": "XL Byg",
      "Streetname": "Nørregade 28",
      "Streetname2": "Pakkeshop: 97343",
      "ZipCode": "8783",
      "CityName": "Hornsyld",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.86406",
      "Latitude": "55.7591"
    },
    {
      "Number": "97338",
      "CompanyName": "Uno-X Extra Hirtshals",
      "Streetname": "Kærvej 2-6",
      "Streetname2": "Pakkeshop: 97338",
      "ZipCode": "9850",
      "CityName": "Hirtshals",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.96465",
      "Latitude": "57.5754"
    },
    {
      "Number": "97670",
      "CompanyName": "Telekæden Søborg",
      "Streetname": "Søborg Hovedgade 93",
      "Streetname2": "Pakkeshop: 97670",
      "ZipCode": "2860",
      "CityName": "Søborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.51",
      "Latitude": "55.7365"
    },
    {
      "Number": "96292",
      "CompanyName": "Dagli´Brugsen Søby",
      "Streetname": "Langebro 13",
      "Streetname2": "Pakkeshop: 96292",
      "ZipCode": "5985",
      "CityName": "Søby Ærø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2542",
      "Latitude": "54.9389"
    },
    {
      "Number": "96293",
      "CompanyName": "SuperBrugsen Nr Lyndelse",
      "Streetname": "Albanivej 26",
      "Streetname2": "Pakkeshop: 96293",
      "ZipCode": "5792",
      "CityName": "Årslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3953",
      "Latitude": "55.3038"
    },
    {
      "Number": "97363",
      "CompanyName": "City2 Foto Plan 2 butik 267",
      "Streetname": "Hveen Boulevard 4",
      "Streetname2": "Pakkeshop: 97363",
      "ZipCode": "2630",
      "CityName": "Taastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2748",
      "Latitude": "55.6439"
    },
    {
      "Number": "97366",
      "CompanyName": "Spar Frederiks",
      "Streetname": "Søndergade 10",
      "Streetname2": "Pakkeshop: 97366",
      "ZipCode": "7470",
      "CityName": "Karup J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.25374",
      "Latitude": "56.3386"
    },
    {
      "Number": "97373",
      "CompanyName": "Super spar Snedsted",
      "Streetname": "Banegårdsvej 3",
      "Streetname2": "Pakkeshop: 97373",
      "ZipCode": "7752",
      "CityName": "Snedsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.52659",
      "Latitude": "56.8919"
    },
    {
      "Number": "96305",
      "CompanyName": "Mosede Centerkiosk",
      "Streetname": "Lilleholm 1",
      "Streetname2": "Pakkeshop: 96305",
      "ZipCode": "2670",
      "CityName": "Greve",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2757",
      "Latitude": "55.5778"
    },
    {
      "Number": "97372",
      "CompanyName": "Superkiosken Stavtrup",
      "Streetname": "Ormslevvej 277",
      "Streetname2": "Pakkeshop: 97372",
      "ZipCode": "8260",
      "CityName": "Viby J.",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1152",
      "Latitude": "56.1285"
    },
    {
      "Number": "97370",
      "CompanyName": "Skørping Cykler",
      "Streetname": "Møldrupvej 10",
      "Streetname2": "Pakkeshop: 97370",
      "ZipCode": "9520",
      "CityName": "Skørping",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.88689",
      "Latitude": "56.8328"
    },
    {
      "Number": "96271",
      "CompanyName": "Dagli´Brugsen Hedegårdene",
      "Streetname": "Klosterengen 58",
      "Streetname2": "Pakkeshop: 96271",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1049",
      "Latitude": "55.649"
    },
    {
      "Number": "97375",
      "CompanyName": "Quick2Go - Ballerup Bycenter",
      "Streetname": "Baltorpvej 2",
      "Streetname2": "Pakkeshop: 97375",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3577",
      "Latitude": "55.729"
    },
    {
      "Number": "97384",
      "CompanyName": "Min Købmand",
      "Streetname": "Vilstrupvej 1",
      "Streetname2": "Pakkeshop: 97384",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.43598",
      "Latitude": "55.6728"
    },
    {
      "Number": "97254",
      "CompanyName": "OK Plus Brørup",
      "Streetname": "Esbjergvej 73",
      "Streetname2": "Pakkeshop: 97254",
      "ZipCode": "6650",
      "CityName": "Brørup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.02086",
      "Latitude": "55.4988"
    },
    {
      "Number": "97100",
      "CompanyName": "Tank Kai Dige Bach",
      "Streetname": "Klausdalsbrovej 493",
      "Streetname2": "Pakkeshop: 97100",
      "ZipCode": "2730",
      "CityName": "Herlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4145",
      "Latitude": "55.7439"
    },
    {
      "Number": "97504",
      "CompanyName": "SuperBrugsen Vonsild",
      "Streetname": "Hjarupvej 2",
      "Streetname2": "Pakkeshop: 97504",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.47565",
      "Latitude": "55.4564"
    },
    {
      "Number": "97120",
      "CompanyName": "Spil & Vind Kiosk",
      "Streetname": "Slotsherrensvej 144 A",
      "Streetname2": "Pakkeshop: 97120",
      "ZipCode": "2720",
      "CityName": "Vanløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4677",
      "Latitude": "55.7001"
    },
    {
      "Number": "97816",
      "CompanyName": "Shell 7-Eleven Frederiksværk",
      "Streetname": "Nørregade 61",
      "Streetname2": "Pakkeshop: 97816",
      "ZipCode": "3300",
      "CityName": "Frederiksværk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0201",
      "Latitude": "55.9806"
    },
    {
      "Number": "96819",
      "CompanyName": "Uno-X Extra Vallø",
      "Streetname": "Kirkehøjen 2",
      "Streetname2": "Pakkeshop: 96819",
      "ZipCode": "4600",
      "CityName": "Køge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.235",
      "Latitude": "55.4017"
    },
    {
      "Number": "97611",
      "CompanyName": "Dagli´Brugsen Lendum",
      "Streetname": "Søndergade 1",
      "Streetname2": "Pakkeshop: 97611",
      "ZipCode": "9870",
      "CityName": "Sindal",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2997",
      "Latitude": "57.41"
    },
    {
      "Number": "97643",
      "CompanyName": "Min Købmand Bjerregrav",
      "Streetname": "Gl. Ålborgvej 16",
      "Streetname2": "Pakkeshop: 97643",
      "ZipCode": "9632",
      "CityName": "Møldrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.49513",
      "Latitude": "56.5811"
    },
    {
      "Number": "97122",
      "CompanyName": "Bolderslev Købmand",
      "Streetname": "Jernbanesvinget 2",
      "Streetname2": "Pakkeshop: 97122",
      "ZipCode": "6392",
      "CityName": "Bolderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.28123",
      "Latitude": "54.9918"
    },
    {
      "Number": "97123",
      "CompanyName": "Shell Tim",
      "Streetname": "Holstebrovej 148",
      "Streetname2": "Pakkeshop: 97123",
      "ZipCode": "6980",
      "CityName": "Tim",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.2987",
      "Latitude": "56.1963"
    },
    {
      "Number": "97103",
      "CompanyName": "Veri Kiosk Og Video",
      "Streetname": "Frijsenborgvej 5",
      "Streetname2": "Pakkeshop: 97103",
      "ZipCode": "8240",
      "CityName": "Risskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2148",
      "Latitude": "56.1891"
    },
    {
      "Number": "96175",
      "CompanyName": "SuperBrugsen Tjæreborg",
      "Streetname": "Skolevej 45",
      "Streetname2": "Pakkeshop: 96175",
      "ZipCode": "6731",
      "CityName": "Tjæreborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.58438",
      "Latitude": "55.4632"
    },
    {
      "Number": "96279",
      "CompanyName": "Dagli´Brugsen Gårslev",
      "Streetname": "Skolegade 2",
      "Streetname2": "Pakkeshop: 96279",
      "ZipCode": "7080",
      "CityName": "Børkop",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.70017",
      "Latitude": "55.6382"
    },
    {
      "Number": "96280",
      "CompanyName": "SuperBrugsen Vorbasse",
      "Streetname": "Vestergade 11",
      "Streetname2": "Pakkeshop: 96280",
      "ZipCode": "6623",
      "CityName": "Vorbasse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.07776",
      "Latitude": "55.6305"
    },
    {
      "Number": "96282",
      "CompanyName": "Dagli´Brugsen Sjølund",
      "Streetname": "Sjølungade 1",
      "Streetname2": "Pakkeshop: 96282",
      "ZipCode": "6093",
      "CityName": "Sjølund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.528470",
      "Latitude": "55.404336"
    },
    {
      "Number": "97108",
      "CompanyName": "Super spar Koldby",
      "Streetname": "Limfjordsgade 15",
      "Streetname2": "Pakkeshop: 97108",
      "ZipCode": "7752",
      "CityName": "Snedsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.53114",
      "Latitude": "56.8455"
    },
    {
      "Number": "96285",
      "CompanyName": "Dagli´Brugsen Morud",
      "Streetname": "Centeret 4",
      "Streetname2": "Pakkeshop: 96285",
      "ZipCode": "5462",
      "CityName": "Morud",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1888",
      "Latitude": "55.4439"
    },
    {
      "Number": "97124",
      "CompanyName": "Battery Store & More",
      "Streetname": "Brandts Passage 30-32",
      "Streetname2": "Pakkeshop: 97124",
      "ZipCode": "5000",
      "CityName": "Odense C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.381",
      "Latitude": "55.3955"
    },
    {
      "Number": "96284",
      "CompanyName": "Dagli´Brugsen Bække",
      "Streetname": "Søndergade 8",
      "Streetname2": "Pakkeshop: 96284",
      "ZipCode": "6622",
      "CityName": "Bække",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.13724",
      "Latitude": "55.57"
    },
    {
      "Number": "97127",
      "CompanyName": "Fanø Boghandel",
      "Streetname": "Hovedgaden 58",
      "Streetname2": "Pakkeshop: 97127",
      "ZipCode": "6720",
      "CityName": "Fanø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.40449",
      "Latitude": "55.4456"
    },
    {
      "Number": "97132",
      "CompanyName": "Spar Supermarked",
      "Streetname": "Egeskoven 224",
      "Streetname2": "Pakkeshop: 97132",
      "ZipCode": "2600",
      "CityName": "Glostrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4119",
      "Latitude": "55.6827"
    },
    {
      "Number": "97272",
      "CompanyName": "OK Plus Nyborg",
      "Streetname": "slipshavnsvej 3",
      "Streetname2": "Pakkeshop: 97272",
      "ZipCode": "5800",
      "CityName": "Nyborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.8099",
      "Latitude": "55.308"
    },
    {
      "Number": "97603",
      "CompanyName": "Den Frie Tank",
      "Streetname": "Frederiksdalsvej 194",
      "Streetname2": "Pakkeshop: 97603",
      "ZipCode": "2830",
      "CityName": "Virum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4576",
      "Latitude": "55.7921"
    },
    {
      "Number": "96295",
      "CompanyName": "Dagli´Brugsen Vester Skerninge",
      "Streetname": "Faaborgvej 38",
      "Streetname2": "Pakkeshop: 96295",
      "ZipCode": "5762",
      "CityName": "Vester Skerninge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4549",
      "Latitude": "55.0743"
    },
    {
      "Number": "96287",
      "CompanyName": "Dagli´Brugsen Allested-Vejle",
      "Streetname": "Vejlegårdsvej 2",
      "Streetname2": "Pakkeshop: 96287",
      "ZipCode": "5672",
      "CityName": "Broby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3108",
      "Latitude": "55.2713"
    },
    {
      "Number": "97142",
      "CompanyName": "Tanken i Hareskov",
      "Streetname": "Tibberup Alle 67-69",
      "Streetname2": "Pakkeshop: 97142",
      "ZipCode": "3500",
      "CityName": "Værløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4087",
      "Latitude": "55.7556"
    },
    {
      "Number": "96297",
      "CompanyName": "SuperBrugsen Samsø",
      "Streetname": "Møllebakkevej 1",
      "Streetname2": "Pakkeshop: 96297",
      "ZipCode": "8305",
      "CityName": "Samsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5938",
      "Latitude": "55.8317"
    },
    {
      "Number": "96298",
      "CompanyName": "Dagli´Brugsen Mårup",
      "Streetname": "Svenskgyden 3",
      "Streetname2": "Pakkeshop: 96298",
      "ZipCode": "8305",
      "CityName": "Samsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5655",
      "Latitude": "55.9458"
    },
    {
      "Number": "96294",
      "CompanyName": "Dagli´Brugsen Jerup",
      "Streetname": "Skagensvej 427",
      "Streetname2": "Pakkeshop: 96294",
      "ZipCode": "9981",
      "CityName": "Jerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.42",
      "Latitude": "57.5341"
    },
    {
      "Number": "97149",
      "CompanyName": "Spar Borrevejle",
      "Streetname": "Hornsherredvej 3",
      "Streetname2": "Pakkeshop: 97149",
      "ZipCode": "4060",
      "CityName": "Kirke Såby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9208",
      "Latitude": "55.6532"
    },
    {
      "Number": "97136",
      "CompanyName": "Min Købmand",
      "Streetname": "Stadion Alle ´4",
      "Streetname2": "Pakkeshop: 97136",
      "ZipCode": "6621",
      "CityName": "Gesten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.20718",
      "Latitude": "55.5259"
    },
    {
      "Number": "96112",
      "CompanyName": "Dagli´Brugsen Gevninge",
      "Streetname": "Gevninge Bygade 2",
      "Streetname2": "Pakkeshop: 96112",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9618",
      "Latitude": "55.6414"
    },
    {
      "Number": "97129",
      "CompanyName": "Spar Frøstrup",
      "Streetname": "Søndergade 5",
      "Streetname2": "Pakkeshop: 97129",
      "ZipCode": "7741",
      "CityName": "Frøstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.99484",
      "Latitude": "57.087"
    },
    {
      "Number": "97507",
      "CompanyName": "SuperBrugsen Aakirkeby",
      "Streetname": "Vesterbro 7",
      "Streetname2": "Pakkeshop: 97507",
      "ZipCode": "3720",
      "CityName": "Aakirkeby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.9168",
      "Latitude": "55.0703"
    },
    {
      "Number": "96213",
      "CompanyName": "Dagli´Brugsen Højen",
      "Streetname": "Højen Kirkevej 1",
      "Streetname2": "Pakkeshop: 96213",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.50518",
      "Latitude": "55.6563"
    },
    {
      "Number": "97502",
      "CompanyName": "Dagli´Brugsen Hovborg",
      "Streetname": "Holmeåvej 15",
      "Streetname2": "Pakkeshop: 97502",
      "ZipCode": "6682",
      "CityName": "Hovborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.93975",
      "Latitude": "55.6051"
    },
    {
      "Number": "97156",
      "CompanyName": "Eurospar Læsøgade",
      "Streetname": "Læsøgade 16",
      "Streetname2": "Pakkeshop: 97156",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5345",
      "Latitude": "57.4366"
    },
    {
      "Number": "97606",
      "CompanyName": "SuperBrugsen Hals",
      "Streetname": "Midtergade 20",
      "Streetname2": "Pakkeshop: 97606",
      "ZipCode": "9370",
      "CityName": "Hals",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3075",
      "Latitude": "56.9964"
    },
    {
      "Number": "97604",
      "CompanyName": "Super spar Stige",
      "Streetname": "Stigevej 275",
      "Streetname2": "Pakkeshop: 97604",
      "ZipCode": "5270",
      "CityName": "Odense N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4107",
      "Latitude": "55.4369"
    },
    {
      "Number": "97617",
      "CompanyName": "William Dams Boghandel",
      "Streetname": "Store Torv 7",
      "Streetname2": "Pakkeshop: 97617",
      "ZipCode": "3700",
      "CityName": "Rønne",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.6994",
      "Latitude": "55.1019"
    },
    {
      "Number": "97618",
      "CompanyName": "Kiosken Nærkøb",
      "Streetname": "Kirkegade 12",
      "Streetname2": "Pakkeshop: 97618",
      "ZipCode": "3770",
      "CityName": "Allinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.8024",
      "Latitude": "55.2773"
    },
    {
      "Number": "97513",
      "CompanyName": "Dagli´Brugsen Almind",
      "Streetname": "Sysselbjergvej 6",
      "Streetname2": "Pakkeshop: 97513",
      "ZipCode": "6051",
      "CityName": "Almind",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.48987",
      "Latitude": "55.5647"
    },
    {
      "Number": "97503",
      "CompanyName": "Dagli´Brugsen Parcelvej",
      "Streetname": "Parcelvej 71",
      "Streetname2": "Pakkeshop: 97503",
      "ZipCode": "2830",
      "CityName": "Virum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4534",
      "Latitude": "55.7993"
    },
    {
      "Number": "96291",
      "CompanyName": "Dagli´Brugsen Slagelse",
      "Streetname": "Hunsballevej 2",
      "Streetname2": "Pakkeshop: 96291",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4436",
      "Latitude": "55.3578"
    },
    {
      "Number": "97401",
      "CompanyName": "Lynge Vinhandel",
      "Streetname": "Lynghøjvej 8 C",
      "Streetname2": "Pakkeshop: 97401",
      "ZipCode": "3540",
      "CityName": "Lynge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2772",
      "Latitude": "55.841"
    },
    {
      "Number": "97675",
      "CompanyName": "Tele Vesterbro",
      "Streetname": "Vesterbrogade 82",
      "Streetname2": "Pakkeshop: 97675",
      "ZipCode": "1620",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5502",
      "Latitude": "55.6728"
    },
    {
      "Number": "97641",
      "CompanyName": "Let Køb Brabrand",
      "Streetname": "Hovedgaden 39 B",
      "Streetname2": "Pakkeshop: 97641",
      "ZipCode": "8220",
      "CityName": "Brabrand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.105",
      "Latitude": "56.1532"
    },
    {
      "Number": "97605",
      "CompanyName": "Dagli´Brugsen Årslev",
      "Streetname": "Overvejen 77",
      "Streetname2": "Pakkeshop: 97605",
      "ZipCode": "5792",
      "CityName": "Årslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4683",
      "Latitude": "55.3057"
    },
    {
      "Number": "97612",
      "CompanyName": "Kwik Spar Redsted",
      "Streetname": "Gl. Møllevej 43",
      "Streetname2": "Pakkeshop: 97612",
      "ZipCode": "7970",
      "CityName": "Redsted M",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.65384",
      "Latitude": "56.7388"
    },
    {
      "Number": "97613",
      "CompanyName": "SuperBest Holstebro",
      "Streetname": "Beethovensvej 10",
      "Streetname2": "Pakkeshop: 97613",
      "ZipCode": "7500",
      "CityName": "Holstebro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.58117",
      "Latitude": "56.3758"
    },
    {
      "Number": "97505",
      "CompanyName": "Dagli´Brugsen Hejls",
      "Streetname": "Hejls landevej 34",
      "Streetname2": "Pakkeshop: 97505",
      "ZipCode": "6094",
      "CityName": "Hejls",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.57891",
      "Latitude": "55.3836"
    },
    {
      "Number": "97506",
      "CompanyName": "Dagli´Brugsen Bjert",
      "Streetname": "Vesterløkke 5",
      "Streetname2": "Pakkeshop: 97506",
      "ZipCode": "6091",
      "CityName": "Bjert",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.55754",
      "Latitude": "55.458"
    },
    {
      "Number": "97607",
      "CompanyName": "Petit Vrå",
      "Streetname": "Østergade 4",
      "Streetname2": "Pakkeshop: 97607",
      "ZipCode": "9760",
      "CityName": "Vrå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.94188",
      "Latitude": "57.3536"
    },
    {
      "Number": "97622",
      "CompanyName": "Kwik Spar Haderslev",
      "Streetname": "Fjelstrup Nørrevej 3",
      "Streetname2": "Pakkeshop: 97622",
      "ZipCode": "6100",
      "CityName": "Haderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.56356",
      "Latitude": "55.3231"
    },
    {
      "Number": "97602",
      "CompanyName": "Tanken På Stubmøllevej",
      "Streetname": "Stubmøllevej 1",
      "Streetname2": "Pakkeshop: 97602",
      "ZipCode": "2450",
      "CityName": "København SV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5265",
      "Latitude": "55.6482"
    },
    {
      "Number": "96296",
      "CompanyName": "Dagli´Brugsen Tranekær",
      "Streetname": "Annexstræde 1",
      "Streetname2": "Pakkeshop: 96296",
      "ZipCode": "5953",
      "CityName": "Tranekær",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.8013",
      "Latitude": "54.9584"
    },
    {
      "Number": "97145",
      "CompanyName": "Klædeskabet",
      "Streetname": "Kirkestræde 10",
      "Streetname2": "Pakkeshop: 97145",
      "ZipCode": "5960",
      "CityName": "Marstal",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5175",
      "Latitude": "54.8547"
    },
    {
      "Number": "97625",
      "CompanyName": "Bog & Idé Lyngby",
      "Streetname": "Lyngby Hovedgade 23",
      "Streetname2": "Pakkeshop: 97625",
      "ZipCode": "2800",
      "CityName": "Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.502",
      "Latitude": "55.7718"
    },
    {
      "Number": "97635",
      "CompanyName": "Flugger Farver Kruså",
      "Streetname": "Skovglimt 2A",
      "Streetname2": "Pakkeshop: 97635",
      "ZipCode": "6340",
      "CityName": "Kruså",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.40077",
      "Latitude": "54.8496"
    },
    {
      "Number": "97692",
      "CompanyName": "Super spar Ullerslev",
      "Streetname": "Svendborgvej 50-54",
      "Streetname2": "Pakkeshop: 97692",
      "ZipCode": "5540",
      "CityName": "Ullerslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6683",
      "Latitude": "55.3555"
    },
    {
      "Number": "97527",
      "CompanyName": "Dagli´ Brugsen Gredstedbro",
      "Streetname": "Andelsgade 4",
      "Streetname2": "Pakkeshop: 97527",
      "ZipCode": "6771",
      "CityName": "Gredstedbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.74193",
      "Latitude": "55.3968"
    },
    {
      "Number": "97645",
      "CompanyName": "Click",
      "Streetname": "Dania 3",
      "Streetname2": "Pakkeshop: 97645",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7578",
      "Latitude": "55.2321"
    },
    {
      "Number": "97676",
      "CompanyName": "Foto-Butikken",
      "Streetname": "Torvegade 3",
      "Streetname2": "Pakkeshop: 97676",
      "ZipCode": "3000",
      "CityName": "Helsingør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6102",
      "Latitude": "56.0361"
    },
    {
      "Number": "97685",
      "CompanyName": "Nivå Nærkøb",
      "Streetname": "Gammel Strandvej 3B",
      "Streetname2": "Pakkeshop: 97685",
      "ZipCode": "2990",
      "CityName": "Nivå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.51",
      "Latitude": "55.9305"
    },
    {
      "Number": "97521",
      "CompanyName": "Dagli´Brugsen Hammershøj",
      "Streetname": "Randersvej 1",
      "Streetname2": "Pakkeshop: 97521",
      "ZipCode": "8830",
      "CityName": "Tjele",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.75059",
      "Latitude": "56.4996"
    },
    {
      "Number": "97661",
      "CompanyName": "Super spar Nørager",
      "Streetname": "Jernbanegade 4",
      "Streetname2": "Pakkeshop: 97661",
      "ZipCode": "9610",
      "CityName": "Nørager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.6307",
      "Latitude": "56.7062"
    },
    {
      "Number": "97662",
      "CompanyName": "Super Spar Haverslev",
      "Streetname": "Strandvejen 2",
      "Streetname2": "Pakkeshop: 97662",
      "ZipCode": "9610",
      "CityName": "Nørager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.68135",
      "Latitude": "56.7872"
    },
    {
      "Number": "97690",
      "CompanyName": "Farum Vin og Tobak",
      "Streetname": "Farum Hovedgade 33",
      "Streetname2": "Pakkeshop: 97690",
      "ZipCode": "3520",
      "CityName": "Farum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3676",
      "Latitude": "55.8111"
    },
    {
      "Number": "97523",
      "CompanyName": "Dagli´Brugsen Øster Bjerregrav",
      "Streetname": "Frederiksbergvej 1 C",
      "Streetname2": "Pakkeshop: 97523",
      "ZipCode": "8920",
      "CityName": "Randers NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.90884",
      "Latitude": "56.4854"
    },
    {
      "Number": "97684",
      "CompanyName": "Click Foto",
      "Streetname": "Slotsgade 10",
      "Streetname2": "Pakkeshop: 97684",
      "ZipCode": "8900",
      "CityName": "Randers",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0387",
      "Latitude": "56.4609"
    },
    {
      "Number": "97687",
      "CompanyName": "Photo Care",
      "Streetname": "Sct. MathiasCentret 315 A",
      "Streetname2": "Pakkeshop: 97687",
      "ZipCode": "8800",
      "CityName": "Viborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.405136",
      "Latitude": "56.448752"
    },
    {
      "Number": "97524",
      "CompanyName": "Dagli´Brugsen Askov",
      "Streetname": "Torvet 1",
      "Streetname2": "Pakkeshop: 97524",
      "ZipCode": "6600",
      "CityName": "Vejen",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.10103",
      "Latitude": "55.4711"
    },
    {
      "Number": "97522",
      "CompanyName": "Dagli´Brugsen Skovby",
      "Streetname": "Kegnæsvej 52",
      "Streetname2": "Pakkeshop: 97522",
      "ZipCode": "6470",
      "CityName": "Sydals",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.99503",
      "Latitude": "54.8843"
    },
    {
      "Number": "97669",
      "CompanyName": "Shell Thisted",
      "Streetname": "Thisted kystvej 7",
      "Streetname2": "Pakkeshop: 97669",
      "ZipCode": "7700",
      "CityName": "Thisted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.69251",
      "Latitude": "56.9528"
    },
    {
      "Number": "97655",
      "CompanyName": "Color Foto",
      "Streetname": "Øster Torv 12",
      "Streetname2": "Pakkeshop: 97655",
      "ZipCode": "3060",
      "CityName": "Espergærde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5458",
      "Latitude": "55.9949"
    },
    {
      "Number": "97710",
      "CompanyName": "Svenstrup Nærkøb",
      "Streetname": "Godthåbsvej 3",
      "Streetname2": "Pakkeshop: 97710",
      "ZipCode": "9230",
      "CityName": "Svenstrup J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.85415",
      "Latitude": "56.9719"
    },
    {
      "Number": "97709",
      "CompanyName": "K.C.Mini Marked",
      "Streetname": "Lindeholmen 14-16",
      "Streetname2": "Pakkeshop: 97709",
      "ZipCode": "2680",
      "CityName": "Solrød Strand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.2056",
      "Latitude": "55.5215"
    },
    {
      "Number": "97711",
      "CompanyName": "Jari Auto",
      "Streetname": "Vestergade 23-25",
      "Streetname2": "Pakkeshop: 97711",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.96393",
      "Latitude": "56.1361"
    },
    {
      "Number": "97715",
      "CompanyName": "Foto A",
      "Streetname": "Frederikssundsvej 317",
      "Streetname2": "Pakkeshop: 97715",
      "ZipCode": "2700",
      "CityName": "Brønshøj",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4744",
      "Latitude": "55.7112"
    },
    {
      "Number": "97536",
      "CompanyName": "Dagli´Brugsen Orø",
      "Streetname": "Brøndevej 34 C",
      "Streetname2": "Pakkeshop: 97536",
      "ZipCode": "4300",
      "CityName": "Holbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8045",
      "Latitude": "55.7649"
    },
    {
      "Number": "97701",
      "CompanyName": "Bog & Idé Silkeborg",
      "Streetname": "Vestergade 31",
      "Streetname2": "Pakkeshop: 97701",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.54531",
      "Latitude": "56.1682"
    },
    {
      "Number": "97535",
      "CompanyName": "SuperBrugsen Tinglev",
      "Streetname": "Centerpladsen 5",
      "Streetname2": "Pakkeshop: 97535",
      "ZipCode": "6360",
      "CityName": "Tinglev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.2553",
      "Latitude": "54.9366"
    },
    {
      "Number": "97525",
      "CompanyName": "Dagli´Brugsen Thorsager",
      "Streetname": "Thorsgade 26",
      "Streetname2": "Pakkeshop: 97525",
      "ZipCode": "8410",
      "CityName": "Rønde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4613",
      "Latitude": "56.3429"
    },
    {
      "Number": "97673",
      "CompanyName": "Uno-X Risskov",
      "Streetname": "Nordre Strandvej 125",
      "Streetname2": "Pakkeshop: 97673",
      "ZipCode": "8240",
      "CityName": "Risskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2595",
      "Latitude": "56.2013"
    },
    {
      "Number": "97698",
      "CompanyName": "Statoil Ryomgård",
      "Streetname": "Nimtoftevej 2",
      "Streetname2": "Pakkeshop: 97698",
      "ZipCode": "8550",
      "CityName": "Ryomgård",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5059",
      "Latitude": "56.3809"
    },
    {
      "Number": "97734",
      "CompanyName": "Shell Ebeltoft",
      "Streetname": "Vibæk Strandvej 6",
      "Streetname2": "Pakkeshop: 97734",
      "ZipCode": "8400",
      "CityName": "Ebeltoft",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6773",
      "Latitude": "56.2134"
    },
    {
      "Number": "97735",
      "CompanyName": "Shell Aarhus N",
      "Streetname": "Randersvej 164",
      "Streetname2": "Pakkeshop: 97735",
      "ZipCode": "8200",
      "CityName": "Aarhus N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1993",
      "Latitude": "56.1804"
    },
    {
      "Number": "97736",
      "CompanyName": "Shell Risskov",
      "Streetname": "Grenaavej 150",
      "Streetname2": "Pakkeshop: 97736",
      "ZipCode": "8240",
      "CityName": "Risskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.219",
      "Latitude": "56.1896"
    },
    {
      "Number": "97697",
      "CompanyName": "Hørsholm Foto",
      "Streetname": "Hovedgaden 12",
      "Streetname2": "Pakkeshop: 97697",
      "ZipCode": "2970",
      "CityName": "Hørsholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4984",
      "Latitude": "55.8793"
    },
    {
      "Number": "97708",
      "CompanyName": "Bog & Idé Farum",
      "Streetname": "Farum Bytorv 64",
      "Streetname2": "Pakkeshop: 97708",
      "ZipCode": "3520",
      "CityName": "Farum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.381",
      "Latitude": "55.8145"
    },
    {
      "Number": "97817",
      "CompanyName": "Shell 7-Eleven Hillerød",
      "Streetname": "Københavnsvej 53",
      "Streetname2": "Pakkeshop: 97817",
      "ZipCode": "3400",
      "CityName": "Hillerød",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3194",
      "Latitude": "55.9293"
    },
    {
      "Number": "97691",
      "CompanyName": "Min Købmand Gludsted",
      "Streetname": "Hjøllundvej 6",
      "Streetname2": "Pakkeshop: 97691",
      "ZipCode": "7361",
      "CityName": "Ejstrupholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.31616",
      "Latitude": "56.0325"
    },
    {
      "Number": "97526",
      "CompanyName": "Dagli´Brugsen Gærum",
      "Streetname": "Østergade 5",
      "Streetname2": "Pakkeshop: 97526",
      "ZipCode": "9900",
      "CityName": "Frederikshavn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4356",
      "Latitude": "57.4025"
    },
    {
      "Number": "97703",
      "CompanyName": "SuperBest Als",
      "Streetname": "Hadsundvej 1",
      "Streetname2": "Pakkeshop: 97703",
      "ZipCode": "9560",
      "CityName": "Hadsund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2895",
      "Latitude": "56.7547"
    },
    {
      "Number": "97706",
      "CompanyName": "Søpark Kiosken Maribo",
      "Streetname": "Vestergade 37",
      "Streetname2": "Pakkeshop: 97706",
      "ZipCode": "4930",
      "CityName": "Maribo",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.496",
      "Latitude": "54.7752"
    },
    {
      "Number": "97529",
      "CompanyName": "Dagli´Brugsen Alslev",
      "Streetname": "Bredgade 32",
      "Streetname2": "Pakkeshop: 97529",
      "ZipCode": "6800",
      "CityName": "Varde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.41702",
      "Latitude": "55.5884"
    },
    {
      "Number": "97533",
      "CompanyName": "Dagli´Brugsen Gudbjerg",
      "Streetname": "Teglværksvej 3",
      "Streetname2": "Pakkeshop: 97533",
      "ZipCode": "5892",
      "CityName": "Gudbjerg Sydfyn",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6738",
      "Latitude": "55.1546"
    },
    {
      "Number": "97534",
      "CompanyName": "Dagli´Brugsen Ollerup",
      "Streetname": "Ollerup Bytorv 1",
      "Streetname2": "Pakkeshop: 97534",
      "ZipCode": "5762",
      "CityName": "Vester Skerninge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5027",
      "Latitude": "55.0701"
    },
    {
      "Number": "97704",
      "CompanyName": "Photocare Hjørring",
      "Streetname": "Jernbanegade 4",
      "Streetname2": "Pakkeshop: 97704",
      "ZipCode": "9800",
      "CityName": "Hjørring",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.98701",
      "Latitude": "57.4593"
    },
    {
      "Number": "97531",
      "CompanyName": "Dagli´Brugsen Havnsøe",
      "Streetname": "Havnevej 8",
      "Streetname2": "Pakkeshop: 97531",
      "ZipCode": "4591",
      "CityName": "Føllenslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3217",
      "Latitude": "55.7528"
    },
    {
      "Number": "97532",
      "CompanyName": "Dagli´Brugsen Sottrup",
      "Streetname": "Skolevej 18",
      "Streetname2": "Pakkeshop: 97532",
      "ZipCode": "6400",
      "CityName": "Sønderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.70228",
      "Latitude": "54.9499"
    },
    {
      "Number": "97718",
      "CompanyName": "Shell Ringsted",
      "Streetname": "Næstvedvej 19",
      "Streetname2": "Pakkeshop: 97718",
      "ZipCode": "4100",
      "CityName": "Ringsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7928",
      "Latitude": "55.4386"
    },
    {
      "Number": "97712",
      "CompanyName": "Døgneren Hvidbjerg",
      "Streetname": "Nørregade 1",
      "Streetname2": "Pakkeshop: 97712",
      "ZipCode": "7790",
      "CityName": "Thyholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.52507",
      "Latitude": "56.6506"
    },
    {
      "Number": "97539",
      "CompanyName": "SuperBrugsen Sindal",
      "Streetname": "Nørregade 7",
      "Streetname2": "Pakkeshop: 97539",
      "ZipCode": "9870",
      "CityName": "Sindal",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2021",
      "Latitude": "57.4718"
    },
    {
      "Number": "97714",
      "CompanyName": "Min Købmand",
      "Streetname": "Bygaden 10",
      "Streetname2": "Pakkeshop: 97714",
      "ZipCode": "5600",
      "CityName": "Faaborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1961",
      "Latitude": "55.1736"
    },
    {
      "Number": "97537",
      "CompanyName": "SuperBrugsen Læsø",
      "Streetname": "Byrum Hovedgade 77",
      "Streetname2": "Pakkeshop: 97537",
      "ZipCode": "9940",
      "CityName": "Læsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.0038",
      "Latitude": "57.2542"
    },
    {
      "Number": "97750",
      "CompanyName": "Statoil Skibby",
      "Streetname": "Hovedgaden 1 D",
      "Streetname2": "Pakkeshop: 97750",
      "ZipCode": "4050",
      "CityName": "Skibby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9592",
      "Latitude": "55.7543"
    },
    {
      "Number": "97540",
      "CompanyName": "LokalBrugsen Jennum",
      "Streetname": "Jennumvej 163",
      "Streetname2": "Pakkeshop: 97540",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.42793",
      "Latitude": "55.7213"
    },
    {
      "Number": "97538",
      "CompanyName": "Dagli´Brugsen Egeskov",
      "Streetname": "Egeskov Bygade 4",
      "Streetname2": "Pakkeshop: 97538",
      "ZipCode": "7000",
      "CityName": "Fredericia",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.74488",
      "Latitude": "55.615"
    },
    {
      "Number": "97713",
      "CompanyName": "Statoil Assentoft",
      "Streetname": "Storegade 12",
      "Streetname2": "Pakkeshop: 97713",
      "ZipCode": "8960",
      "CityName": "Randers SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1367",
      "Latitude": "56.4398"
    },
    {
      "Number": "97717",
      "CompanyName": "Spar Hald",
      "Streetname": "Ørslevklostervej 107",
      "Streetname2": "Pakkeshop: 97717",
      "ZipCode": "7840",
      "CityName": "Højslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.19445",
      "Latitude": "56.5941"
    },
    {
      "Number": "97530",
      "CompanyName": "Dagli´Brugsen Hou",
      "Streetname": "Brogade 23",
      "Streetname2": "Pakkeshop: 97530",
      "ZipCode": "9370",
      "CityName": "Hals",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.371",
      "Latitude": "57.0567"
    },
    {
      "Number": "97757",
      "CompanyName": "Statoil Herrestrup",
      "Streetname": "Nykøbingvej 194",
      "Streetname2": "Pakkeshop: 97757",
      "ZipCode": "4571",
      "CityName": "Grevinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6001",
      "Latitude": "55.7922"
    },
    {
      "Number": "97732",
      "CompanyName": "Shell Højbjerg",
      "Streetname": "Rosenvangsalle 218",
      "Streetname2": "Pakkeshop: 97732",
      "ZipCode": "8270",
      "CityName": "Højbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1985",
      "Latitude": "56.1171"
    },
    {
      "Number": "97739",
      "CompanyName": "Shell Viby J",
      "Streetname": "Skanderborgvej 123",
      "Streetname2": "Pakkeshop: 97739",
      "ZipCode": "8260",
      "CityName": "Viby J",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1775",
      "Latitude": "56.1372"
    },
    {
      "Number": "97740",
      "CompanyName": "Shell Agerøvej",
      "Streetname": "Agerøvej 10",
      "Streetname2": "Pakkeshop: 97740",
      "ZipCode": "8381",
      "CityName": "Tilst",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1111",
      "Latitude": "56.182"
    },
    {
      "Number": "97851",
      "CompanyName": "7-Eleven Nørrebrogade",
      "Streetname": "Nørrebrogade 190",
      "Streetname2": "Pakkeshop: 97851",
      "ZipCode": "2200",
      "CityName": "København N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5441",
      "Latitude": "55.6977"
    },
    {
      "Number": "97573",
      "CompanyName": "SuperBrugsen Søndersø",
      "Streetname": "Toftekær 4",
      "Streetname2": "Pakkeshop: 97573",
      "ZipCode": "5471",
      "CityName": "Søndersø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2519",
      "Latitude": "55.4818"
    },
    {
      "Number": "97575",
      "CompanyName": "Dagli´Brugsen Mosbjerg",
      "Streetname": "Mosbjergvej 429",
      "Streetname2": "Pakkeshop: 97575",
      "ZipCode": "9870",
      "CityName": "Sindal",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2789",
      "Latitude": "57.502"
    },
    {
      "Number": "97876",
      "CompanyName": "Shell 7-Eleven Rødekro",
      "Streetname": "Kometvej 1",
      "Streetname2": "Pakkeshop: 97876",
      "ZipCode": "6230",
      "CityName": "Rødekro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.36137",
      "Latitude": "55.0678"
    },
    {
      "Number": "95040",
      "CompanyName": "Hundslund Købmandsgård",
      "Streetname": "Landevejen 8",
      "Streetname2": "Pakkeshop: 95040",
      "ZipCode": "8350",
      "CityName": "Hundslund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0509",
      "Latitude": "55.9148"
    },
    {
      "Number": "97866",
      "CompanyName": "7-Eleven Rungsted Kyst Station",
      "Streetname": "Vestre Stationsvej 7",
      "Streetname2": "Pakkeshop: 97866",
      "ZipCode": "2960",
      "CityName": "Rungsted Kyst",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5312",
      "Latitude": "55.8822"
    },
    {
      "Number": "95038",
      "CompanyName": "Shell Sundvej",
      "Streetname": "Sundvej 2 A",
      "Streetname2": "Pakkeshop: 95038",
      "ZipCode": "8700",
      "CityName": "Horsens",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.86162",
      "Latitude": "55.8627"
    },
    {
      "Number": "95041",
      "CompanyName": "Eurospar Høng",
      "Streetname": "Hovedgaden 50",
      "Streetname2": "Pakkeshop: 95041",
      "ZipCode": "4270",
      "CityName": "Høng",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.2902",
      "Latitude": "55.5112"
    },
    {
      "Number": "95034",
      "CompanyName": "Tips & Håndkøb",
      "Streetname": "vestergade 24",
      "Streetname2": "Pakkeshop: 95034",
      "ZipCode": "8723",
      "CityName": "Løsning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.69885",
      "Latitude": "55.8038"
    },
    {
      "Number": "95025",
      "CompanyName": "Statoil Vordingborg",
      "Streetname": "Næstvedvej 36",
      "Streetname2": "Pakkeshop: 95025",
      "ZipCode": "4760",
      "CityName": "Vordingborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8973",
      "Latitude": "55.0156"
    },
    {
      "Number": "97495",
      "CompanyName": "Shell Tune",
      "Streetname": "Tune parkvej 7",
      "Streetname2": "Pakkeshop: 97495",
      "ZipCode": "4030",
      "CityName": "Tune",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.189",
      "Latitude": "55.5966"
    },
    {
      "Number": "95031",
      "CompanyName": "Høyrup",
      "Streetname": "Industrivej 2",
      "Streetname2": "Pakkeshop: 95031",
      "ZipCode": "9750",
      "CityName": "Øster Vrå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2375",
      "Latitude": "57.3406"
    },
    {
      "Number": "97868",
      "CompanyName": "7-Eleven Snekkersten",
      "Streetname": "Nørrevej 93",
      "Streetname2": "Pakkeshop: 97868",
      "ZipCode": "3070",
      "CityName": "Snekkersten",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5777",
      "Latitude": "56.0097"
    },
    {
      "Number": "97897",
      "CompanyName": "7-Eleven Espergærde Station",
      "Streetname": "Kløvermarken 3",
      "Streetname2": "Pakkeshop: 97897",
      "ZipCode": "3060",
      "CityName": "Espergærde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5492",
      "Latitude": "55.9953"
    },
    {
      "Number": "95047",
      "CompanyName": "Ringvejens Kiosk",
      "Streetname": "Vindinggård Center 31 A",
      "Streetname2": "Pakkeshop: 95047",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.55133",
      "Latitude": "55.6884"
    },
    {
      "Number": "97580",
      "CompanyName": "Dagli´Brugsen Kirke Såby",
      "Streetname": "Rømøvej 3",
      "Streetname2": "Pakkeshop: 97580",
      "ZipCode": "4060",
      "CityName": "Kirke Såby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.8732389",
      "Latitude": "55.6326141"
    },
    {
      "Number": "95010",
      "CompanyName": "Superbest Skibby",
      "Streetname": "Hovedgaden 34",
      "Streetname2": "Pakkeshop: 95010",
      "ZipCode": "4050",
      "CityName": "Skibby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9593",
      "Latitude": "55.7521"
    },
    {
      "Number": "97286",
      "CompanyName": "OK Plus Middelfart",
      "Streetname": "Jyllandsvej 40",
      "Streetname2": "Pakkeshop: 97286",
      "ZipCode": "5500",
      "CityName": "Middelfart",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.75446",
      "Latitude": "55.5029"
    },
    {
      "Number": "95037",
      "CompanyName": "Eurospar Brande",
      "Streetname": "Storegade 9",
      "Streetname2": "Pakkeshop: 95037",
      "ZipCode": "7330",
      "CityName": "Brande",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.12584",
      "Latitude": "55.9445"
    },
    {
      "Number": "97577",
      "CompanyName": "Dagli´Brugsen Visse",
      "Streetname": "Vissevej 93",
      "Streetname2": "Pakkeshop: 97577",
      "ZipCode": "9210",
      "CityName": "Aalborg SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.92946",
      "Latitude": "56.9959"
    },
    {
      "Number": "97578",
      "CompanyName": "Dagli´Brugsen Nørhalne",
      "Streetname": "Bygaden 2",
      "Streetname2": "Pakkeshop: 97578",
      "ZipCode": "9430",
      "CityName": "Vadum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.8724",
      "Latitude": "57.1497"
    },
    {
      "Number": "95055",
      "CompanyName": "Q8 Slangerup",
      "Streetname": "Brobæksgade 7 A",
      "Streetname2": "Pakkeshop: 95055",
      "ZipCode": "3550",
      "CityName": "Slangerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.173683",
      "Latitude": "55.844165"
    },
    {
      "Number": "95004",
      "CompanyName": "DSB 7-Eleven Gentofte",
      "Streetname": "Brogårdsvej 14",
      "Streetname2": "Pakkeshop: 95004",
      "ZipCode": "2820",
      "CityName": "Gentofte",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5413",
      "Latitude": "55.7534"
    },
    {
      "Number": "97583",
      "CompanyName": "Dagli´Brugsen Abbednæs",
      "Streetname": "Appenæs Bygade 70",
      "Streetname2": "Pakkeshop: 97583",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7488",
      "Latitude": "55.1978"
    },
    {
      "Number": "95032",
      "CompanyName": "Eurospar Sct. Jørgens Park",
      "Streetname": "Sct Jørgens Park 34",
      "Streetname2": "Pakkeshop: 95032",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7574",
      "Latitude": "55.2155"
    },
    {
      "Number": "97875",
      "CompanyName": "Shell 7-Eleven Aabenraa",
      "Streetname": "Vestvejen 95",
      "Streetname2": "Pakkeshop: 97875",
      "ZipCode": "6200",
      "CityName": "Aabenraa",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.40419",
      "Latitude": "55.0446"
    },
    {
      "Number": "95036",
      "CompanyName": "Eurospar Borup",
      "Streetname": "Hovedgaden 12",
      "Streetname2": "Pakkeshop: 95036",
      "ZipCode": "4140",
      "CityName": "Borup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9727",
      "Latitude": "55.4935"
    },
    {
      "Number": "95039",
      "CompanyName": "Spar Vindinge",
      "Streetname": "Tingvej 14",
      "Streetname2": "Pakkeshop: 95039",
      "ZipCode": "4000",
      "CityName": "Roskilde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1358",
      "Latitude": "55.6259"
    },
    {
      "Number": "95042",
      "CompanyName": "Shell Mylius Erichsensvej",
      "Streetname": "Mylius Erichsensvej 78",
      "Streetname2": "Pakkeshop: 95042",
      "ZipCode": "9210",
      "CityName": "Aalborg SØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.93727",
      "Latitude": "57.0212"
    },
    {
      "Number": "95014",
      "CompanyName": "DSB 7-Eleven Slagelse",
      "Streetname": "Sdr. Stationsvej 28",
      "Streetname2": "Pakkeshop: 95014",
      "ZipCode": "4200",
      "CityName": "Slagelse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3481",
      "Latitude": "55.4072"
    },
    {
      "Number": "95054",
      "CompanyName": "Shell 7-Eleven Kolding",
      "Streetname": "Hylkedalvej 2",
      "Streetname2": "Pakkeshop: 95054",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.44677",
      "Latitude": "55.4833"
    },
    {
      "Number": "95046",
      "CompanyName": "Statoil Bækmarksbro",
      "Streetname": "Brogade 68",
      "Streetname2": "Pakkeshop: 95046",
      "ZipCode": "7660",
      "CityName": "Bækmarksbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.3076",
      "Latitude": "56.4167"
    },
    {
      "Number": "95027",
      "CompanyName": "Statoil Øster Snede",
      "Streetname": "Bredalvej 1",
      "Streetname2": "Pakkeshop: 95027",
      "ZipCode": "8723",
      "CityName": "Løsning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.64664",
      "Latitude": "55.7944"
    },
    {
      "Number": "97887",
      "CompanyName": "Shell 7-Eleven Hasselager",
      "Streetname": "Hovedvejen 4",
      "Streetname2": "Pakkeshop: 97887",
      "ZipCode": "8361",
      "CityName": "Hasselager",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1102",
      "Latitude": "56.1073"
    },
    {
      "Number": "95049",
      "CompanyName": "Spar Sejerslev",
      "Streetname": "Sejersvej 26",
      "Streetname2": "Pakkeshop: 95049",
      "ZipCode": "7900",
      "CityName": "Nykøbing M",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.86651",
      "Latitude": "56.922"
    },
    {
      "Number": "97867",
      "CompanyName": "7-Eleven Nivå Station",
      "Streetname": "Niverødvej 4",
      "Streetname2": "Pakkeshop: 97867",
      "ZipCode": "2990",
      "CityName": "Nivå",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5066",
      "Latitude": "55.9333"
    },
    {
      "Number": "95052",
      "CompanyName": "Lyngby Cafe",
      "Streetname": "Buddingevej 79 B",
      "Streetname2": "Pakkeshop: 95052",
      "ZipCode": "2800",
      "CityName": "Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4949",
      "Latitude": "55.7609"
    },
    {
      "Number": "97584",
      "CompanyName": "Lokalbrugsen Vallensved",
      "Streetname": "Vallensved Bygade 25",
      "Streetname2": "Pakkeshop: 97584",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6546",
      "Latitude": "55.2647"
    },
    {
      "Number": "95048",
      "CompanyName": "Kwik Spar Esbjerg",
      "Streetname": "Darumvej 70",
      "Streetname2": "Pakkeshop: 95048",
      "ZipCode": "6700",
      "CityName": "Esbjerg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.47849",
      "Latitude": "55.4637"
    },
    {
      "Number": "95017",
      "CompanyName": "7-Eleven Kokkedal Station",
      "Streetname": "Kokkedal Stationsvej 6",
      "Streetname2": "Pakkeshop: 95017",
      "ZipCode": "2970",
      "CityName": "Hørsholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.502",
      "Latitude": "55.9035"
    },
    {
      "Number": "95044",
      "CompanyName": "Letkøb Skottegården",
      "Streetname": "Skottegården 4",
      "Streetname2": "Pakkeshop: 95044",
      "ZipCode": "2770",
      "CityName": "Kastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6349",
      "Latitude": "55.638"
    },
    {
      "Number": "95045",
      "CompanyName": "Shell Kampmannsgade",
      "Streetname": "Kampmannsgade 2",
      "Streetname2": "Pakkeshop: 95045",
      "ZipCode": "1604",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5619",
      "Latitude": "55.6778"
    },
    {
      "Number": "97576",
      "CompanyName": "Dagli´Brugsen Ørholm",
      "Streetname": "Nøjsomhedsvej 45",
      "Streetname2": "Pakkeshop: 97576",
      "ZipCode": "2800",
      "CityName": "Lyngby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5143",
      "Latitude": "55.7976"
    },
    {
      "Number": "95043",
      "CompanyName": "Miktan - gaver og brugskunst",
      "Streetname": "Jernbanegade 12",
      "Streetname2": "Pakkeshop: 95043",
      "ZipCode": "8881",
      "CityName": "Thorsø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.79299",
      "Latitude": "56.2972"
    },
    {
      "Number": "97579",
      "CompanyName": "Brugsen Ålum",
      "Streetname": "Gl. Viborgvej 381",
      "Streetname2": "Pakkeshop: 97579",
      "ZipCode": "8920",
      "CityName": "Randers NV",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.83488",
      "Latitude": "56.4536"
    },
    {
      "Number": "95035",
      "CompanyName": "Min Købmand Krogager",
      "Streetname": "Storegade 2",
      "Streetname2": "Pakkeshop: 95035",
      "ZipCode": "7200",
      "CityName": "Grindsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.84538",
      "Latitude": "55.7011"
    },
    {
      "Number": "97581",
      "CompanyName": "Lokalbrugsen Hørby",
      "Streetname": "Hjørringvej 120",
      "Streetname2": "Pakkeshop: 97581",
      "ZipCode": "9300",
      "CityName": "Sæby",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3823",
      "Latitude": "57.3229"
    },
    {
      "Number": "95050",
      "CompanyName": "Haals Bageri",
      "Streetname": "Nøvlingvej 23",
      "Streetname2": "Pakkeshop: 95050",
      "ZipCode": "9260",
      "CityName": "Gistrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.99458",
      "Latitude": "56.9976"
    },
    {
      "Number": "97582",
      "CompanyName": "Dagli´Brugsen Undløse",
      "Streetname": "Østergårdsvej 2",
      "Streetname2": "Pakkeshop: 97582",
      "ZipCode": "4340",
      "CityName": "Tølløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.585",
      "Latitude": "55.6051"
    },
    {
      "Number": "97169",
      "CompanyName": "Shell Herning",
      "Streetname": "Silkeborgvej 7",
      "Streetname2": "Pakkeshop: 97169",
      "ZipCode": "7400",
      "CityName": "Herning",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.98413",
      "Latitude": "56.1353"
    },
    {
      "Number": "97160",
      "CompanyName": "Shell Herfølge",
      "Streetname": "Vordingborgvej 125 A",
      "Streetname2": "Pakkeshop: 97160",
      "ZipCode": "4681",
      "CityName": "Herfølge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1379",
      "Latitude": "55.4132"
    },
    {
      "Number": "97282",
      "CompanyName": "OK Plus Ballerup",
      "Streetname": "Hold-An Vej 94-96",
      "Streetname2": "Pakkeshop: 97282",
      "ZipCode": "2750",
      "CityName": "Ballerup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3556",
      "Latitude": "55.7242"
    },
    {
      "Number": "97170",
      "CompanyName": "Shell Brønderslev",
      "Streetname": "Hjørringvej 3",
      "Streetname2": "Pakkeshop: 97170",
      "ZipCode": "9700",
      "CityName": "Brønderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.9693",
      "Latitude": "57.2682"
    },
    {
      "Number": "97161",
      "CompanyName": "Shell Greve Strand",
      "Streetname": "Lillevangsvej 50",
      "Streetname2": "Pakkeshop: 97161",
      "ZipCode": "2670",
      "CityName": "Greve",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3084",
      "Latitude": "55.6008"
    },
    {
      "Number": "97448",
      "CompanyName": "Statoil Harlev",
      "Streetname": "Framlev Korsvej 10",
      "Streetname2": "Pakkeshop: 97448",
      "ZipCode": "8462",
      "CityName": "Harlev j",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0062",
      "Latitude": "56.1516"
    },
    {
      "Number": "97412",
      "CompanyName": "SuperBest Hvidovre",
      "Streetname": "Hvidovre Stationscenter 13",
      "Streetname2": "Pakkeshop: 97412",
      "ZipCode": "2650",
      "CityName": "Hvidovre",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4756",
      "Latitude": "55.6638"
    },
    {
      "Number": "97797",
      "CompanyName": "Eurospar Rønnede",
      "Streetname": "Vordingborgvej 517",
      "Streetname2": "Pakkeshop: 97797",
      "ZipCode": "4683",
      "CityName": "Rønnede",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0218",
      "Latitude": "55.2592"
    },
    {
      "Number": "97553",
      "CompanyName": "SuperBrugsen Mårslet",
      "Streetname": "Hørretvej 12",
      "Streetname2": "Pakkeshop: 97553",
      "ZipCode": "8320",
      "CityName": "Mårslet",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.164",
      "Latitude": "56.0677"
    },
    {
      "Number": "97452",
      "CompanyName": "Witting Herretøj",
      "Streetname": "Østergade 20",
      "Streetname2": "Pakkeshop: 97452",
      "ZipCode": "9440",
      "CityName": "Aabybro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.73153",
      "Latitude": "57.1606"
    },
    {
      "Number": "97555",
      "CompanyName": "Dagli´Brugsen Ugerløse",
      "Streetname": "Hovedgaden 34",
      "Streetname2": "Pakkeshop: 97555",
      "ZipCode": "4350",
      "CityName": "Ugerløse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.6546",
      "Latitude": "55.5844"
    },
    {
      "Number": "97822",
      "CompanyName": "Shell Ring 4 Herlev",
      "Streetname": "Ring 4 50",
      "Streetname2": "Pakkeshop: 97822",
      "ZipCode": "2730",
      "CityName": "Herlev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4419",
      "Latitude": "55.7236"
    },
    {
      "Number": "97172",
      "CompanyName": "Shell Oksbøl",
      "Streetname": "Østergade 23",
      "Streetname2": "Pakkeshop: 97172",
      "ZipCode": "6840",
      "CityName": "Oksbøl",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.28508",
      "Latitude": "55.625"
    },
    {
      "Number": "97440",
      "CompanyName": "Vores Verden",
      "Streetname": "Blåvandsvej 28",
      "Streetname2": "Pakkeshop: 97440",
      "ZipCode": "6857",
      "CityName": "Blåvand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.13492",
      "Latitude": "55.5558"
    },
    {
      "Number": "97441",
      "CompanyName": "Statoil Vinderup",
      "Streetname": "Søndergade 51",
      "Streetname2": "Pakkeshop: 97441",
      "ZipCode": "7830",
      "CityName": "Vinderup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.77704",
      "Latitude": "56.4778"
    },
    {
      "Number": "97550",
      "CompanyName": "Dagli´Brugsen Selde",
      "Streetname": "Skivevej 7",
      "Streetname2": "Pakkeshop: 97550",
      "ZipCode": "7870",
      "CityName": "Roslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.0468",
      "Latitude": "56.7784"
    },
    {
      "Number": "97438",
      "CompanyName": "Statoil Bjerringbro",
      "Streetname": "Pilevej 18",
      "Streetname2": "Pakkeshop: 97438",
      "ZipCode": "8850",
      "CityName": "Bjerringbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.67237",
      "Latitude": "56.3797"
    },
    {
      "Number": "97796",
      "CompanyName": "EuroSpar Fakse Ladeplads",
      "Streetname": "Postvej 2",
      "Streetname2": "Pakkeshop: 97796",
      "ZipCode": "4654",
      "CityName": "Fakse Ladeplads",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1631",
      "Latitude": "55.2166"
    },
    {
      "Number": "97554",
      "CompanyName": "Dagli´Brugsen Sabro",
      "Streetname": "Vistoftvej 38",
      "Streetname2": "Pakkeshop: 97554",
      "ZipCode": "8471",
      "CityName": "Sabro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0375",
      "Latitude": "56.2122"
    },
    {
      "Number": "97566",
      "CompanyName": "Dagli´Brugsen Vivild",
      "Streetname": "Langgade 43",
      "Streetname2": "Pakkeshop: 97566",
      "ZipCode": "8961",
      "CityName": "Allingåbro",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4475",
      "Latitude": "56.4832"
    },
    {
      "Number": "97569",
      "CompanyName": "Dagli´Brugsen Gassum",
      "Streetname": "Amtsvejen 31",
      "Streetname2": "Pakkeshop: 97569",
      "ZipCode": "8981",
      "CityName": "Spentrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.99616",
      "Latitude": "56.5754"
    },
    {
      "Number": "97197",
      "CompanyName": "Anne Mette",
      "Streetname": "Metheasvej 2",
      "Streetname2": "Pakkeshop: 97197",
      "ZipCode": "6960",
      "CityName": "Hvide Sande",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.12686",
      "Latitude": "55.9993"
    },
    {
      "Number": "97571",
      "CompanyName": "SuperBrugsen Ølsted",
      "Streetname": "Byvej 6",
      "Streetname2": "Pakkeshop: 97571",
      "ZipCode": "3310",
      "CityName": "Ølsted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0724",
      "Latitude": "55.9237"
    },
    {
      "Number": "97895",
      "CompanyName": "Shell Boulevarden",
      "Streetname": "Boulevarden 28",
      "Streetname2": "Pakkeshop: 97895",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.52275",
      "Latitude": "55.7128"
    },
    {
      "Number": "97567",
      "CompanyName": "Dagli´Brugsen Arden",
      "Streetname": "Vestergade 34-35",
      "Streetname2": "Pakkeshop: 97567",
      "ZipCode": "9510",
      "CityName": "Arden",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.85472",
      "Latitude": "56.7701"
    },
    {
      "Number": "97570",
      "CompanyName": "Dagli´Brugsen Gudumholm",
      "Streetname": "Aagade 40",
      "Streetname2": "Pakkeshop: 97570",
      "ZipCode": "9280",
      "CityName": "Storvorde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1015",
      "Latitude": "56.9669"
    },
    {
      "Number": "95013",
      "CompanyName": "Shell Service Stege",
      "Streetname": "Ny Ørnebjergvej 1",
      "Streetname2": "Pakkeshop: 95013",
      "ZipCode": "4780",
      "CityName": "Stege",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.267",
      "Latitude": "54.9771"
    },
    {
      "Number": "95008",
      "CompanyName": "Spar Hasle",
      "Streetname": "Storegade 47",
      "Streetname2": "Pakkeshop: 95008",
      "ZipCode": "3790",
      "CityName": "Hasle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.7062",
      "Latitude": "55.1834"
    },
    {
      "Number": "95007",
      "CompanyName": "Hjerting Kiosken",
      "Streetname": "Bytoften 20",
      "Streetname2": "Pakkeshop: 95007",
      "ZipCode": "6710",
      "CityName": "Esbjerg V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.35802",
      "Latitude": "55.5264"
    },
    {
      "Number": "97568",
      "CompanyName": "Dagli´Brugsen Dybvad",
      "Streetname": "Markedsvej 14",
      "Streetname2": "Pakkeshop: 97568",
      "ZipCode": "9352",
      "CityName": "Dybvad",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.3567",
      "Latitude": "57.275"
    },
    {
      "Number": "95015",
      "CompanyName": "Shell Ringstedgade",
      "Streetname": "Ringstedgade 244",
      "Streetname2": "Pakkeshop: 95015",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7557",
      "Latitude": "55.2565"
    },
    {
      "Number": "95016",
      "CompanyName": "Shell Havnegade",
      "Streetname": "Havnegade 60",
      "Streetname2": "Pakkeshop: 95016",
      "ZipCode": "4700",
      "CityName": "Næstved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.7583",
      "Latitude": "55.2236"
    },
    {
      "Number": "97496",
      "CompanyName": "Shell Frederiksværk",
      "Streetname": "Hillerødvej 34",
      "Streetname2": "Pakkeshop: 97496",
      "ZipCode": "3300",
      "CityName": "Frederiksværk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0291",
      "Latitude": "55.9683"
    },
    {
      "Number": "97841",
      "CompanyName": "7-Eleven Vesterbrogade 6 E",
      "Streetname": "Vesterbrogade 6 E",
      "Streetname2": "Pakkeshop: 97841",
      "ZipCode": "1620",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5623",
      "Latitude": "55.6739"
    },
    {
      "Number": "97874",
      "CompanyName": "Shell 7-Eleven Haderslev",
      "Streetname": "Aarøsund Landevej 84",
      "Streetname2": "Pakkeshop: 97874",
      "ZipCode": "6100",
      "CityName": "Haderslev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.50314",
      "Latitude": "55.2439"
    },
    {
      "Number": "97894",
      "CompanyName": "Shell Fredericiavej",
      "Streetname": "Fredericiavej 151",
      "Streetname2": "Pakkeshop: 97894",
      "ZipCode": "7100",
      "CityName": "Vejle",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.56134",
      "Latitude": "55.6846"
    },
    {
      "Number": "97885",
      "CompanyName": "7-Eleven M.P.Bruuns Gade",
      "Streetname": "M.P.Bruuns Gade 62",
      "Streetname2": "Pakkeshop: 97885",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2036",
      "Latitude": "56.1467"
    },
    {
      "Number": "97192",
      "CompanyName": "Klarup Isenkram",
      "Streetname": "Jørgensmindevej 20",
      "Streetname2": "Pakkeshop: 97192",
      "ZipCode": "9270",
      "CityName": "Klarup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0466",
      "Latitude": "57.0183"
    },
    {
      "Number": "97882",
      "CompanyName": "7-Eleven Nørreport",
      "Streetname": "Nørreport 28 st.",
      "Streetname2": "Pakkeshop: 97882",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2116",
      "Latitude": "56.162"
    },
    {
      "Number": "95011",
      "CompanyName": "Shell St. Heddinge",
      "Streetname": "Højerupvej 2",
      "Streetname2": "Pakkeshop: 95011",
      "ZipCode": "4660",
      "CityName": "Store Heddinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3899",
      "Latitude": "55.3057"
    },
    {
      "Number": "95019",
      "CompanyName": "Hos Købmand Hylke",
      "Streetname": "Hylkevej 52",
      "Streetname2": "Pakkeshop: 95019",
      "ZipCode": "8660",
      "CityName": "Skanderborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.93469",
      "Latitude": "55.9923"
    },
    {
      "Number": "97837",
      "CompanyName": "7-Eleven v/ Vesterbrogade",
      "Streetname": "Banegårdspladsen 1",
      "Streetname2": "Pakkeshop: 97837",
      "ZipCode": "1570",
      "CityName": "København V",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5641",
      "Latitude": "55.674"
    },
    {
      "Number": "97898",
      "CompanyName": "Shell Faaborg",
      "Streetname": "Assensvej 102",
      "Streetname2": "Pakkeshop: 97898",
      "ZipCode": "5600",
      "CityName": "Faaborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.2243",
      "Latitude": "55.11"
    },
    {
      "Number": "97411",
      "CompanyName": "SuperBest Borups Allé",
      "Streetname": "Borups Alle 130",
      "Streetname2": "Pakkeshop: 97411",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5319",
      "Latitude": "55.6942"
    },
    {
      "Number": "97475",
      "CompanyName": "Shell Albertslund",
      "Streetname": "Roskildevej 18 B",
      "Streetname2": "Pakkeshop: 97475",
      "ZipCode": "2620",
      "CityName": "Albertslund",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3613",
      "Latitude": "55.6643"
    },
    {
      "Number": "97199",
      "CompanyName": "Statoil Vejlevej",
      "Streetname": "Vejlevej 137",
      "Streetname2": "Pakkeshop: 97199",
      "ZipCode": "6000",
      "CityName": "Kolding",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.45735",
      "Latitude": "55.5053"
    },
    {
      "Number": "95009",
      "CompanyName": "Kiosk 13",
      "Streetname": "Hovedgaden 13",
      "Streetname2": "Pakkeshop: 95009",
      "ZipCode": "8860",
      "CityName": "Ulstrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.79422",
      "Latitude": "56.3919"
    },
    {
      "Number": "97198",
      "CompanyName": "Vadum Installationsforretning",
      "Streetname": "Ellehammersvej 88",
      "Streetname2": "Pakkeshop: 97198",
      "ZipCode": "9430",
      "CityName": "Vadum",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.86285",
      "Latitude": "57.1217"
    },
    {
      "Number": "97860",
      "CompanyName": "7-Eleven Vallensbæk Strand",
      "Streetname": "Vallensbæk Stationstorv 64",
      "Streetname2": "Pakkeshop: 97860",
      "ZipCode": "2665",
      "CityName": "Vallensbæk Strand",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3884",
      "Latitude": "55.6232"
    },
    {
      "Number": "97862",
      "CompanyName": "7-Eleven Præstefælledvej",
      "Streetname": "Præstefælledvej 24-26",
      "Streetname2": "Pakkeshop: 97862",
      "ZipCode": "2770",
      "CityName": "Kastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5996",
      "Latitude": "55.6236"
    },
    {
      "Number": "97883",
      "CompanyName": "7-Eleven Frederiks Alle",
      "Streetname": "Frederiks Alle 125",
      "Streetname2": "Pakkeshop: 97883",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1954",
      "Latitude": "56.1472"
    },
    {
      "Number": "95056",
      "CompanyName": "Let Køb",
      "Streetname": "Jernbanevej 2",
      "Streetname2": "Pakkeshop: 95056",
      "ZipCode": "4262",
      "CityName": "Sandved",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.5187",
      "Latitude": "55.2643"
    },
    {
      "Number": "97843",
      "CompanyName": "7-Eleven Falkoner Alle 86",
      "Streetname": "Falkoner Alle 86",
      "Streetname2": "Pakkeshop: 97843",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5387",
      "Latitude": "55.6852"
    },
    {
      "Number": "97287",
      "CompanyName": "OK Plus Trustrup",
      "Streetname": "Århusvej 192",
      "Streetname2": "Pakkeshop: 97287",
      "ZipCode": "8570",
      "CityName": "Trustrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.7801",
      "Latitude": "56.3511"
    },
    {
      "Number": "97288",
      "CompanyName": "OK Plus Skærød",
      "Streetname": "Industrivej 1",
      "Streetname2": "Pakkeshop: 97288",
      "ZipCode": "3200",
      "CityName": "Helsinge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1654",
      "Latitude": "56.0173"
    },
    {
      "Number": "95018",
      "CompanyName": "7-Eleven Helsingør Station",
      "Streetname": "Stationspladsen 2",
      "Streetname2": "Pakkeshop: 95018",
      "ZipCode": "3000",
      "CityName": "Helsingør",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6145",
      "Latitude": "56.0336"
    },
    {
      "Number": "95081",
      "CompanyName": "Shell Ikast",
      "Streetname": "Østergade 50-52",
      "Streetname2": "Pakkeshop: 95081",
      "ZipCode": "7430",
      "CityName": "Ikast",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.1623201",
      "Latitude": "56.1398087"
    },
    {
      "Number": "95058",
      "CompanyName": "7-Eleven Gl. Kongevej",
      "Streetname": "Gammel Kongevej 111",
      "Streetname2": "Pakkeshop: 95058",
      "ZipCode": "1850",
      "CityName": "Frederiksberg C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5453",
      "Latitude": "55.6754"
    },
    {
      "Number": "95061",
      "CompanyName": "Sportigan",
      "Streetname": "Ny Boder 8",
      "Streetname2": "Pakkeshop: 95061",
      "ZipCode": "7080",
      "CityName": "Børkop",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.65016",
      "Latitude": "55.6414"
    },
    {
      "Number": "95067",
      "CompanyName": "XL Byg",
      "Streetname": "Nørregade 31",
      "Streetname2": "Pakkeshop: 95067",
      "ZipCode": "4534",
      "CityName": "Hørve",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.454",
      "Latitude": "55.7563"
    },
    {
      "Number": "95087",
      "CompanyName": "Shell Barde",
      "Streetname": "Herningvej 41",
      "Streetname2": "Pakkeshop: 95087",
      "ZipCode": "6920",
      "CityName": "Videbæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.70321",
      "Latitude": "56.1007"
    },
    {
      "Number": "95079",
      "CompanyName": "Uno-X",
      "Streetname": "Sct Klemensgade 3",
      "Streetname2": "Pakkeshop: 95079",
      "ZipCode": "3782",
      "CityName": "Klemensker",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "14.8068",
      "Latitude": "55.1755"
    },
    {
      "Number": "95099",
      "CompanyName": "Hedensted Kiosk",
      "Streetname": "Østerbrogade 32",
      "Streetname2": "Pakkeshop: 95099",
      "ZipCode": "8722",
      "CityName": "Hedensted",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.70352",
      "Latitude": "55.7714"
    },
    {
      "Number": "95097",
      "CompanyName": "7-Eleven Vesterbro Torv",
      "Streetname": "Vesterbro Torv 9",
      "Streetname2": "Pakkeshop: 95097",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1986",
      "Latitude": "56.1583"
    },
    {
      "Number": "97292",
      "CompanyName": "OK Plus Bording",
      "Streetname": "Søndergade 51",
      "Streetname2": "Pakkeshop: 97292",
      "ZipCode": "7441",
      "CityName": "Bording",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.2742",
      "Latitude": "56.1411"
    },
    {
      "Number": "97291",
      "CompanyName": "OK Plus Lisbjerg",
      "Streetname": "Randersvej 346",
      "Streetname2": "Pakkeshop: 97291",
      "ZipCode": "8200",
      "CityName": "Århus N",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.167",
      "Latitude": "56.2188"
    },
    {
      "Number": "95088",
      "CompanyName": "Spar Horbelev",
      "Streetname": "Grønsundsvej 353",
      "Streetname2": "Pakkeshop: 95088",
      "ZipCode": "4871",
      "CityName": "Horbelev",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.0554",
      "Latitude": "54.8236"
    },
    {
      "Number": "95094",
      "CompanyName": "Shell Deli2Go",
      "Streetname": "Usserød Kongevej 79",
      "Streetname2": "Pakkeshop: 95094",
      "ZipCode": "2970",
      "CityName": "Hørsholm",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4962",
      "Latitude": "55.8895"
    },
    {
      "Number": "95103",
      "CompanyName": "Specialiteten.dk",
      "Streetname": "Humlebæk Strandvej 52",
      "Streetname2": "Pakkeshop: 95103",
      "ZipCode": "3050",
      "CityName": "Humlebæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5346",
      "Latitude": "55.9625"
    },
    {
      "Number": "95069",
      "CompanyName": "Kiosk Stoppestedet",
      "Streetname": "Horsensvej 6",
      "Streetname2": "Pakkeshop: 95069",
      "ZipCode": "8732",
      "CityName": "Hovedgård",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.96183",
      "Latitude": "55.9466"
    },
    {
      "Number": "95076",
      "CompanyName": "Rosen & Kilden",
      "Streetname": "Præstøvej 69",
      "Streetname2": "Pakkeshop: 95076",
      "ZipCode": "4640",
      "CityName": "Fakse",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1066",
      "Latitude": "55.2478"
    },
    {
      "Number": "97591",
      "CompanyName": "Lokalbrugsen Bårse",
      "Streetname": "Næstvedvej 50",
      "Streetname2": "Pakkeshop: 97591",
      "ZipCode": "4720",
      "CityName": "Præstø",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.9514",
      "Latitude": "55.1255"
    },
    {
      "Number": "95080",
      "CompanyName": "Statoil Juelsminde",
      "Streetname": "Odelsgade 57",
      "Streetname2": "Pakkeshop: 95080",
      "ZipCode": "7130",
      "CityName": "Juelsminde",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.0037",
      "Latitude": "55.7157"
    },
    {
      "Number": "95083",
      "CompanyName": "Q8 Tirstrup",
      "Streetname": "Århusvej 42",
      "Streetname2": "Pakkeshop: 95083",
      "ZipCode": "8400",
      "CityName": "Ebeltoft",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6866",
      "Latitude": "56.3013"
    },
    {
      "Number": "97589",
      "CompanyName": "Superbrugsen Svinninge",
      "Streetname": "Hovedgaden 46",
      "Streetname2": "Pakkeshop: 97589",
      "ZipCode": "4520",
      "CityName": "Svinninge",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.4611",
      "Latitude": "55.7221"
    },
    {
      "Number": "95082",
      "CompanyName": "Shell Østergade",
      "Streetname": "Østergade 17",
      "Streetname2": "Pakkeshop: 95082",
      "ZipCode": "8600",
      "CityName": "Silkeborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "9.55349",
      "Latitude": "56.1707"
    },
    {
      "Number": "97590",
      "CompanyName": "Dagli´Brugsen Kalvehave",
      "Streetname": "Kalvehave Havnevej 41",
      "Streetname2": "Pakkeshop: 97590",
      "ZipCode": "4771",
      "CityName": "Kalvehave",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.1659803",
      "Latitude": "54.99617"
    },
    {
      "Number": "97592",
      "CompanyName": "Tved Brugsforening",
      "Streetname": "Tved Bygade 48",
      "Streetname2": "Pakkeshop: 97592",
      "ZipCode": "8420",
      "CityName": "Knebel",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.4339",
      "Latitude": "56.1972"
    },
    {
      "Number": "95093",
      "CompanyName": "Let Køb",
      "Streetname": "Sønderborggade 9",
      "Streetname2": "Pakkeshop: 95093",
      "ZipCode": "8000",
      "CityName": "Århus C",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1815",
      "Latitude": "56.1408"
    },
    {
      "Number": "97593",
      "CompanyName": "Dagli´Brugsen Harridslev",
      "Streetname": "Udbyhøjvej 330",
      "Streetname2": "Pakkeshop: 97593",
      "ZipCode": "8930",
      "CityName": "Randers NØ",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1279",
      "Latitude": "56.5009"
    },
    {
      "Number": "95084",
      "CompanyName": "Statoil Kuldyssen",
      "Streetname": "Kuldyssen 2",
      "Streetname2": "Pakkeshop: 95084",
      "ZipCode": "2630",
      "CityName": "Taastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.288",
      "Latitude": "55.6469"
    },
    {
      "Number": "95091",
      "CompanyName": "Eurospar Svendborg",
      "Streetname": "Wandallsvej 10",
      "Streetname2": "Pakkeshop: 95091",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5822",
      "Latitude": "55.0489"
    },
    {
      "Number": "95092",
      "CompanyName": "Eurospar Tved",
      "Streetname": "Tvedvej 210",
      "Streetname2": "Pakkeshop: 95092",
      "ZipCode": "5700",
      "CityName": "Svendborg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.6221",
      "Latitude": "55.0865"
    },
    {
      "Number": "95096",
      "CompanyName": "Shell Gandrup",
      "Streetname": "Aalborgvej 356",
      "Streetname2": "Pakkeshop: 95096",
      "ZipCode": "9362",
      "CityName": "Gandrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.1743",
      "Latitude": "57.0545"
    },
    {
      "Number": "97595",
      "CompanyName": "Superbrugsen Jyderup",
      "Streetname": "Nyvej 7",
      "Streetname2": "Pakkeshop: 97595",
      "ZipCode": "4450",
      "CityName": "Jyderup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "11.3966",
      "Latitude": "55.6596"
    },
    {
      "Number": "95089",
      "CompanyName": "Shell Kjærgårdsholm",
      "Streetname": "Landevejen 54",
      "Streetname2": "Pakkeshop: 95089",
      "ZipCode": "7860",
      "CityName": "Spøttrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.86899",
      "Latitude": "56.5694"
    },
    {
      "Number": "95090",
      "CompanyName": "Shell Kibæk",
      "Streetname": "Østergade 38",
      "Streetname2": "Pakkeshop: 95090",
      "ZipCode": "6933",
      "CityName": "Kibæk",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "8.85895",
      "Latitude": "56.0312"
    },
    {
      "Number": "95101",
      "CompanyName": "Købmanden Nr 1",
      "Streetname": "Kastruplundgade 24 B",
      "Streetname2": "Pakkeshop: 95101",
      "ZipCode": "2770",
      "CityName": "Kastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.6416597",
      "Latitude": "55.6367111"
    },
    {
      "Number": "95109",
      "CompanyName": "7-Eleven",
      "Streetname": "Borups Alle 116",
      "Streetname2": "Pakkeshop: 95109",
      "ZipCode": "2000",
      "CityName": "Frederiksberg",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.5333",
      "Latitude": "55.6937"
    },
    {
      "Number": "95060",
      "CompanyName": "Spar Glostrup",
      "Streetname": "Dalvangsvej 52",
      "Streetname2": "Pakkeshop: 95060",
      "ZipCode": "2600",
      "CityName": "Glostrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.4115",
      "Latitude": "55.6696"
    },
    {
      "Number": "95078",
      "CompanyName": "7-Eleven Frederiksberggade",
      "Streetname": "Frederiksberggade 2",
      "Streetname2": "Pakkeshop: 95078",
      "ZipCode": "1459",
      "CityName": "København K",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.572",
      "Latitude": "55.6778"
    },
    {
      "Number": "95085",
      "CompanyName": "Shell Langeskov",
      "Streetname": "Odensevej 35",
      "Streetname2": "Pakkeshop: 95085",
      "ZipCode": "5550",
      "CityName": "Langeskov",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "10.5848",
      "Latitude": "55.3639"
    },
    {
      "Number": "95064",
      "CompanyName": "Shell",
      "Streetname": "Taastrup Hovedgade 25",
      "Streetname2": "Pakkeshop: 95064",
      "ZipCode": "2630",
      "CityName": "Taastrup",
      "CountryCode": "008",
      "CountryCodeISO3166A2": "DK",
      "Telephone": "-",
      "Longitude": "12.3074",
      "Latitude": "55.6561"
    }
  ]
};